
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1189"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1189"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8EJWz", function(module, exports) {

$parcel$export(module.exports, "generateMathQuestion", () => generateMathQuestion);
//Psuedo Code
/*
- Math questions array [{mathQPropertiess}]
- Check difficulty level (sets max number - ex: 'hard = 500)
- Generate number 1, generate number 2, generate operator (+/-)
- If addition (order does not matter)
- If subtraction (largest first)
- Generate answer, with 3 close but incorrect (+10, +1, -2)
- Put info into question obj, push to MathQuestion Array. 
- Loop 3x


- User clicks "check answers"
- Compile answers from selection (each own radio button?) w/ data-identifier.
- Sends to controller to handleAnswerSubmission or check locally in view?
- Checks against mathQuestionsArray. 
- Determine # correct. 
- If less than all (3) correct, update view messaging, add correct/error classes for visual. 
- If all correct, update view messaging, show play-again UI. Update player stats, update local storage. 
- If click "play again?" Regenerate new math questions, update view UI. 

*/ function generateMathQuestion(userObj) {
    //Check difficulty and set parameters
    //Loop 3 times (for loop / do..while)
    // Generate operand (+/-)
    // Generate number 1
    // Generate number 2
    // If addition: set numbers to object
    // If subtraction: set bigger number to obj1 and other to obj2
    // Set answer in obj & push to choices array
    // If chocies array.length < 4 -> generate other choice and push to array
    // Easy -> Max = 20. Second number max -> Max - first number
    // Medium -> max = 99. Second number max -> max - first number
    // Hard -> max = 999. Second number max -> max - first number
    const mathQuestions = {
        q1: {},
        q2: {},
        q3: {}
    };
    let maxNumber;
    switch(userObj.difficulty){
        case "easy":
            maxNumber = 20;
            break;
        case "normal":
            maxNumber = 99;
            break;
        case "hard":
            maxNumber = 999;
            break;
        default:
            maxNumber = 99;
    }
    let questionNumber = 1;
    do {
        const qReference = mathQuestions[`q${questionNumber}`];
        const operand = [
            "+",
            "-"
        ][Math.round(Math.random())];
        const numberOne = Math.floor(Math.random() * maxNumber);
        const numberTwo = Math.floor(Math.random() * (maxNumber - numberOne));
        const choices = [];
        qReference.qnumber = questionNumber;
        qReference.operand = operand;
        if (operand == "+") {
            qReference.top = numberOne;
            qReference.bottom = numberTwo;
            qReference.answer = eval(`${numberOne} + ${numberTwo}`);
            choices.push(qReference.answer);
        }
        if (operand == "-") {
            qReference.top = Math.max(numberOne, numberTwo);
            qReference.bottom = Math.min(numberOne, numberTwo);
            qReference.answer = eval(`${qReference.top} - ${qReference.bottom}`);
            choices.push(qReference.answer);
        }
        for(let i = 0; i < 3; i++){
            const operation = [
                "+",
                "-"
            ][Math.round(Math.random())];
            const numDif = Math.ceil(Math.random() * 9);
            let choice = eval(`${qReference.answer} ${operation} ${numDif}`);
            choice < 0 && (choice *= -1);
            choices.push(choice);
        }
        qReference.choices = choices.sort(); //Converting to strings?
        questionNumber++;
    }while (questionNumber <= 3);
    return mathQuestions;
}

});

"use strict";
var $ef322a7f89c3ed41$exports = {};
"use strict";
var $6140c9fa18232846$exports = {};
"use strict";
$6140c9fa18232846$exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};


// Detect IE8's incomplete defineProperty implementation
$ef322a7f89c3ed41$exports = !$6140c9fa18232846$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] !== 7;
});


var $fcd977913fa5bb2d$exports = {};
"use strict";
var $842f8f0a18746212$exports = {};
"use strict";
var $3fbf1185731afe2b$exports = {};
"use strict";
var $3fbf1185731afe2b$var$check = function(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
$3fbf1185731afe2b$exports = // eslint-disable-next-line es/no-global-this -- safe
$3fbf1185731afe2b$var$check(typeof globalThis == "object" && globalThis) || $3fbf1185731afe2b$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$3fbf1185731afe2b$var$check(typeof self == "object" && self) || $3fbf1185731afe2b$var$check(typeof $parcel$global == "object" && $parcel$global) || $3fbf1185731afe2b$var$check(typeof $3fbf1185731afe2b$exports == "object" && $3fbf1185731afe2b$exports) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function("return this")();


var $1946b9b54b48e7fd$exports = {};
"use strict";
var $d00d03e557d638db$exports = {};
"use strict";
var $e0409817d4e03fc4$exports = {};
"use strict";
$e0409817d4e03fc4$exports = false;



var $4ce407c7007beb63$exports = {};
"use strict";

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $4ce407c7007beb63$var$defineProperty = Object.defineProperty;
$4ce407c7007beb63$exports = function(key, value) {
    try {
        $4ce407c7007beb63$var$defineProperty($3fbf1185731afe2b$exports, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $3fbf1185731afe2b$exports[key] = value;
    }
    return value;
};


var $d00d03e557d638db$var$SHARED = "__core-js_shared__";
var $d00d03e557d638db$var$store = $d00d03e557d638db$exports = $3fbf1185731afe2b$exports[$d00d03e557d638db$var$SHARED] || $4ce407c7007beb63$exports($d00d03e557d638db$var$SHARED, {});
($d00d03e557d638db$var$store.versions || ($d00d03e557d638db$var$store.versions = [])).push({
    version: "3.38.1",
    mode: $e0409817d4e03fc4$exports ? "pure" : "global",
    copyright: "\xa9 2014-2024 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.38.1/LICENSE",
    source: "https://github.com/zloirock/core-js"
});


$1946b9b54b48e7fd$exports = function(key, value) {
    return $d00d03e557d638db$exports[key] || ($d00d03e557d638db$exports[key] = value || {});
};


var $1f868a26fd901990$exports = {};
"use strict";
var $43b18aa2f1faac44$exports = {};
"use strict";
var $bcbe62e89adc7d37$exports = {};
"use strict";

$bcbe62e89adc7d37$exports = !$6140c9fa18232846$exports(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});


var $43b18aa2f1faac44$var$FunctionPrototype = Function.prototype;
var $43b18aa2f1faac44$var$call = $43b18aa2f1faac44$var$FunctionPrototype.call;
var $43b18aa2f1faac44$var$uncurryThisWithBind = $bcbe62e89adc7d37$exports && $43b18aa2f1faac44$var$FunctionPrototype.bind.bind($43b18aa2f1faac44$var$call, $43b18aa2f1faac44$var$call);
$43b18aa2f1faac44$exports = $bcbe62e89adc7d37$exports ? $43b18aa2f1faac44$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $43b18aa2f1faac44$var$call.apply(fn, arguments);
    };
};


var $a2f3ebb5da11db12$exports = {};
"use strict";
var $c378177673193450$exports = {};
"use strict";
var $7ce250ddf7b42d4d$exports = {};
"use strict";
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
$7ce250ddf7b42d4d$exports = function(it) {
    return it === null || it === undefined;
};


var $c378177673193450$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
$c378177673193450$exports = function(it) {
    if ($7ce250ddf7b42d4d$exports(it)) throw new $c378177673193450$var$$TypeError("Can't call method on " + it);
    return it;
};


var $a2f3ebb5da11db12$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
$a2f3ebb5da11db12$exports = function(argument) {
    return $a2f3ebb5da11db12$var$$Object($c378177673193450$exports(argument));
};


var $1f868a26fd901990$var$hasOwnProperty = $43b18aa2f1faac44$exports({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
$1f868a26fd901990$exports = Object.hasOwn || function hasOwn(it, key) {
    return $1f868a26fd901990$var$hasOwnProperty($a2f3ebb5da11db12$exports(it), key);
};


var $5e0a1e292f79defc$exports = {};
"use strict";

var $5e0a1e292f79defc$var$id = 0;
var $5e0a1e292f79defc$var$postfix = Math.random();
var $5e0a1e292f79defc$var$toString = $43b18aa2f1faac44$exports(1.0.toString);
$5e0a1e292f79defc$exports = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $5e0a1e292f79defc$var$toString(++$5e0a1e292f79defc$var$id + $5e0a1e292f79defc$var$postfix, 36);
};


var $4a39565fee8fe980$exports = {};
"use strict";
var $b2a56c1a090208a5$exports = {};
"use strict";

var $34fa2a1382dc63c1$exports = {};
"use strict";

var $34fa2a1382dc63c1$var$navigator = $3fbf1185731afe2b$exports.navigator;
var $34fa2a1382dc63c1$var$userAgent = $34fa2a1382dc63c1$var$navigator && $34fa2a1382dc63c1$var$navigator.userAgent;
$34fa2a1382dc63c1$exports = $34fa2a1382dc63c1$var$userAgent ? String($34fa2a1382dc63c1$var$userAgent) : "";


var $b2a56c1a090208a5$var$process = $3fbf1185731afe2b$exports.process;
var $b2a56c1a090208a5$var$Deno = $3fbf1185731afe2b$exports.Deno;
var $b2a56c1a090208a5$var$versions = $b2a56c1a090208a5$var$process && $b2a56c1a090208a5$var$process.versions || $b2a56c1a090208a5$var$Deno && $b2a56c1a090208a5$var$Deno.version;
var $b2a56c1a090208a5$var$v8 = $b2a56c1a090208a5$var$versions && $b2a56c1a090208a5$var$versions.v8;
var $b2a56c1a090208a5$var$match, $b2a56c1a090208a5$var$version;
if ($b2a56c1a090208a5$var$v8) {
    $b2a56c1a090208a5$var$match = $b2a56c1a090208a5$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $b2a56c1a090208a5$var$version = $b2a56c1a090208a5$var$match[0] > 0 && $b2a56c1a090208a5$var$match[0] < 4 ? 1 : +($b2a56c1a090208a5$var$match[0] + $b2a56c1a090208a5$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$b2a56c1a090208a5$var$version && $34fa2a1382dc63c1$exports) {
    $b2a56c1a090208a5$var$match = $34fa2a1382dc63c1$exports.match(/Edge\/(\d+)/);
    if (!$b2a56c1a090208a5$var$match || $b2a56c1a090208a5$var$match[1] >= 74) {
        $b2a56c1a090208a5$var$match = $34fa2a1382dc63c1$exports.match(/Chrome\/(\d+)/);
        if ($b2a56c1a090208a5$var$match) $b2a56c1a090208a5$var$version = +$b2a56c1a090208a5$var$match[1];
    }
}
$b2a56c1a090208a5$exports = $b2a56c1a090208a5$var$version;




var $4a39565fee8fe980$var$$String = $3fbf1185731afe2b$exports.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
$4a39565fee8fe980$exports = !!Object.getOwnPropertySymbols && !$6140c9fa18232846$exports(function() {
    var symbol = Symbol("symbol detection");
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$4a39565fee8fe980$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $b2a56c1a090208a5$exports && $b2a56c1a090208a5$exports < 41;
});


var $47f18b427c2fbabf$exports = {};
"use strict";

$47f18b427c2fbabf$exports = $4a39565fee8fe980$exports && !Symbol.sham && typeof Symbol.iterator == "symbol";


var $842f8f0a18746212$var$Symbol = $3fbf1185731afe2b$exports.Symbol;
var $842f8f0a18746212$var$WellKnownSymbolsStore = $1946b9b54b48e7fd$exports("wks");
var $842f8f0a18746212$var$createWellKnownSymbol = $47f18b427c2fbabf$exports ? $842f8f0a18746212$var$Symbol["for"] || $842f8f0a18746212$var$Symbol : $842f8f0a18746212$var$Symbol && $842f8f0a18746212$var$Symbol.withoutSetter || $5e0a1e292f79defc$exports;
$842f8f0a18746212$exports = function(name) {
    if (!$1f868a26fd901990$exports($842f8f0a18746212$var$WellKnownSymbolsStore, name)) $842f8f0a18746212$var$WellKnownSymbolsStore[name] = $4a39565fee8fe980$exports && $1f868a26fd901990$exports($842f8f0a18746212$var$Symbol, name) ? $842f8f0a18746212$var$Symbol[name] : $842f8f0a18746212$var$createWellKnownSymbol("Symbol." + name);
    return $842f8f0a18746212$var$WellKnownSymbolsStore[name];
};


var $5c0346dde328cc4c$exports = {};
"use strict";
var $c845d421b7b0e630$exports = {};
"use strict";
var $6a130d390db46c8e$exports = {};
"use strict";
var $70e34a5a2021f756$exports = {};
"use strict";
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var $70e34a5a2021f756$var$documentAll = typeof document == "object" && document.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
$70e34a5a2021f756$exports = typeof $70e34a5a2021f756$var$documentAll == "undefined" && $70e34a5a2021f756$var$documentAll !== undefined ? function(argument) {
    return typeof argument == "function" || argument === $70e34a5a2021f756$var$documentAll;
} : function(argument) {
    return typeof argument == "function";
};


$6a130d390db46c8e$exports = function(it) {
    return typeof it == "object" ? it !== null : $70e34a5a2021f756$exports(it);
};


var $c845d421b7b0e630$var$$String = String;
var $c845d421b7b0e630$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
$c845d421b7b0e630$exports = function(argument) {
    if ($6a130d390db46c8e$exports(argument)) return argument;
    throw new $c845d421b7b0e630$var$$TypeError($c845d421b7b0e630$var$$String(argument) + " is not an object");
};


// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var $4c5dc42699fd98c2$export$2d1720544b23b823;
"use strict";

var $161a89d67c436ccf$exports = {};
"use strict";


// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
$161a89d67c436ccf$exports = $ef322a7f89c3ed41$exports && $6140c9fa18232846$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype !== 42;
});


// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $2d0ac3aa5e39584b$export$2d1720544b23b823;
"use strict";

var $d45526d8245cb22c$exports = {};
"use strict";


var $15c0c414b89100b1$exports = {};
"use strict";


var $15c0c414b89100b1$var$document = $3fbf1185731afe2b$exports.document;
// typeof document.createElement is 'object' in old IE
var $15c0c414b89100b1$var$EXISTS = $6a130d390db46c8e$exports($15c0c414b89100b1$var$document) && $6a130d390db46c8e$exports($15c0c414b89100b1$var$document.createElement);
$15c0c414b89100b1$exports = function(it) {
    return $15c0c414b89100b1$var$EXISTS ? $15c0c414b89100b1$var$document.createElement(it) : {};
};


// Thanks to IE8 for its funny defineProperty
$d45526d8245cb22c$exports = !$ef322a7f89c3ed41$exports && !$6140c9fa18232846$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($15c0c414b89100b1$exports("div"), "a", {
        get: function() {
            return 7;
        }
    }).a !== 7;
});




var $7f19acfe53927f5c$exports = {};
"use strict";
var $8ffb6b36a733d3c0$exports = {};
"use strict";
var $881ad37dbe259e8f$exports = {};
"use strict";

var $881ad37dbe259e8f$var$call = Function.prototype.call;
$881ad37dbe259e8f$exports = $bcbe62e89adc7d37$exports ? $881ad37dbe259e8f$var$call.bind($881ad37dbe259e8f$var$call) : function() {
    return $881ad37dbe259e8f$var$call.apply($881ad37dbe259e8f$var$call, arguments);
};



var $0b429cc7792c7d26$exports = {};
"use strict";
var $a5217dbd1b0d33ce$exports = {};
"use strict";


var $a5217dbd1b0d33ce$var$aFunction = function(argument) {
    return $70e34a5a2021f756$exports(argument) ? argument : undefined;
};
$a5217dbd1b0d33ce$exports = function(namespace, method) {
    return arguments.length < 2 ? $a5217dbd1b0d33ce$var$aFunction($3fbf1185731afe2b$exports[namespace]) : $3fbf1185731afe2b$exports[namespace] && $3fbf1185731afe2b$exports[namespace][method];
};



var $41cc576e850a251e$exports = {};
"use strict";

$41cc576e850a251e$exports = $43b18aa2f1faac44$exports({}.isPrototypeOf);



var $0b429cc7792c7d26$var$$Object = Object;
$0b429cc7792c7d26$exports = $47f18b427c2fbabf$exports ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    var $Symbol = $a5217dbd1b0d33ce$exports("Symbol");
    return $70e34a5a2021f756$exports($Symbol) && $41cc576e850a251e$exports($Symbol.prototype, $0b429cc7792c7d26$var$$Object(it));
};


var $eb80dcd0b8a5698c$exports = {};
"use strict";
var $ae485921c5498156$exports = {};
"use strict";

var $8f0ebae34f61e14c$exports = {};
"use strict";
var $8f0ebae34f61e14c$var$$String = String;
$8f0ebae34f61e14c$exports = function(argument) {
    try {
        return $8f0ebae34f61e14c$var$$String(argument);
    } catch (error) {
        return "Object";
    }
};


var $ae485921c5498156$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
$ae485921c5498156$exports = function(argument) {
    if ($70e34a5a2021f756$exports(argument)) return argument;
    throw new $ae485921c5498156$var$$TypeError($8f0ebae34f61e14c$exports(argument) + " is not a function");
};



// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
$eb80dcd0b8a5698c$exports = function(V, P) {
    var func = V[P];
    return $7ce250ddf7b42d4d$exports(func) ? undefined : $ae485921c5498156$exports(func);
};


var $b0f812e443807cb5$exports = {};
"use strict";



var $b0f812e443807cb5$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
$b0f812e443807cb5$exports = function(input, pref) {
    var fn, val;
    if (pref === "string" && $70e34a5a2021f756$exports(fn = input.toString) && !$6a130d390db46c8e$exports(val = $881ad37dbe259e8f$exports(fn, input))) return val;
    if ($70e34a5a2021f756$exports(fn = input.valueOf) && !$6a130d390db46c8e$exports(val = $881ad37dbe259e8f$exports(fn, input))) return val;
    if (pref !== "string" && $70e34a5a2021f756$exports(fn = input.toString) && !$6a130d390db46c8e$exports(val = $881ad37dbe259e8f$exports(fn, input))) return val;
    throw new $b0f812e443807cb5$var$$TypeError("Can't convert object to primitive value");
};



var $8ffb6b36a733d3c0$var$$TypeError = TypeError;
var $8ffb6b36a733d3c0$var$TO_PRIMITIVE = $842f8f0a18746212$exports("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
$8ffb6b36a733d3c0$exports = function(input, pref) {
    if (!$6a130d390db46c8e$exports(input) || $0b429cc7792c7d26$exports(input)) return input;
    var exoticToPrim = $eb80dcd0b8a5698c$exports(input, $8ffb6b36a733d3c0$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $881ad37dbe259e8f$exports(exoticToPrim, input, pref);
        if (!$6a130d390db46c8e$exports(result) || $0b429cc7792c7d26$exports(result)) return result;
        throw new $8ffb6b36a733d3c0$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $b0f812e443807cb5$exports(input, pref);
};



// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
$7f19acfe53927f5c$exports = function(argument) {
    var key = $8ffb6b36a733d3c0$exports(argument, "string");
    return $0b429cc7792c7d26$exports(key) ? key : key + "";
};


var $2d0ac3aa5e39584b$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $2d0ac3aa5e39584b$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $2d0ac3aa5e39584b$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $2d0ac3aa5e39584b$var$ENUMERABLE = "enumerable";
var $2d0ac3aa5e39584b$var$CONFIGURABLE = "configurable";
var $2d0ac3aa5e39584b$var$WRITABLE = "writable";
$2d0ac3aa5e39584b$export$2d1720544b23b823 = $ef322a7f89c3ed41$exports ? $161a89d67c436ccf$exports ? function defineProperty(O, P, Attributes) {
    $c845d421b7b0e630$exports(O);
    P = $7f19acfe53927f5c$exports(P);
    $c845d421b7b0e630$exports(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && $2d0ac3aa5e39584b$var$WRITABLE in Attributes && !Attributes[$2d0ac3aa5e39584b$var$WRITABLE]) {
        var current = $2d0ac3aa5e39584b$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$2d0ac3aa5e39584b$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $2d0ac3aa5e39584b$var$CONFIGURABLE in Attributes ? Attributes[$2d0ac3aa5e39584b$var$CONFIGURABLE] : current[$2d0ac3aa5e39584b$var$CONFIGURABLE],
                enumerable: $2d0ac3aa5e39584b$var$ENUMERABLE in Attributes ? Attributes[$2d0ac3aa5e39584b$var$ENUMERABLE] : current[$2d0ac3aa5e39584b$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $2d0ac3aa5e39584b$var$$defineProperty(O, P, Attributes);
} : $2d0ac3aa5e39584b$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $c845d421b7b0e630$exports(O);
    P = $7f19acfe53927f5c$exports(P);
    $c845d421b7b0e630$exports(Attributes);
    if ($d45526d8245cb22c$exports) try {
        return $2d0ac3aa5e39584b$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw new $2d0ac3aa5e39584b$var$$TypeError("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};



var $4d273c9d7e1bdf46$exports = {};
"use strict";
var $8239f4c7c6082668$exports = {};
"use strict";


var $b0ba63bfbfb16088$exports = {};
"use strict";

var $b0ba63bfbfb16088$var$toString = $43b18aa2f1faac44$exports({}.toString);
var $b0ba63bfbfb16088$var$stringSlice = $43b18aa2f1faac44$exports("".slice);
$b0ba63bfbfb16088$exports = function(it) {
    return $b0ba63bfbfb16088$var$stringSlice($b0ba63bfbfb16088$var$toString(it), 8, -1);
};


var $8239f4c7c6082668$var$$Object = Object;
var $8239f4c7c6082668$var$split = $43b18aa2f1faac44$exports("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
$8239f4c7c6082668$exports = $6140c9fa18232846$exports(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$8239f4c7c6082668$var$$Object("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $b0ba63bfbfb16088$exports(it) === "String" ? $8239f4c7c6082668$var$split(it, "") : $8239f4c7c6082668$var$$Object(it);
} : $8239f4c7c6082668$var$$Object;



$4d273c9d7e1bdf46$exports = function(it) {
    return $8239f4c7c6082668$exports($c378177673193450$exports(it));
};


var $b74a8f96578f4948$exports = {};
"use strict";
var $c4fba4611365c4f5$exports = {};
"use strict";



var $f00609c516640f24$exports = {};
"use strict";

var $1ef9432c43157f41$exports = {};
"use strict";
var $b5bb21648546ce5b$exports = {};
"use strict";
var $5395b5a4913a5e32$exports = {};
"use strict";
var $5395b5a4913a5e32$var$ceil = Math.ceil;
var $5395b5a4913a5e32$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
$5395b5a4913a5e32$exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $5395b5a4913a5e32$var$floor : $5395b5a4913a5e32$var$ceil)(n);
};


// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
$b5bb21648546ce5b$exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $5395b5a4913a5e32$exports(number);
};


var $1ef9432c43157f41$var$max = Math.max;
var $1ef9432c43157f41$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
$1ef9432c43157f41$exports = function(index, length) {
    var integer = $b5bb21648546ce5b$exports(index);
    return integer < 0 ? $1ef9432c43157f41$var$max(integer + length, 0) : $1ef9432c43157f41$var$min(integer, length);
};


var $04c91bd3815cd64a$exports = {};
"use strict";
var $4aba983aae3daed3$exports = {};
"use strict";

var $4aba983aae3daed3$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
$4aba983aae3daed3$exports = function(argument) {
    var len = $b5bb21648546ce5b$exports(argument);
    return len > 0 ? $4aba983aae3daed3$var$min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
$04c91bd3815cd64a$exports = function(obj) {
    return $4aba983aae3daed3$exports(obj.length);
};


// `Array.prototype.{ indexOf, includes }` methods implementation
var $f00609c516640f24$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $4d273c9d7e1bdf46$exports($this);
        var length = $04c91bd3815cd64a$exports(O);
        if (length === 0) return !IS_INCLUDES && -1;
        var index = $1ef9432c43157f41$exports(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
$f00609c516640f24$exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $f00609c516640f24$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $f00609c516640f24$var$createMethod(false)
};


var $c4fba4611365c4f5$require$indexOf = $f00609c516640f24$exports.indexOf;
var $9f571a3f3d135e31$exports = {};
"use strict";
$9f571a3f3d135e31$exports = {};


var $c4fba4611365c4f5$var$push = $43b18aa2f1faac44$exports([].push);
$c4fba4611365c4f5$exports = function(object, names) {
    var O = $4d273c9d7e1bdf46$exports(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$1f868a26fd901990$exports($9f571a3f3d135e31$exports, key) && $1f868a26fd901990$exports(O, key) && $c4fba4611365c4f5$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($1f868a26fd901990$exports(O, key = names[i++])) ~$c4fba4611365c4f5$require$indexOf(result, key) || $c4fba4611365c4f5$var$push(result, key);
    return result;
};


var $e73f13f1d8a17cad$exports = {};
"use strict";
// IE8- don't enum bug keys
$e73f13f1d8a17cad$exports = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];


// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
$b74a8f96578f4948$exports = Object.keys || function keys(O) {
    return $c4fba4611365c4f5$exports(O, $e73f13f1d8a17cad$exports);
};


$4c5dc42699fd98c2$export$2d1720544b23b823 = $ef322a7f89c3ed41$exports && !$161a89d67c436ccf$exports ? Object.defineProperties : function defineProperties(O, Properties) {
    $c845d421b7b0e630$exports(O);
    var props = $4d273c9d7e1bdf46$exports(Properties);
    var keys = $b74a8f96578f4948$exports(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$2d0ac3aa5e39584b$export$2d1720544b23b823(O, key = keys[index++], props[key]);
    return O;
};




var $b8ce1ad1b6b1e7c1$exports = {};
"use strict";

$b8ce1ad1b6b1e7c1$exports = $a5217dbd1b0d33ce$exports("document", "documentElement");



var $834abcf0f8f3f871$exports = {};
"use strict";


var $834abcf0f8f3f871$var$keys = $1946b9b54b48e7fd$exports("keys");
$834abcf0f8f3f871$exports = function(key) {
    return $834abcf0f8f3f871$var$keys[key] || ($834abcf0f8f3f871$var$keys[key] = $5e0a1e292f79defc$exports(key));
};


var $5c0346dde328cc4c$var$GT = ">";
var $5c0346dde328cc4c$var$LT = "<";
var $5c0346dde328cc4c$var$PROTOTYPE = "prototype";
var $5c0346dde328cc4c$var$SCRIPT = "script";
var $5c0346dde328cc4c$var$IE_PROTO = $834abcf0f8f3f871$exports("IE_PROTO");
var $5c0346dde328cc4c$var$EmptyConstructor = function() {};
var $5c0346dde328cc4c$var$scriptTag = function(content) {
    return $5c0346dde328cc4c$var$LT + $5c0346dde328cc4c$var$SCRIPT + $5c0346dde328cc4c$var$GT + content + $5c0346dde328cc4c$var$LT + "/" + $5c0346dde328cc4c$var$SCRIPT + $5c0346dde328cc4c$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $5c0346dde328cc4c$var$NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write($5c0346dde328cc4c$var$scriptTag(""));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    // eslint-disable-next-line no-useless-assignment -- avoid memory leak
    activeXDocument = null;
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $5c0346dde328cc4c$var$NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $15c0c414b89100b1$exports("iframe");
    var JS = "java" + $5c0346dde328cc4c$var$SCRIPT + ":";
    var iframeDocument;
    iframe.style.display = "none";
    $b8ce1ad1b6b1e7c1$exports.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($5c0346dde328cc4c$var$scriptTag("document.F=Object"));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $5c0346dde328cc4c$var$activeXDocument;
var $5c0346dde328cc4c$var$NullProtoObject = function() {
    try {
        $5c0346dde328cc4c$var$activeXDocument = new ActiveXObject("htmlfile");
    } catch (error) {}
    $5c0346dde328cc4c$var$NullProtoObject = typeof document != "undefined" ? document.domain && $5c0346dde328cc4c$var$activeXDocument ? $5c0346dde328cc4c$var$NullProtoObjectViaActiveX($5c0346dde328cc4c$var$activeXDocument) // old IE
     : $5c0346dde328cc4c$var$NullProtoObjectViaIFrame() : $5c0346dde328cc4c$var$NullProtoObjectViaActiveX($5c0346dde328cc4c$var$activeXDocument); // WSH
    var length = $e73f13f1d8a17cad$exports.length;
    while(length--)delete $5c0346dde328cc4c$var$NullProtoObject[$5c0346dde328cc4c$var$PROTOTYPE][$e73f13f1d8a17cad$exports[length]];
    return $5c0346dde328cc4c$var$NullProtoObject();
};
$9f571a3f3d135e31$exports[$5c0346dde328cc4c$var$IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
$5c0346dde328cc4c$exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $5c0346dde328cc4c$var$EmptyConstructor[$5c0346dde328cc4c$var$PROTOTYPE] = $c845d421b7b0e630$exports(O);
        result = new $5c0346dde328cc4c$var$EmptyConstructor();
        $5c0346dde328cc4c$var$EmptyConstructor[$5c0346dde328cc4c$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$5c0346dde328cc4c$var$IE_PROTO] = O;
    } else result = $5c0346dde328cc4c$var$NullProtoObject();
    return Properties === undefined ? result : $4c5dc42699fd98c2$export$2d1720544b23b823(result, Properties);
};



var $fcd977913fa5bb2d$require$defineProperty = $2d0ac3aa5e39584b$export$2d1720544b23b823;
var $fcd977913fa5bb2d$var$UNSCOPABLES = $842f8f0a18746212$exports("unscopables");
var $fcd977913fa5bb2d$var$ArrayPrototype = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if ($fcd977913fa5bb2d$var$ArrayPrototype[$fcd977913fa5bb2d$var$UNSCOPABLES] === undefined) $fcd977913fa5bb2d$require$defineProperty($fcd977913fa5bb2d$var$ArrayPrototype, $fcd977913fa5bb2d$var$UNSCOPABLES, {
    configurable: true,
    value: $5c0346dde328cc4c$exports(null)
});
// add a key to Array.prototype[@@unscopables]
$fcd977913fa5bb2d$exports = function(key) {
    $fcd977913fa5bb2d$var$ArrayPrototype[$fcd977913fa5bb2d$var$UNSCOPABLES][key] = true;
};




var $74a6fb831e72713b$exports = {};
"use strict";
var $09c56ff2ae09b2d7$exports = {};
"use strict";





var $81c64883d194e3b4$exports = {};
"use strict";


var $81c64883d194e3b4$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $81c64883d194e3b4$var$getDescriptor = $ef322a7f89c3ed41$exports && Object.getOwnPropertyDescriptor;
var $81c64883d194e3b4$var$EXISTS = $1f868a26fd901990$exports($81c64883d194e3b4$var$FunctionPrototype, "name");
// additional protection from minified / mangled / dropped function names
var $81c64883d194e3b4$var$PROPER = $81c64883d194e3b4$var$EXISTS && (function something() {}).name === "something";
var $81c64883d194e3b4$var$CONFIGURABLE = $81c64883d194e3b4$var$EXISTS && (!$ef322a7f89c3ed41$exports || $ef322a7f89c3ed41$exports && $81c64883d194e3b4$var$getDescriptor($81c64883d194e3b4$var$FunctionPrototype, "name").configurable);
$81c64883d194e3b4$exports = {
    EXISTS: $81c64883d194e3b4$var$EXISTS,
    PROPER: $81c64883d194e3b4$var$PROPER,
    CONFIGURABLE: $81c64883d194e3b4$var$CONFIGURABLE
};


var $09c56ff2ae09b2d7$require$CONFIGURABLE_FUNCTION_NAME = $81c64883d194e3b4$exports.CONFIGURABLE;
var $9990f6f719f26a96$exports = {};
"use strict";



var $9990f6f719f26a96$var$functionToString = $43b18aa2f1faac44$exports(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$70e34a5a2021f756$exports($d00d03e557d638db$exports.inspectSource)) $d00d03e557d638db$exports.inspectSource = function(it) {
    return $9990f6f719f26a96$var$functionToString(it);
};
$9990f6f719f26a96$exports = $d00d03e557d638db$exports.inspectSource;


var $3a8bcef306e86159$exports = {};
"use strict";
var $47d53bb84a8f3c5b$exports = {};
"use strict";


var $47d53bb84a8f3c5b$var$WeakMap = $3fbf1185731afe2b$exports.WeakMap;
$47d53bb84a8f3c5b$exports = $70e34a5a2021f756$exports($47d53bb84a8f3c5b$var$WeakMap) && /native code/.test(String($47d53bb84a8f3c5b$var$WeakMap));




var $8693737507995841$exports = {};
"use strict";


var $b66966b48674609b$exports = {};
"use strict";
$b66966b48674609b$exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};


$8693737507995841$exports = $ef322a7f89c3ed41$exports ? function(object, key, value) {
    return $2d0ac3aa5e39584b$export$2d1720544b23b823(object, key, $b66966b48674609b$exports(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};






var $3a8bcef306e86159$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $3a8bcef306e86159$var$TypeError = $3fbf1185731afe2b$exports.TypeError;
var $3a8bcef306e86159$var$WeakMap = $3fbf1185731afe2b$exports.WeakMap;
var $3a8bcef306e86159$var$set, $3a8bcef306e86159$var$get, $3a8bcef306e86159$var$has;
var $3a8bcef306e86159$var$enforce = function(it) {
    return $3a8bcef306e86159$var$has(it) ? $3a8bcef306e86159$var$get(it) : $3a8bcef306e86159$var$set(it, {});
};
var $3a8bcef306e86159$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$6a130d390db46c8e$exports(it) || (state = $3a8bcef306e86159$var$get(it)).type !== TYPE) throw new $3a8bcef306e86159$var$TypeError("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($47d53bb84a8f3c5b$exports || $d00d03e557d638db$exports.state) {
    var $3a8bcef306e86159$var$store = $d00d03e557d638db$exports.state || ($d00d03e557d638db$exports.state = new $3a8bcef306e86159$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $3a8bcef306e86159$var$store.get = $3a8bcef306e86159$var$store.get;
    $3a8bcef306e86159$var$store.has = $3a8bcef306e86159$var$store.has;
    $3a8bcef306e86159$var$store.set = $3a8bcef306e86159$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $3a8bcef306e86159$var$set = function(it, metadata) {
        if ($3a8bcef306e86159$var$store.has(it)) throw new $3a8bcef306e86159$var$TypeError($3a8bcef306e86159$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $3a8bcef306e86159$var$store.set(it, metadata);
        return metadata;
    };
    $3a8bcef306e86159$var$get = function(it) {
        return $3a8bcef306e86159$var$store.get(it) || {};
    };
    $3a8bcef306e86159$var$has = function(it) {
        return $3a8bcef306e86159$var$store.has(it);
    };
} else {
    var $3a8bcef306e86159$var$STATE = $834abcf0f8f3f871$exports("state");
    $9f571a3f3d135e31$exports[$3a8bcef306e86159$var$STATE] = true;
    $3a8bcef306e86159$var$set = function(it, metadata) {
        if ($1f868a26fd901990$exports(it, $3a8bcef306e86159$var$STATE)) throw new $3a8bcef306e86159$var$TypeError($3a8bcef306e86159$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $8693737507995841$exports(it, $3a8bcef306e86159$var$STATE, metadata);
        return metadata;
    };
    $3a8bcef306e86159$var$get = function(it) {
        return $1f868a26fd901990$exports(it, $3a8bcef306e86159$var$STATE) ? it[$3a8bcef306e86159$var$STATE] : {};
    };
    $3a8bcef306e86159$var$has = function(it) {
        return $1f868a26fd901990$exports(it, $3a8bcef306e86159$var$STATE);
    };
}
$3a8bcef306e86159$exports = {
    set: $3a8bcef306e86159$var$set,
    get: $3a8bcef306e86159$var$get,
    has: $3a8bcef306e86159$var$has,
    enforce: $3a8bcef306e86159$var$enforce,
    getterFor: $3a8bcef306e86159$var$getterFor
};


var $09c56ff2ae09b2d7$var$enforceInternalState = $3a8bcef306e86159$exports.enforce;
var $09c56ff2ae09b2d7$var$getInternalState = $3a8bcef306e86159$exports.get;
var $09c56ff2ae09b2d7$var$$String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $09c56ff2ae09b2d7$var$defineProperty = Object.defineProperty;
var $09c56ff2ae09b2d7$var$stringSlice = $43b18aa2f1faac44$exports("".slice);
var $09c56ff2ae09b2d7$var$replace = $43b18aa2f1faac44$exports("".replace);
var $09c56ff2ae09b2d7$var$join = $43b18aa2f1faac44$exports([].join);
var $09c56ff2ae09b2d7$var$CONFIGURABLE_LENGTH = $ef322a7f89c3ed41$exports && !$6140c9fa18232846$exports(function() {
    return $09c56ff2ae09b2d7$var$defineProperty(function() {}, "length", {
        value: 8
    }).length !== 8;
});
var $09c56ff2ae09b2d7$var$TEMPLATE = String(String).split("String");
var $09c56ff2ae09b2d7$var$makeBuiltIn = $09c56ff2ae09b2d7$exports = function(value, name, options) {
    if ($09c56ff2ae09b2d7$var$stringSlice($09c56ff2ae09b2d7$var$$String(name), 0, 7) === "Symbol(") name = "[" + $09c56ff2ae09b2d7$var$replace($09c56ff2ae09b2d7$var$$String(name), /^Symbol\(([^)]*)\).*$/, "$1") + "]";
    if (options && options.getter) name = "get " + name;
    if (options && options.setter) name = "set " + name;
    if (!$1f868a26fd901990$exports(value, "name") || $09c56ff2ae09b2d7$require$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($ef322a7f89c3ed41$exports) $09c56ff2ae09b2d7$var$defineProperty(value, "name", {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($09c56ff2ae09b2d7$var$CONFIGURABLE_LENGTH && options && $1f868a26fd901990$exports(options, "arity") && value.length !== options.arity) $09c56ff2ae09b2d7$var$defineProperty(value, "length", {
        value: options.arity
    });
    try {
        if (options && $1f868a26fd901990$exports(options, "constructor") && options.constructor) {
            if ($ef322a7f89c3ed41$exports) $09c56ff2ae09b2d7$var$defineProperty(value, "prototype", {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $09c56ff2ae09b2d7$var$enforceInternalState(value);
    if (!$1f868a26fd901990$exports(state, "source")) state.source = $09c56ff2ae09b2d7$var$join($09c56ff2ae09b2d7$var$TEMPLATE, typeof name == "string" ? name : "");
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $09c56ff2ae09b2d7$var$makeBuiltIn(function toString() {
    return $70e34a5a2021f756$exports(this) && $09c56ff2ae09b2d7$var$getInternalState(this).source || $9990f6f719f26a96$exports(this);
}, "toString");



$74a6fb831e72713b$exports = function(target, name, descriptor) {
    if (descriptor.get) $09c56ff2ae09b2d7$exports(descriptor.get, name, {
        getter: true
    });
    if (descriptor.set) $09c56ff2ae09b2d7$exports(descriptor.set, name, {
        setter: true
    });
    return $2d0ac3aa5e39584b$export$2d1720544b23b823(target, name, descriptor);
};


// `Array.prototype.lastIndex` getter
// https://github.com/keithamus/proposal-array-last
if ($ef322a7f89c3ed41$exports) {
    $74a6fb831e72713b$exports(Array.prototype, "lastIndex", {
        configurable: true,
        get: function lastIndex() {
            var O = $a2f3ebb5da11db12$exports(this);
            var len = $04c91bd3815cd64a$exports(O);
            return len === 0 ? 0 : len - 1;
        }
    });
    $fcd977913fa5bb2d$exports("lastIndex");
}


"use strict";





// `Array.prototype.lastIndex` accessor
// https://github.com/keithamus/proposal-array-last
if ($ef322a7f89c3ed41$exports) {
    $74a6fb831e72713b$exports(Array.prototype, "lastItem", {
        configurable: true,
        get: function lastItem() {
            var O = $a2f3ebb5da11db12$exports(this);
            var len = $04c91bd3815cd64a$exports(O);
            return len === 0 ? undefined : O[len - 1];
        },
        set: function lastItem(value) {
            var O = $a2f3ebb5da11db12$exports(this);
            var len = $04c91bd3815cd64a$exports(O);
            return O[len === 0 ? 0 : len - 1] = value;
        }
    });
    $fcd977913fa5bb2d$exports("lastItem");
}


"use strict";
var $ca3e1754e676956d$exports = {};
"use strict";

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $6d99163b6684d050$export$2d1720544b23b823;
"use strict";


// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $1e0782be6903ea7b$export$2d1720544b23b823;
"use strict";
var $1e0782be6903ea7b$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $1e0782be6903ea7b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $1e0782be6903ea7b$var$NASHORN_BUG = $1e0782be6903ea7b$var$getOwnPropertyDescriptor && !$1e0782be6903ea7b$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$1e0782be6903ea7b$export$2d1720544b23b823 = $1e0782be6903ea7b$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $1e0782be6903ea7b$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $1e0782be6903ea7b$var$$propertyIsEnumerable;







// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $6d99163b6684d050$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$6d99163b6684d050$export$2d1720544b23b823 = $ef322a7f89c3ed41$exports ? $6d99163b6684d050$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $4d273c9d7e1bdf46$exports(O);
    P = $7f19acfe53927f5c$exports(P);
    if ($d45526d8245cb22c$exports) try {
        return $6d99163b6684d050$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($1f868a26fd901990$exports(O, P)) return $b66966b48674609b$exports(!$881ad37dbe259e8f$exports($1e0782be6903ea7b$export$2d1720544b23b823, O, P), O[P]);
};


var $ca3e1754e676956d$require$getOwnPropertyDescriptor = $6d99163b6684d050$export$2d1720544b23b823;

var $40e957865125f98f$exports = {};
"use strict";




$40e957865125f98f$exports = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($70e34a5a2021f756$exports(value)) $09c56ff2ae09b2d7$exports(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $4ce407c7007beb63$exports(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $2d0ac3aa5e39584b$export$2d1720544b23b823(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};



var $ef14b437ba65973a$exports = {};
"use strict";

var $339f2419d379e6c2$exports = {};
"use strict";


// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $f6c32256739dd9b5$export$2d1720544b23b823;
"use strict";


var $f6c32256739dd9b5$var$hiddenKeys = $e73f13f1d8a17cad$exports.concat("length", "prototype");
$f6c32256739dd9b5$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $c4fba4611365c4f5$exports(O, $f6c32256739dd9b5$var$hiddenKeys);
};


// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $0ed66cde5c449819$export$2d1720544b23b823;
"use strict";
$0ed66cde5c449819$export$2d1720544b23b823 = Object.getOwnPropertySymbols;



var $339f2419d379e6c2$var$concat = $43b18aa2f1faac44$exports([].concat);
// all object keys, includes non-enumerable and symbols
$339f2419d379e6c2$exports = $a5217dbd1b0d33ce$exports("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $f6c32256739dd9b5$export$2d1720544b23b823($c845d421b7b0e630$exports(it));
    var getOwnPropertySymbols = $0ed66cde5c449819$export$2d1720544b23b823;
    return getOwnPropertySymbols ? $339f2419d379e6c2$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};




$ef14b437ba65973a$exports = function(target, source, exceptions) {
    var keys = $339f2419d379e6c2$exports(source);
    var defineProperty = $2d0ac3aa5e39584b$export$2d1720544b23b823;
    var getOwnPropertyDescriptor = $6d99163b6684d050$export$2d1720544b23b823;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$1f868a26fd901990$exports(target, key) && !(exceptions && $1f868a26fd901990$exports(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};


var $ca268db110e9e457$exports = {};
"use strict";


var $ca268db110e9e457$var$replacement = /#|\.prototype\./;
var $ca268db110e9e457$var$isForced = function(feature, detection) {
    var value = $ca268db110e9e457$var$data[$ca268db110e9e457$var$normalize(feature)];
    return value === $ca268db110e9e457$var$POLYFILL ? true : value === $ca268db110e9e457$var$NATIVE ? false : $70e34a5a2021f756$exports(detection) ? $6140c9fa18232846$exports(detection) : !!detection;
};
var $ca268db110e9e457$var$normalize = $ca268db110e9e457$var$isForced.normalize = function(string) {
    return String(string).replace($ca268db110e9e457$var$replacement, ".").toLowerCase();
};
var $ca268db110e9e457$var$data = $ca268db110e9e457$var$isForced.data = {};
var $ca268db110e9e457$var$NATIVE = $ca268db110e9e457$var$isForced.NATIVE = "N";
var $ca268db110e9e457$var$POLYFILL = $ca268db110e9e457$var$isForced.POLYFILL = "P";
$ca268db110e9e457$exports = $ca268db110e9e457$var$isForced;


/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ $ca3e1754e676956d$exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $3fbf1185731afe2b$exports;
    else if (STATIC) target = $3fbf1185731afe2b$exports[TARGET] || $4ce407c7007beb63$exports(TARGET, {});
    else target = $3fbf1185731afe2b$exports[TARGET] && $3fbf1185731afe2b$exports[TARGET].prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $ca3e1754e676956d$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $ca268db110e9e457$exports(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $ef14b437ba65973a$exports(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $8693737507995841$exports(sourceProperty, "sham", true);
        $40e957865125f98f$exports(target, key, sourceProperty, options);
    }
};


var $3cdb2ef65d8e3cb5$exports = {};
"use strict";

var $3cdb2ef65d8e3cb5$var$FunctionPrototype = Function.prototype;
var $3cdb2ef65d8e3cb5$var$apply = $3cdb2ef65d8e3cb5$var$FunctionPrototype.apply;
var $3cdb2ef65d8e3cb5$var$call = $3cdb2ef65d8e3cb5$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-reflect -- safe
$3cdb2ef65d8e3cb5$exports = typeof Reflect == "object" && Reflect.apply || ($bcbe62e89adc7d37$exports ? $3cdb2ef65d8e3cb5$var$call.bind($3cdb2ef65d8e3cb5$var$apply) : function() {
    return $3cdb2ef65d8e3cb5$var$call.apply($3cdb2ef65d8e3cb5$var$apply, arguments);
});


var $e12f552938f6c28b$exports = {};
"use strict";
"use strict";
"use strict";
var $6b78298c759520c1$exports = {};
"use strict";





var $0a7dfd4ed285865b$exports = {};
"use strict";






var $0a7dfd4ed285865b$require$defineProperty = $2d0ac3aa5e39584b$export$2d1720544b23b823;

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var $2d32fe738cfc6a16$export$2d1720544b23b823;
"use strict";



var $2d32fe738cfc6a16$require$$getOwnPropertyNames = $f6c32256739dd9b5$export$2d1720544b23b823;
var $0709cba658bb4ed6$exports = {};
"use strict";

$0709cba658bb4ed6$exports = $43b18aa2f1faac44$exports([].slice);


var $2d32fe738cfc6a16$var$windowNames = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var $2d32fe738cfc6a16$var$getWindowNames = function(it) {
    try {
        return $2d32fe738cfc6a16$require$$getOwnPropertyNames(it);
    } catch (error) {
        return $0709cba658bb4ed6$exports($2d32fe738cfc6a16$var$windowNames);
    }
};
$2d32fe738cfc6a16$export$2d1720544b23b823 = function getOwnPropertyNames(it) {
    return $2d32fe738cfc6a16$var$windowNames && $b0ba63bfbfb16088$exports(it) === "Window" ? $2d32fe738cfc6a16$var$getWindowNames(it) : $2d32fe738cfc6a16$require$$getOwnPropertyNames($4d273c9d7e1bdf46$exports(it));
};


var $abe4acfbab10a1da$exports = {};
"use strict";



var $e3ff2916d5862bdc$exports = {};
"use strict";

$e3ff2916d5862bdc$exports = $6140c9fa18232846$exports(function() {
    if (typeof ArrayBuffer == "function") {
        var buffer = new ArrayBuffer(8);
        // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
        if (Object.isExtensible(buffer)) Object.defineProperty(buffer, "a", {
            value: 8
        });
    }
});


// eslint-disable-next-line es/no-object-isextensible -- safe
var $abe4acfbab10a1da$var$$isExtensible = Object.isExtensible;
var $abe4acfbab10a1da$var$FAILS_ON_PRIMITIVES = $6140c9fa18232846$exports(function() {
    $abe4acfbab10a1da$var$$isExtensible(1);
});
// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
$abe4acfbab10a1da$exports = $abe4acfbab10a1da$var$FAILS_ON_PRIMITIVES || $e3ff2916d5862bdc$exports ? function isExtensible(it) {
    if (!$6a130d390db46c8e$exports(it)) return false;
    if ($e3ff2916d5862bdc$exports && $b0ba63bfbfb16088$exports(it) === "ArrayBuffer") return false;
    return $abe4acfbab10a1da$var$$isExtensible ? $abe4acfbab10a1da$var$$isExtensible(it) : true;
} : $abe4acfbab10a1da$var$$isExtensible;



var $ef4d4edd3daa687a$exports = {};
"use strict";

$ef4d4edd3daa687a$exports = !$6140c9fa18232846$exports(function() {
    // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
    return Object.isExtensible(Object.preventExtensions({}));
});


var $0a7dfd4ed285865b$var$REQUIRED = false;
var $0a7dfd4ed285865b$var$METADATA = $5e0a1e292f79defc$exports("meta");
var $0a7dfd4ed285865b$var$id = 0;
var $0a7dfd4ed285865b$var$setMetadata = function(it) {
    $0a7dfd4ed285865b$require$defineProperty(it, $0a7dfd4ed285865b$var$METADATA, {
        value: {
            objectID: "O" + $0a7dfd4ed285865b$var$id++,
            weakData: {} // weak collections IDs
        }
    });
};
var $0a7dfd4ed285865b$var$fastKey = function(it, create) {
    // return a primitive with prefix
    if (!$6a130d390db46c8e$exports(it)) return typeof it == "symbol" ? it : (typeof it == "string" ? "S" : "P") + it;
    if (!$1f868a26fd901990$exports(it, $0a7dfd4ed285865b$var$METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!$abe4acfbab10a1da$exports(it)) return "F";
        // not necessary to add metadata
        if (!create) return "E";
        // add missing metadata
        $0a7dfd4ed285865b$var$setMetadata(it);
    // return object ID
    }
    return it[$0a7dfd4ed285865b$var$METADATA].objectID;
};
var $0a7dfd4ed285865b$var$getWeakData = function(it, create) {
    if (!$1f868a26fd901990$exports(it, $0a7dfd4ed285865b$var$METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!$abe4acfbab10a1da$exports(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        $0a7dfd4ed285865b$var$setMetadata(it);
    // return the store of weak collections IDs
    }
    return it[$0a7dfd4ed285865b$var$METADATA].weakData;
};
// add metadata on freeze-family methods calling
var $0a7dfd4ed285865b$var$onFreeze = function(it) {
    if ($ef4d4edd3daa687a$exports && $0a7dfd4ed285865b$var$REQUIRED && $abe4acfbab10a1da$exports(it) && !$1f868a26fd901990$exports(it, $0a7dfd4ed285865b$var$METADATA)) $0a7dfd4ed285865b$var$setMetadata(it);
    return it;
};
var $0a7dfd4ed285865b$var$enable = function() {
    $0a7dfd4ed285865b$var$meta.enable = function() {};
    $0a7dfd4ed285865b$var$REQUIRED = true;
    var getOwnPropertyNames = $f6c32256739dd9b5$export$2d1720544b23b823;
    var splice = $43b18aa2f1faac44$exports([].splice);
    var test = {};
    test[$0a7dfd4ed285865b$var$METADATA] = 1;
    // prevent exposing of metadata key
    if (getOwnPropertyNames(test).length) {
        $f6c32256739dd9b5$export$2d1720544b23b823 = function(it) {
            var result = getOwnPropertyNames(it);
            for(var i = 0, length = result.length; i < length; i++)if (result[i] === $0a7dfd4ed285865b$var$METADATA) {
                splice(result, i, 1);
                break;
            }
            return result;
        };
        $ca3e1754e676956d$exports({
            target: "Object",
            stat: true,
            forced: true
        }, {
            getOwnPropertyNames: $2d32fe738cfc6a16$export$2d1720544b23b823
        });
    }
};
var $0a7dfd4ed285865b$var$meta = $0a7dfd4ed285865b$exports = {
    enable: $0a7dfd4ed285865b$var$enable,
    fastKey: $0a7dfd4ed285865b$var$fastKey,
    getWeakData: $0a7dfd4ed285865b$var$getWeakData,
    onFreeze: $0a7dfd4ed285865b$var$onFreeze
};
$9f571a3f3d135e31$exports[$0a7dfd4ed285865b$var$METADATA] = true;


var $a78806ef4ebb6167$exports = {};
"use strict";
var $43284f0171045916$exports = {};
"use strict";
var $4828cb1b4c7586c8$exports = {};
"use strict";


$4828cb1b4c7586c8$exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($b0ba63bfbfb16088$exports(fn) === "Function") return $43b18aa2f1faac44$exports(fn);
};




var $43284f0171045916$var$bind = $4828cb1b4c7586c8$exports($4828cb1b4c7586c8$exports.bind);
// optional / simple context binding
$43284f0171045916$exports = function(fn, that) {
    $ae485921c5498156$exports(fn);
    return that === undefined ? fn : $bcbe62e89adc7d37$exports ? $43284f0171045916$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};





var $570a6df80758b4be$exports = {};
"use strict";

var $0fe0dd04b0eb22af$exports = {};
"use strict";
$0fe0dd04b0eb22af$exports = {};


var $570a6df80758b4be$var$ITERATOR = $842f8f0a18746212$exports("iterator");
var $570a6df80758b4be$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
$570a6df80758b4be$exports = function(it) {
    return it !== undefined && ($0fe0dd04b0eb22af$exports.Array === it || $570a6df80758b4be$var$ArrayPrototype[$570a6df80758b4be$var$ITERATOR] === it);
};




var $13a4c31eee540026$exports = {};
"use strict";




var $8d560b8b837672a0$exports = {};
"use strict";
var $b07c9aec2f9c74e4$exports = {};
"use strict";
var $a2c149aaa14cc75b$exports = {};
"use strict";

var $a2c149aaa14cc75b$var$TO_STRING_TAG = $842f8f0a18746212$exports("toStringTag");
var $a2c149aaa14cc75b$var$test = {};
$a2c149aaa14cc75b$var$test[$a2c149aaa14cc75b$var$TO_STRING_TAG] = "z";
$a2c149aaa14cc75b$exports = String($a2c149aaa14cc75b$var$test) === "[object z]";





var $b07c9aec2f9c74e4$var$TO_STRING_TAG = $842f8f0a18746212$exports("toStringTag");
var $b07c9aec2f9c74e4$var$$Object = Object;
// ES3 wrong here
var $b07c9aec2f9c74e4$var$CORRECT_ARGUMENTS = $b0ba63bfbfb16088$exports(function() {
    return arguments;
}()) === "Arguments";
// fallback for IE11 Script Access Denied error
var $b07c9aec2f9c74e4$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
$b07c9aec2f9c74e4$exports = $a2c149aaa14cc75b$exports ? $b0ba63bfbfb16088$exports : function(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = $b07c9aec2f9c74e4$var$tryGet(O = $b07c9aec2f9c74e4$var$$Object(it), $b07c9aec2f9c74e4$var$TO_STRING_TAG)) == "string" ? tag : $b07c9aec2f9c74e4$var$CORRECT_ARGUMENTS ? $b0ba63bfbfb16088$exports(O) : (result = $b0ba63bfbfb16088$exports(O)) === "Object" && $70e34a5a2021f756$exports(O.callee) ? "Arguments" : result;
};






var $8d560b8b837672a0$var$ITERATOR = $842f8f0a18746212$exports("iterator");
$8d560b8b837672a0$exports = function(it) {
    if (!$7ce250ddf7b42d4d$exports(it)) return $eb80dcd0b8a5698c$exports(it, $8d560b8b837672a0$var$ITERATOR) || $eb80dcd0b8a5698c$exports(it, "@@iterator") || $0fe0dd04b0eb22af$exports[$b07c9aec2f9c74e4$exports(it)];
};


var $13a4c31eee540026$var$$TypeError = TypeError;
$13a4c31eee540026$exports = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $8d560b8b837672a0$exports(argument) : usingIterator;
    if ($ae485921c5498156$exports(iteratorMethod)) return $c845d421b7b0e630$exports($881ad37dbe259e8f$exports(iteratorMethod, argument));
    throw new $13a4c31eee540026$var$$TypeError($8f0ebae34f61e14c$exports(argument) + " is not iterable");
};



var $4105790cb9bf2aaa$exports = {};
"use strict";



$4105790cb9bf2aaa$exports = function(iterator, kind, value) {
    var innerResult, innerError;
    $c845d421b7b0e630$exports(iterator);
    try {
        innerResult = $eb80dcd0b8a5698c$exports(iterator, "return");
        if (!innerResult) {
            if (kind === "throw") throw value;
            return value;
        }
        innerResult = $881ad37dbe259e8f$exports(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === "throw") throw value;
    if (innerError) throw innerResult;
    $c845d421b7b0e630$exports(innerResult);
    return value;
};


var $a78806ef4ebb6167$var$$TypeError = TypeError;
var $a78806ef4ebb6167$var$Result = function(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var $a78806ef4ebb6167$var$ResultPrototype = $a78806ef4ebb6167$var$Result.prototype;
$a78806ef4ebb6167$exports = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_RECORD = !!(options && options.IS_RECORD);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $43284f0171045916$exports(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function(condition) {
        if (iterator) $4105790cb9bf2aaa$exports(iterator, "normal", condition);
        return new $a78806ef4ebb6167$var$Result(true, condition);
    };
    var callFn = function(value) {
        if (AS_ENTRIES) {
            $c845d421b7b0e630$exports(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_RECORD) iterator = iterable.iterator;
    else if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $8d560b8b837672a0$exports(iterable);
        if (!iterFn) throw new $a78806ef4ebb6167$var$$TypeError($8f0ebae34f61e14c$exports(iterable) + " is not iterable");
        // optimisation for array iterators
        if ($570a6df80758b4be$exports(iterFn)) {
            for(index = 0, length = $04c91bd3815cd64a$exports(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && $41cc576e850a251e$exports($a78806ef4ebb6167$var$ResultPrototype, result)) return result;
            }
            return new $a78806ef4ebb6167$var$Result(false);
        }
        iterator = $13a4c31eee540026$exports(iterable, iterFn);
    }
    next = IS_RECORD ? iterable.next : iterator.next;
    while(!(step = $881ad37dbe259e8f$exports(next, iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            $4105790cb9bf2aaa$exports(iterator, "throw", error);
        }
        if (typeof result == "object" && result && $41cc576e850a251e$exports($a78806ef4ebb6167$var$ResultPrototype, result)) return result;
    }
    return new $a78806ef4ebb6167$var$Result(false);
};


var $85de2a4f93f1c485$exports = {};
"use strict";

var $85de2a4f93f1c485$var$$TypeError = TypeError;
$85de2a4f93f1c485$exports = function(it, Prototype) {
    if ($41cc576e850a251e$exports(Prototype, it)) return it;
    throw new $85de2a4f93f1c485$var$$TypeError("Incorrect invocation");
};






var $159ca9ebcc568d56$exports = {};
"use strict";

var $159ca9ebcc568d56$var$ITERATOR = $842f8f0a18746212$exports("iterator");
var $159ca9ebcc568d56$var$SAFE_CLOSING = false;
try {
    var $159ca9ebcc568d56$var$called = 0;
    var $159ca9ebcc568d56$var$iteratorWithReturn = {
        next: function() {
            return {
                done: !!$159ca9ebcc568d56$var$called++
            };
        },
        "return": function() {
            $159ca9ebcc568d56$var$SAFE_CLOSING = true;
        }
    };
    $159ca9ebcc568d56$var$iteratorWithReturn[$159ca9ebcc568d56$var$ITERATOR] = function() {
        return this;
    };
    // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
    Array.from($159ca9ebcc568d56$var$iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
$159ca9ebcc568d56$exports = function(exec, SKIP_CLOSING) {
    try {
        if (!SKIP_CLOSING && !$159ca9ebcc568d56$var$SAFE_CLOSING) return false;
    } catch (error) {
        return false;
    } // workaround of old WebKit + `eval` bug
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        object[$159ca9ebcc568d56$var$ITERATOR] = function() {
            return {
                next: function() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};


var $3984243ae29093af$exports = {};
"use strict";

var $3984243ae29093af$require$defineProperty = $2d0ac3aa5e39584b$export$2d1720544b23b823;


var $3984243ae29093af$var$TO_STRING_TAG = $842f8f0a18746212$exports("toStringTag");
$3984243ae29093af$exports = function(target, TAG, STATIC) {
    if (target && !STATIC) target = target.prototype;
    if (target && !$1f868a26fd901990$exports(target, $3984243ae29093af$var$TO_STRING_TAG)) $3984243ae29093af$require$defineProperty(target, $3984243ae29093af$var$TO_STRING_TAG, {
        configurable: true,
        value: TAG
    });
};


var $c84532d17907c41e$exports = {};
"use strict";


var $5e6994558f51b773$exports = {};
"use strict";
var $ab274a67893419f3$exports = {};
"use strict";


$ab274a67893419f3$exports = function(object, key, method) {
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        return $43b18aa2f1faac44$exports($ae485921c5498156$exports(Object.getOwnPropertyDescriptor(object, key)[method]));
    } catch (error) {}
};




var $d4d31549cf7c058b$exports = {};
"use strict";
var $46bfa91322f93a01$exports = {};
"use strict";

$46bfa91322f93a01$exports = function(argument) {
    return $6a130d390db46c8e$exports(argument) || argument === null;
};


var $d4d31549cf7c058b$var$$String = String;
var $d4d31549cf7c058b$var$$TypeError = TypeError;
$d4d31549cf7c058b$exports = function(argument) {
    if ($46bfa91322f93a01$exports(argument)) return argument;
    throw new $d4d31549cf7c058b$var$$TypeError("Can't set " + $d4d31549cf7c058b$var$$String(argument) + " as a prototype");
};


// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
$5e6994558f51b773$exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        setter = $ab274a67893419f3$exports(Object.prototype, "__proto__", "set");
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $c378177673193450$exports(O);
        $d4d31549cf7c058b$exports(proto);
        if (!$6a130d390db46c8e$exports(O)) return O;
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);


// makes subclassing work correct for wrapped built-ins
$c84532d17907c41e$exports = function($this, dummy, Wrapper) {
    var NewTarget, NewTargetPrototype;
    if (// it can work only with native `setPrototypeOf`
    $5e6994558f51b773$exports && // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    $70e34a5a2021f756$exports(NewTarget = dummy.constructor) && NewTarget !== Wrapper && $6a130d390db46c8e$exports(NewTargetPrototype = NewTarget.prototype) && NewTargetPrototype !== Wrapper.prototype) $5e6994558f51b773$exports($this, NewTargetPrototype);
    return $this;
};


$6b78298c759520c1$exports = function(CONSTRUCTOR_NAME, wrapper, common) {
    var IS_MAP = CONSTRUCTOR_NAME.indexOf("Map") !== -1;
    var IS_WEAK = CONSTRUCTOR_NAME.indexOf("Weak") !== -1;
    var ADDER = IS_MAP ? "set" : "add";
    var NativeConstructor = $3fbf1185731afe2b$exports[CONSTRUCTOR_NAME];
    var NativePrototype = NativeConstructor && NativeConstructor.prototype;
    var Constructor = NativeConstructor;
    var exported = {};
    var fixMethod = function(KEY) {
        var uncurriedNativeMethod = $43b18aa2f1faac44$exports(NativePrototype[KEY]);
        $40e957865125f98f$exports(NativePrototype, KEY, KEY === "add" ? function add(value) {
            uncurriedNativeMethod(this, value === 0 ? 0 : value);
            return this;
        } : KEY === "delete" ? function(key) {
            return IS_WEAK && !$6a130d390db46c8e$exports(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : KEY === "get" ? function get(key) {
            return IS_WEAK && !$6a130d390db46c8e$exports(key) ? undefined : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : KEY === "has" ? function has(key) {
            return IS_WEAK && !$6a130d390db46c8e$exports(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : function set(key, value) {
            uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
            return this;
        });
    };
    var REPLACE = $ca268db110e9e457$exports(CONSTRUCTOR_NAME, !$70e34a5a2021f756$exports(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !$6140c9fa18232846$exports(function() {
        new NativeConstructor().entries().next();
    })));
    if (REPLACE) {
        // create collection constructor
        Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
        $0a7dfd4ed285865b$exports.enable();
    } else if ($ca268db110e9e457$exports(CONSTRUCTOR_NAME, true)) {
        var instance = new Constructor();
        // early implementations not supports chaining
        var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) !== instance;
        // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
        var THROWS_ON_PRIMITIVES = $6140c9fa18232846$exports(function() {
            instance.has(1);
        });
        // most early implementations doesn't supports iterables, most modern - not close it correctly
        // eslint-disable-next-line no-new -- required for testing
        var ACCEPT_ITERABLES = $159ca9ebcc568d56$exports(function(iterable) {
            new NativeConstructor(iterable);
        });
        // for early implementations -0 and +0 not the same
        var BUGGY_ZERO = !IS_WEAK && $6140c9fa18232846$exports(function() {
            // V8 ~ Chromium 42- fails only with 5+ elements
            var $instance = new NativeConstructor();
            var index = 5;
            while(index--)$instance[ADDER](index, index);
            return !$instance.has(-0);
        });
        if (!ACCEPT_ITERABLES) {
            Constructor = wrapper(function(dummy, iterable) {
                $85de2a4f93f1c485$exports(dummy, NativePrototype);
                var that = $c84532d17907c41e$exports(new NativeConstructor(), dummy, Constructor);
                if (!$7ce250ddf7b42d4d$exports(iterable)) $a78806ef4ebb6167$exports(iterable, that[ADDER], {
                    that: that,
                    AS_ENTRIES: IS_MAP
                });
                return that;
            });
            Constructor.prototype = NativePrototype;
            NativePrototype.constructor = Constructor;
        }
        if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
            fixMethod("delete");
            fixMethod("has");
            IS_MAP && fixMethod("get");
        }
        if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
        // weak collections should not contains .clear method
        if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
    }
    exported[CONSTRUCTOR_NAME] = Constructor;
    $ca3e1754e676956d$exports({
        global: true,
        constructor: true,
        forced: Constructor !== NativeConstructor
    }, exported);
    $3984243ae29093af$exports(Constructor, CONSTRUCTOR_NAME);
    if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);
    return Constructor;
};


var $941be47da6423263$exports = {};
"use strict";


var $a3d227a61e709d75$exports = {};
"use strict";

$a3d227a61e709d75$exports = function(target, src, options) {
    for(var key in src)$40e957865125f98f$exports(target, key, src[key], options);
    return target;
};






var $9a73e569966b34cd$exports = {};
"use strict";





var $2428e9d9593354c3$exports = {};
"use strict";
var $82ce71e2bd45bc6e$exports = {};
"use strict";




var $a69a130329c6de82$exports = {};
"use strict";




var $e4c58b47d3c8d112$exports = {};
"use strict";

$e4c58b47d3c8d112$exports = !$6140c9fa18232846$exports(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});


var $a69a130329c6de82$var$IE_PROTO = $834abcf0f8f3f871$exports("IE_PROTO");
var $a69a130329c6de82$var$$Object = Object;
var $a69a130329c6de82$var$ObjectPrototype = $a69a130329c6de82$var$$Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
$a69a130329c6de82$exports = $e4c58b47d3c8d112$exports ? $a69a130329c6de82$var$$Object.getPrototypeOf : function(O) {
    var object = $a2f3ebb5da11db12$exports(O);
    if ($1f868a26fd901990$exports(object, $a69a130329c6de82$var$IE_PROTO)) return object[$a69a130329c6de82$var$IE_PROTO];
    var constructor = object.constructor;
    if ($70e34a5a2021f756$exports(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $a69a130329c6de82$var$$Object ? $a69a130329c6de82$var$ObjectPrototype : null;
};





var $82ce71e2bd45bc6e$var$ITERATOR = $842f8f0a18746212$exports("iterator");
var $82ce71e2bd45bc6e$var$BUGGY_SAFARI_ITERATORS = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var $82ce71e2bd45bc6e$var$IteratorPrototype, $82ce71e2bd45bc6e$var$PrototypeOfArrayIteratorPrototype, $82ce71e2bd45bc6e$var$arrayIterator;
/* eslint-disable es/no-array-prototype-keys -- safe */ if ([].keys) {
    $82ce71e2bd45bc6e$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!("next" in $82ce71e2bd45bc6e$var$arrayIterator)) $82ce71e2bd45bc6e$var$BUGGY_SAFARI_ITERATORS = true;
    else {
        $82ce71e2bd45bc6e$var$PrototypeOfArrayIteratorPrototype = $a69a130329c6de82$exports($a69a130329c6de82$exports($82ce71e2bd45bc6e$var$arrayIterator));
        if ($82ce71e2bd45bc6e$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $82ce71e2bd45bc6e$var$IteratorPrototype = $82ce71e2bd45bc6e$var$PrototypeOfArrayIteratorPrototype;
    }
}
var $82ce71e2bd45bc6e$var$NEW_ITERATOR_PROTOTYPE = !$6a130d390db46c8e$exports($82ce71e2bd45bc6e$var$IteratorPrototype) || $6140c9fa18232846$exports(function() {
    var test = {};
    // FF44- legacy iterators case
    return $82ce71e2bd45bc6e$var$IteratorPrototype[$82ce71e2bd45bc6e$var$ITERATOR].call(test) !== test;
});
if ($82ce71e2bd45bc6e$var$NEW_ITERATOR_PROTOTYPE) $82ce71e2bd45bc6e$var$IteratorPrototype = {};
else if ($e0409817d4e03fc4$exports) $82ce71e2bd45bc6e$var$IteratorPrototype = $5c0346dde328cc4c$exports($82ce71e2bd45bc6e$var$IteratorPrototype);
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!$70e34a5a2021f756$exports($82ce71e2bd45bc6e$var$IteratorPrototype[$82ce71e2bd45bc6e$var$ITERATOR])) $40e957865125f98f$exports($82ce71e2bd45bc6e$var$IteratorPrototype, $82ce71e2bd45bc6e$var$ITERATOR, function() {
    return this;
});
$82ce71e2bd45bc6e$exports = {
    IteratorPrototype: $82ce71e2bd45bc6e$var$IteratorPrototype,
    BUGGY_SAFARI_ITERATORS: $82ce71e2bd45bc6e$var$BUGGY_SAFARI_ITERATORS
};


var $2428e9d9593354c3$require$IteratorPrototype = $82ce71e2bd45bc6e$exports.IteratorPrototype;




var $2428e9d9593354c3$var$returnThis = function() {
    return this;
};
$2428e9d9593354c3$exports = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + " Iterator";
    IteratorConstructor.prototype = $5c0346dde328cc4c$exports($2428e9d9593354c3$require$IteratorPrototype, {
        next: $b66966b48674609b$exports(+!ENUMERABLE_NEXT, next)
    });
    $3984243ae29093af$exports(IteratorConstructor, TO_STRING_TAG, false, true);
    $0fe0dd04b0eb22af$exports[TO_STRING_TAG] = $2428e9d9593354c3$var$returnThis;
    return IteratorConstructor;
};










var $9a73e569966b34cd$var$PROPER_FUNCTION_NAME = $81c64883d194e3b4$exports.PROPER;
var $9a73e569966b34cd$var$CONFIGURABLE_FUNCTION_NAME = $81c64883d194e3b4$exports.CONFIGURABLE;
var $9a73e569966b34cd$var$IteratorPrototype = $82ce71e2bd45bc6e$exports.IteratorPrototype;
var $9a73e569966b34cd$var$BUGGY_SAFARI_ITERATORS = $82ce71e2bd45bc6e$exports.BUGGY_SAFARI_ITERATORS;
var $9a73e569966b34cd$var$ITERATOR = $842f8f0a18746212$exports("iterator");
var $9a73e569966b34cd$var$KEYS = "keys";
var $9a73e569966b34cd$var$VALUES = "values";
var $9a73e569966b34cd$var$ENTRIES = "entries";
var $9a73e569966b34cd$var$returnThis = function() {
    return this;
};
$9a73e569966b34cd$exports = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $2428e9d9593354c3$exports(IteratorConstructor, NAME, next);
    var getIterationMethod = function(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$9a73e569966b34cd$var$BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $9a73e569966b34cd$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $9a73e569966b34cd$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $9a73e569966b34cd$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + " Iterator";
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$9a73e569966b34cd$var$ITERATOR] || IterablePrototype["@@iterator"] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$9a73e569966b34cd$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME === "Array" ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $a69a130329c6de82$exports(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if (!$e0409817d4e03fc4$exports && $a69a130329c6de82$exports(CurrentIteratorPrototype) !== $9a73e569966b34cd$var$IteratorPrototype) {
                if ($5e6994558f51b773$exports) $5e6994558f51b773$exports(CurrentIteratorPrototype, $9a73e569966b34cd$var$IteratorPrototype);
                else if (!$70e34a5a2021f756$exports(CurrentIteratorPrototype[$9a73e569966b34cd$var$ITERATOR])) $40e957865125f98f$exports(CurrentIteratorPrototype, $9a73e569966b34cd$var$ITERATOR, $9a73e569966b34cd$var$returnThis);
            }
            // Set @@toStringTag to native iterators
            $3984243ae29093af$exports(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
            if ($e0409817d4e03fc4$exports) $0fe0dd04b0eb22af$exports[TO_STRING_TAG] = $9a73e569966b34cd$var$returnThis;
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if ($9a73e569966b34cd$var$PROPER_FUNCTION_NAME && DEFAULT === $9a73e569966b34cd$var$VALUES && nativeIterator && nativeIterator.name !== $9a73e569966b34cd$var$VALUES) {
        if (!$e0409817d4e03fc4$exports && $9a73e569966b34cd$var$CONFIGURABLE_FUNCTION_NAME) $8693737507995841$exports(IterablePrototype, "name", $9a73e569966b34cd$var$VALUES);
        else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return $881ad37dbe259e8f$exports(nativeIterator, this);
            };
        }
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($9a73e569966b34cd$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($9a73e569966b34cd$var$KEYS),
            entries: getIterationMethod($9a73e569966b34cd$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($9a73e569966b34cd$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $40e957865125f98f$exports(IterablePrototype, KEY, methods[KEY]);
        } else $ca3e1754e676956d$exports({
            target: NAME,
            proto: true,
            forced: $9a73e569966b34cd$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if ((!$e0409817d4e03fc4$exports || FORCED) && IterablePrototype[$9a73e569966b34cd$var$ITERATOR] !== defaultIterator) $40e957865125f98f$exports(IterablePrototype, $9a73e569966b34cd$var$ITERATOR, defaultIterator, {
        name: DEFAULT
    });
    $0fe0dd04b0eb22af$exports[NAME] = defaultIterator;
    return methods;
};


var $dfab5f5c406cd291$exports = {};
"use strict";
// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
$dfab5f5c406cd291$exports = function(value, done) {
    return {
        value: value,
        done: done
    };
};


var $0df731b64ad8eead$exports = {};
"use strict";




var $0df731b64ad8eead$var$SPECIES = $842f8f0a18746212$exports("species");
$0df731b64ad8eead$exports = function(CONSTRUCTOR_NAME) {
    var Constructor = $a5217dbd1b0d33ce$exports(CONSTRUCTOR_NAME);
    if ($ef322a7f89c3ed41$exports && Constructor && !Constructor[$0df731b64ad8eead$var$SPECIES]) $74a6fb831e72713b$exports(Constructor, $0df731b64ad8eead$var$SPECIES, {
        configurable: true,
        get: function() {
            return this;
        }
    });
};




var $941be47da6423263$require$fastKey = $0a7dfd4ed285865b$exports.fastKey;

var $941be47da6423263$var$setInternalState = $3a8bcef306e86159$exports.set;
var $941be47da6423263$var$internalStateGetterFor = $3a8bcef306e86159$exports.getterFor;
$941be47da6423263$exports = {
    getConstructor: function(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
        var Constructor = wrapper(function(that, iterable) {
            $85de2a4f93f1c485$exports(that, Prototype);
            $941be47da6423263$var$setInternalState(that, {
                type: CONSTRUCTOR_NAME,
                index: $5c0346dde328cc4c$exports(null),
                first: null,
                last: null,
                size: 0
            });
            if (!$ef322a7f89c3ed41$exports) that.size = 0;
            if (!$7ce250ddf7b42d4d$exports(iterable)) $a78806ef4ebb6167$exports(iterable, that[ADDER], {
                that: that,
                AS_ENTRIES: IS_MAP
            });
        });
        var Prototype = Constructor.prototype;
        var getInternalState = $941be47da6423263$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        var define = function(that, key, value) {
            var state = getInternalState(that);
            var entry = getEntry(that, key);
            var previous, index;
            // change existing entry
            if (entry) entry.value = value;
            else {
                state.last = entry = {
                    index: index = $941be47da6423263$require$fastKey(key, true),
                    key: key,
                    value: value,
                    previous: previous = state.last,
                    next: null,
                    removed: false
                };
                if (!state.first) state.first = entry;
                if (previous) previous.next = entry;
                if ($ef322a7f89c3ed41$exports) state.size++;
                else that.size++;
                // add to index
                if (index !== "F") state.index[index] = entry;
            }
            return that;
        };
        var getEntry = function(that, key) {
            var state = getInternalState(that);
            // fast case
            var index = $941be47da6423263$require$fastKey(key);
            var entry;
            if (index !== "F") return state.index[index];
            // frozen object case
            for(entry = state.first; entry; entry = entry.next){
                if (entry.key === key) return entry;
            }
        };
        $a3d227a61e709d75$exports(Prototype, {
            // `{ Map, Set }.prototype.clear()` methods
            // https://tc39.es/ecma262/#sec-map.prototype.clear
            // https://tc39.es/ecma262/#sec-set.prototype.clear
            clear: function clear() {
                var that = this;
                var state = getInternalState(that);
                var entry = state.first;
                while(entry){
                    entry.removed = true;
                    if (entry.previous) entry.previous = entry.previous.next = null;
                    entry = entry.next;
                }
                state.first = state.last = null;
                state.index = $5c0346dde328cc4c$exports(null);
                if ($ef322a7f89c3ed41$exports) state.size = 0;
                else that.size = 0;
            },
            // `{ Map, Set }.prototype.delete(key)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.delete
            // https://tc39.es/ecma262/#sec-set.prototype.delete
            "delete": function(key) {
                var that = this;
                var state = getInternalState(that);
                var entry = getEntry(that, key);
                if (entry) {
                    var next = entry.next;
                    var prev = entry.previous;
                    delete state.index[entry.index];
                    entry.removed = true;
                    if (prev) prev.next = next;
                    if (next) next.previous = prev;
                    if (state.first === entry) state.first = next;
                    if (state.last === entry) state.last = prev;
                    if ($ef322a7f89c3ed41$exports) state.size--;
                    else that.size--;
                }
                return !!entry;
            },
            // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.foreach
            // https://tc39.es/ecma262/#sec-set.prototype.foreach
            forEach: function forEach(callbackfn /* , that = undefined */ ) {
                var state = getInternalState(this);
                var boundFunction = $43284f0171045916$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                var entry;
                while(entry = entry ? entry.next : state.first){
                    boundFunction(entry.value, entry.key, this);
                    // revert to the last existing entry
                    while(entry && entry.removed)entry = entry.previous;
                }
            },
            // `{ Map, Set}.prototype.has(key)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.has
            // https://tc39.es/ecma262/#sec-set.prototype.has
            has: function has(key) {
                return !!getEntry(this, key);
            }
        });
        $a3d227a61e709d75$exports(Prototype, IS_MAP ? {
            // `Map.prototype.get(key)` method
            // https://tc39.es/ecma262/#sec-map.prototype.get
            get: function get(key) {
                var entry = getEntry(this, key);
                return entry && entry.value;
            },
            // `Map.prototype.set(key, value)` method
            // https://tc39.es/ecma262/#sec-map.prototype.set
            set: function set(key, value) {
                return define(this, key === 0 ? 0 : key, value);
            }
        } : {
            // `Set.prototype.add(value)` method
            // https://tc39.es/ecma262/#sec-set.prototype.add
            add: function add(value) {
                return define(this, value = value === 0 ? 0 : value, value);
            }
        });
        if ($ef322a7f89c3ed41$exports) $74a6fb831e72713b$exports(Prototype, "size", {
            configurable: true,
            get: function() {
                return getInternalState(this).size;
            }
        });
        return Constructor;
    },
    setStrong: function(Constructor, CONSTRUCTOR_NAME, IS_MAP) {
        var ITERATOR_NAME = CONSTRUCTOR_NAME + " Iterator";
        var getInternalCollectionState = $941be47da6423263$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        var getInternalIteratorState = $941be47da6423263$var$internalStateGetterFor(ITERATOR_NAME);
        // `{ Map, Set }.prototype.{ keys, values, entries, @@iterator }()` methods
        // https://tc39.es/ecma262/#sec-map.prototype.entries
        // https://tc39.es/ecma262/#sec-map.prototype.keys
        // https://tc39.es/ecma262/#sec-map.prototype.values
        // https://tc39.es/ecma262/#sec-map.prototype-@@iterator
        // https://tc39.es/ecma262/#sec-set.prototype.entries
        // https://tc39.es/ecma262/#sec-set.prototype.keys
        // https://tc39.es/ecma262/#sec-set.prototype.values
        // https://tc39.es/ecma262/#sec-set.prototype-@@iterator
        $9a73e569966b34cd$exports(Constructor, CONSTRUCTOR_NAME, function(iterated, kind) {
            $941be47da6423263$var$setInternalState(this, {
                type: ITERATOR_NAME,
                target: iterated,
                state: getInternalCollectionState(iterated),
                kind: kind,
                last: null
            });
        }, function() {
            var state = getInternalIteratorState(this);
            var kind = state.kind;
            var entry = state.last;
            // revert to the last existing entry
            while(entry && entry.removed)entry = entry.previous;
            // get next entry
            if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
                // or finish the iteration
                state.target = null;
                return $dfab5f5c406cd291$exports(undefined, true);
            }
            // return step by kind
            if (kind === "keys") return $dfab5f5c406cd291$exports(entry.key, false);
            if (kind === "values") return $dfab5f5c406cd291$exports(entry.value, false);
            return $dfab5f5c406cd291$exports([
                entry.key,
                entry.value
            ], false);
        }, IS_MAP ? "entries" : "values", !IS_MAP, true);
        // `{ Map, Set }.prototype[@@species]` accessors
        // https://tc39.es/ecma262/#sec-get-map-@@species
        // https://tc39.es/ecma262/#sec-get-set-@@species
        $0df731b64ad8eead$exports(CONSTRUCTOR_NAME);
    }
};


// `Map` constructor
// https://tc39.es/ecma262/#sec-map-objects
$6b78298c759520c1$exports("Map", function(init) {
    return function Map() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
}, $941be47da6423263$exports);




"use strict";
"use strict";






var $57377286d950d3fe$exports = {};
"use strict";



var $57377286d950d3fe$require$getWeakData = $0a7dfd4ed285865b$exports.getWeakData;





var $b83decaf38ef8d03$exports = {};
"use strict";





var $ff0c754b12dbde54$exports = {};
"use strict";
var $9f39c016fe266197$exports = {};
"use strict";
var $c73d879bf8761e55$exports = {};
"use strict";

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
$c73d879bf8761e55$exports = Array.isArray || function isArray(argument) {
    return $b0ba63bfbfb16088$exports(argument) === "Array";
};


var $1abaf8429012df1f$exports = {};
"use strict";






var $1abaf8429012df1f$var$noop = function() {};
var $1abaf8429012df1f$var$construct = $a5217dbd1b0d33ce$exports("Reflect", "construct");
var $1abaf8429012df1f$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $1abaf8429012df1f$var$exec = $43b18aa2f1faac44$exports($1abaf8429012df1f$var$constructorRegExp.exec);
var $1abaf8429012df1f$var$INCORRECT_TO_STRING = !$1abaf8429012df1f$var$constructorRegExp.test($1abaf8429012df1f$var$noop);
var $1abaf8429012df1f$var$isConstructorModern = function isConstructor(argument) {
    if (!$70e34a5a2021f756$exports(argument)) return false;
    try {
        $1abaf8429012df1f$var$construct($1abaf8429012df1f$var$noop, [], argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $1abaf8429012df1f$var$isConstructorLegacy = function isConstructor(argument) {
    if (!$70e34a5a2021f756$exports(argument)) return false;
    switch($b07c9aec2f9c74e4$exports(argument)){
        case "AsyncFunction":
        case "GeneratorFunction":
        case "AsyncGeneratorFunction":
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return $1abaf8429012df1f$var$INCORRECT_TO_STRING || !!$1abaf8429012df1f$var$exec($1abaf8429012df1f$var$constructorRegExp, $9990f6f719f26a96$exports(argument));
    } catch (error) {
        return true;
    }
};
$1abaf8429012df1f$var$isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
$1abaf8429012df1f$exports = !$1abaf8429012df1f$var$construct || $6140c9fa18232846$exports(function() {
    var called;
    return $1abaf8429012df1f$var$isConstructorModern($1abaf8429012df1f$var$isConstructorModern.call) || !$1abaf8429012df1f$var$isConstructorModern(Object) || !$1abaf8429012df1f$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $1abaf8429012df1f$var$isConstructorLegacy : $1abaf8429012df1f$var$isConstructorModern;




var $9f39c016fe266197$var$SPECIES = $842f8f0a18746212$exports("species");
var $9f39c016fe266197$var$$Array = Array;
// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
$9f39c016fe266197$exports = function(originalArray) {
    var C;
    if ($c73d879bf8761e55$exports(originalArray)) {
        C = originalArray.constructor;
        // cross-realm fallback
        if ($1abaf8429012df1f$exports(C) && (C === $9f39c016fe266197$var$$Array || $c73d879bf8761e55$exports(C.prototype))) C = undefined;
        else if ($6a130d390db46c8e$exports(C)) {
            C = C[$9f39c016fe266197$var$SPECIES];
            if (C === null) C = undefined;
        }
    }
    return C === undefined ? $9f39c016fe266197$var$$Array : C;
};


// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
$ff0c754b12dbde54$exports = function(originalArray, length) {
    return new ($9f39c016fe266197$exports(originalArray))(length === 0 ? 0 : length);
};


var $b83decaf38ef8d03$var$push = $43b18aa2f1faac44$exports([].push);
// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var $b83decaf38ef8d03$var$createMethod = function(TYPE) {
    var IS_MAP = TYPE === 1;
    var IS_FILTER = TYPE === 2;
    var IS_SOME = TYPE === 3;
    var IS_EVERY = TYPE === 4;
    var IS_FIND_INDEX = TYPE === 6;
    var IS_FILTER_REJECT = TYPE === 7;
    var NO_HOLES = TYPE === 5 || IS_FIND_INDEX;
    return function($this, callbackfn, that, specificCreate) {
        var O = $a2f3ebb5da11db12$exports($this);
        var self = $8239f4c7c6082668$exports(O);
        var length = $04c91bd3815cd64a$exports(self);
        var boundFunction = $43284f0171045916$exports(callbackfn, that);
        var index = 0;
        var create = specificCreate || $ff0c754b12dbde54$exports;
        var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
        var value, result;
        for(; length > index; index++)if (NO_HOLES || index in self) {
            value = self[index];
            result = boundFunction(value, index, O);
            if (TYPE) {
                if (IS_MAP) target[index] = result; // map
                else if (result) switch(TYPE){
                    case 3:
                        return true; // some
                    case 5:
                        return value; // find
                    case 6:
                        return index; // findIndex
                    case 2:
                        $b83decaf38ef8d03$var$push(target, value); // filter
                }
                else switch(TYPE){
                    case 4:
                        return false; // every
                    case 7:
                        $b83decaf38ef8d03$var$push(target, value); // filterReject
                }
            }
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
    };
};
$b83decaf38ef8d03$exports = {
    // `Array.prototype.forEach` method
    // https://tc39.es/ecma262/#sec-array.prototype.foreach
    forEach: $b83decaf38ef8d03$var$createMethod(0),
    // `Array.prototype.map` method
    // https://tc39.es/ecma262/#sec-array.prototype.map
    map: $b83decaf38ef8d03$var$createMethod(1),
    // `Array.prototype.filter` method
    // https://tc39.es/ecma262/#sec-array.prototype.filter
    filter: $b83decaf38ef8d03$var$createMethod(2),
    // `Array.prototype.some` method
    // https://tc39.es/ecma262/#sec-array.prototype.some
    some: $b83decaf38ef8d03$var$createMethod(3),
    // `Array.prototype.every` method
    // https://tc39.es/ecma262/#sec-array.prototype.every
    every: $b83decaf38ef8d03$var$createMethod(4),
    // `Array.prototype.find` method
    // https://tc39.es/ecma262/#sec-array.prototype.find
    find: $b83decaf38ef8d03$var$createMethod(5),
    // `Array.prototype.findIndex` method
    // https://tc39.es/ecma262/#sec-array.prototype.findIndex
    findIndex: $b83decaf38ef8d03$var$createMethod(6),
    // `Array.prototype.filterReject` method
    // https://github.com/tc39/proposal-array-filtering
    filterReject: $b83decaf38ef8d03$var$createMethod(7)
};




var $57377286d950d3fe$var$setInternalState = $3a8bcef306e86159$exports.set;
var $57377286d950d3fe$var$internalStateGetterFor = $3a8bcef306e86159$exports.getterFor;
var $57377286d950d3fe$var$find = $b83decaf38ef8d03$exports.find;
var $57377286d950d3fe$var$findIndex = $b83decaf38ef8d03$exports.findIndex;
var $57377286d950d3fe$var$splice = $43b18aa2f1faac44$exports([].splice);
var $57377286d950d3fe$var$id = 0;
// fallback for uncaught frozen keys
var $57377286d950d3fe$var$uncaughtFrozenStore = function(state) {
    return state.frozen || (state.frozen = new $57377286d950d3fe$var$UncaughtFrozenStore());
};
var $57377286d950d3fe$var$UncaughtFrozenStore = function() {
    this.entries = [];
};
var $57377286d950d3fe$var$findUncaughtFrozen = function(store, key) {
    return $57377286d950d3fe$var$find(store.entries, function(it) {
        return it[0] === key;
    });
};
$57377286d950d3fe$var$UncaughtFrozenStore.prototype = {
    get: function(key) {
        var entry = $57377286d950d3fe$var$findUncaughtFrozen(this, key);
        if (entry) return entry[1];
    },
    has: function(key) {
        return !!$57377286d950d3fe$var$findUncaughtFrozen(this, key);
    },
    set: function(key, value) {
        var entry = $57377286d950d3fe$var$findUncaughtFrozen(this, key);
        if (entry) entry[1] = value;
        else this.entries.push([
            key,
            value
        ]);
    },
    "delete": function(key) {
        var index = $57377286d950d3fe$var$findIndex(this.entries, function(it) {
            return it[0] === key;
        });
        if (~index) $57377286d950d3fe$var$splice(this.entries, index, 1);
        return !!~index;
    }
};
$57377286d950d3fe$exports = {
    getConstructor: function(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
        var Constructor = wrapper(function(that, iterable) {
            $85de2a4f93f1c485$exports(that, Prototype);
            $57377286d950d3fe$var$setInternalState(that, {
                type: CONSTRUCTOR_NAME,
                id: $57377286d950d3fe$var$id++,
                frozen: null
            });
            if (!$7ce250ddf7b42d4d$exports(iterable)) $a78806ef4ebb6167$exports(iterable, that[ADDER], {
                that: that,
                AS_ENTRIES: IS_MAP
            });
        });
        var Prototype = Constructor.prototype;
        var getInternalState = $57377286d950d3fe$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        var define = function(that, key, value) {
            var state = getInternalState(that);
            var data = $57377286d950d3fe$require$getWeakData($c845d421b7b0e630$exports(key), true);
            if (data === true) $57377286d950d3fe$var$uncaughtFrozenStore(state).set(key, value);
            else data[state.id] = value;
            return that;
        };
        $a3d227a61e709d75$exports(Prototype, {
            // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
            // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
            // https://tc39.es/ecma262/#sec-weakset.prototype.delete
            "delete": function(key) {
                var state = getInternalState(this);
                if (!$6a130d390db46c8e$exports(key)) return false;
                var data = $57377286d950d3fe$require$getWeakData(key);
                if (data === true) return $57377286d950d3fe$var$uncaughtFrozenStore(state)["delete"](key);
                return data && $1f868a26fd901990$exports(data, state.id) && delete data[state.id];
            },
            // `{ WeakMap, WeakSet }.prototype.has(key)` methods
            // https://tc39.es/ecma262/#sec-weakmap.prototype.has
            // https://tc39.es/ecma262/#sec-weakset.prototype.has
            has: function has(key) {
                var state = getInternalState(this);
                if (!$6a130d390db46c8e$exports(key)) return false;
                var data = $57377286d950d3fe$require$getWeakData(key);
                if (data === true) return $57377286d950d3fe$var$uncaughtFrozenStore(state).has(key);
                return data && $1f868a26fd901990$exports(data, state.id);
            }
        });
        $a3d227a61e709d75$exports(Prototype, IS_MAP ? {
            // `WeakMap.prototype.get(key)` method
            // https://tc39.es/ecma262/#sec-weakmap.prototype.get
            get: function get(key) {
                var state = getInternalState(this);
                if ($6a130d390db46c8e$exports(key)) {
                    var data = $57377286d950d3fe$require$getWeakData(key);
                    if (data === true) return $57377286d950d3fe$var$uncaughtFrozenStore(state).get(key);
                    if (data) return data[state.id];
                }
            },
            // `WeakMap.prototype.set(key, value)` method
            // https://tc39.es/ecma262/#sec-weakmap.prototype.set
            set: function set(key, value) {
                return define(this, key, value);
            }
        } : {
            // `WeakSet.prototype.add(value)` method
            // https://tc39.es/ecma262/#sec-weakset.prototype.add
            add: function add(value) {
                return define(this, value, true);
            }
        });
        return Constructor;
    }
};




var $341abe5437092e31$require$enforceInternalState = $3a8bcef306e86159$exports.enforce;


var $341abe5437092e31$var$$Object = Object;
// eslint-disable-next-line es/no-array-isarray -- safe
var $341abe5437092e31$var$isArray = Array.isArray;
// eslint-disable-next-line es/no-object-isextensible -- safe
var $341abe5437092e31$var$isExtensible = $341abe5437092e31$var$$Object.isExtensible;
// eslint-disable-next-line es/no-object-isfrozen -- safe
var $341abe5437092e31$var$isFrozen = $341abe5437092e31$var$$Object.isFrozen;
// eslint-disable-next-line es/no-object-issealed -- safe
var $341abe5437092e31$var$isSealed = $341abe5437092e31$var$$Object.isSealed;
// eslint-disable-next-line es/no-object-freeze -- safe
var $341abe5437092e31$var$freeze = $341abe5437092e31$var$$Object.freeze;
// eslint-disable-next-line es/no-object-seal -- safe
var $341abe5437092e31$var$seal = $341abe5437092e31$var$$Object.seal;
var $341abe5437092e31$var$IS_IE11 = !$3fbf1185731afe2b$exports.ActiveXObject && "ActiveXObject" in $3fbf1185731afe2b$exports;
var $341abe5437092e31$var$InternalWeakMap;
var $341abe5437092e31$var$wrapper = function(init) {
    return function WeakMap() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
};
// `WeakMap` constructor
// https://tc39.es/ecma262/#sec-weakmap-constructor
var $341abe5437092e31$var$$WeakMap = $6b78298c759520c1$exports("WeakMap", $341abe5437092e31$var$wrapper, $57377286d950d3fe$exports);
var $341abe5437092e31$var$WeakMapPrototype = $341abe5437092e31$var$$WeakMap.prototype;
var $341abe5437092e31$var$nativeSet = $43b18aa2f1faac44$exports($341abe5437092e31$var$WeakMapPrototype.set);
// Chakra Edge bug: adding frozen arrays to WeakMap unfreeze them
var $341abe5437092e31$var$hasMSEdgeFreezingBug = function() {
    return $ef4d4edd3daa687a$exports && $6140c9fa18232846$exports(function() {
        var frozenArray = $341abe5437092e31$var$freeze([]);
        $341abe5437092e31$var$nativeSet(new $341abe5437092e31$var$$WeakMap(), frozenArray, 1);
        return !$341abe5437092e31$var$isFrozen(frozenArray);
    });
};
// IE11 WeakMap frozen keys fix
// We can't use feature detection because it crash some old IE builds
// https://github.com/zloirock/core-js/issues/485
if ($47d53bb84a8f3c5b$exports) {
    if ($341abe5437092e31$var$IS_IE11) {
        $341abe5437092e31$var$InternalWeakMap = $57377286d950d3fe$exports.getConstructor($341abe5437092e31$var$wrapper, "WeakMap", true);
        $0a7dfd4ed285865b$exports.enable();
        var $341abe5437092e31$var$nativeDelete = $43b18aa2f1faac44$exports($341abe5437092e31$var$WeakMapPrototype["delete"]);
        var $341abe5437092e31$var$nativeHas = $43b18aa2f1faac44$exports($341abe5437092e31$var$WeakMapPrototype.has);
        var $341abe5437092e31$var$nativeGet = $43b18aa2f1faac44$exports($341abe5437092e31$var$WeakMapPrototype.get);
        $a3d227a61e709d75$exports($341abe5437092e31$var$WeakMapPrototype, {
            "delete": function(key) {
                if ($6a130d390db46c8e$exports(key) && !$341abe5437092e31$var$isExtensible(key)) {
                    var state = $341abe5437092e31$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $341abe5437092e31$var$InternalWeakMap();
                    return $341abe5437092e31$var$nativeDelete(this, key) || state.frozen["delete"](key);
                }
                return $341abe5437092e31$var$nativeDelete(this, key);
            },
            has: function has(key) {
                if ($6a130d390db46c8e$exports(key) && !$341abe5437092e31$var$isExtensible(key)) {
                    var state = $341abe5437092e31$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $341abe5437092e31$var$InternalWeakMap();
                    return $341abe5437092e31$var$nativeHas(this, key) || state.frozen.has(key);
                }
                return $341abe5437092e31$var$nativeHas(this, key);
            },
            get: function get(key) {
                if ($6a130d390db46c8e$exports(key) && !$341abe5437092e31$var$isExtensible(key)) {
                    var state = $341abe5437092e31$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $341abe5437092e31$var$InternalWeakMap();
                    return $341abe5437092e31$var$nativeHas(this, key) ? $341abe5437092e31$var$nativeGet(this, key) : state.frozen.get(key);
                }
                return $341abe5437092e31$var$nativeGet(this, key);
            },
            set: function set(key, value) {
                if ($6a130d390db46c8e$exports(key) && !$341abe5437092e31$var$isExtensible(key)) {
                    var state = $341abe5437092e31$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $341abe5437092e31$var$InternalWeakMap();
                    $341abe5437092e31$var$nativeHas(this, key) ? $341abe5437092e31$var$nativeSet(this, key, value) : state.frozen.set(key, value);
                } else $341abe5437092e31$var$nativeSet(this, key, value);
                return this;
            }
        });
    // Chakra Edge frozen keys fix
    } else if ($341abe5437092e31$var$hasMSEdgeFreezingBug()) $a3d227a61e709d75$exports($341abe5437092e31$var$WeakMapPrototype, {
        set: function set(key, value) {
            var arrayIntegrityLevel;
            if ($341abe5437092e31$var$isArray(key)) {
                if ($341abe5437092e31$var$isFrozen(key)) arrayIntegrityLevel = $341abe5437092e31$var$freeze;
                else if ($341abe5437092e31$var$isSealed(key)) arrayIntegrityLevel = $341abe5437092e31$var$seal;
            }
            $341abe5437092e31$var$nativeSet(this, key, value);
            if (arrayIntegrityLevel) arrayIntegrityLevel(key);
            return this;
        }
    });
}







var $e12f552938f6c28b$var$$Object = Object;
var $e12f552938f6c28b$var$$TypeError = TypeError;
var $e12f552938f6c28b$var$Map = $a5217dbd1b0d33ce$exports("Map");
var $e12f552938f6c28b$var$WeakMap = $a5217dbd1b0d33ce$exports("WeakMap");
var $e12f552938f6c28b$var$Node = function() {
    // keys
    this.object = null;
    this.symbol = null;
    // child nodes
    this.primitives = null;
    this.objectsByIndex = $5c0346dde328cc4c$exports(null);
};
$e12f552938f6c28b$var$Node.prototype.get = function(key, initializer) {
    return this[key] || (this[key] = initializer());
};
$e12f552938f6c28b$var$Node.prototype.next = function(i, it, IS_OBJECT) {
    var store = IS_OBJECT ? this.objectsByIndex[i] || (this.objectsByIndex[i] = new $e12f552938f6c28b$var$WeakMap()) : this.primitives || (this.primitives = new $e12f552938f6c28b$var$Map());
    var entry = store.get(it);
    if (!entry) store.set(it, entry = new $e12f552938f6c28b$var$Node());
    return entry;
};
var $e12f552938f6c28b$var$root = new $e12f552938f6c28b$var$Node();
$e12f552938f6c28b$exports = function() {
    var active = $e12f552938f6c28b$var$root;
    var length = arguments.length;
    var i, it;
    // for prevent leaking, start from objects
    for(i = 0; i < length; i++)if ($6a130d390db46c8e$exports(it = arguments[i])) active = active.next(i, it, true);
    if (this === $e12f552938f6c28b$var$$Object && active === $e12f552938f6c28b$var$root) throw new $e12f552938f6c28b$var$$TypeError("Composite keys must contain a non-primitive component");
    for(i = 0; i < length; i++)if (!$6a130d390db46c8e$exports(it = arguments[i])) active = active.next(i, it, false);
    return active;
};




var $ce0417b2220ce615$var$$Object = Object;
var $ce0417b2220ce615$var$initializer = function() {
    var freeze = $a5217dbd1b0d33ce$exports("Object", "freeze");
    return freeze ? freeze($5c0346dde328cc4c$exports(null)) : $5c0346dde328cc4c$exports(null);
};
// https://github.com/tc39/proposal-richer-keys/tree/master/compositeKey
$ca3e1754e676956d$exports({
    global: true,
    forced: true
}, {
    compositeKey: function compositeKey() {
        return $3cdb2ef65d8e3cb5$exports($e12f552938f6c28b$exports, $ce0417b2220ce615$var$$Object, arguments).get("object", $ce0417b2220ce615$var$initializer);
    }
});


"use strict";




// https://github.com/tc39/proposal-richer-keys/tree/master/compositeKey
$ca3e1754e676956d$exports({
    global: true,
    forced: true
}, {
    compositeSymbol: function compositeSymbol() {
        if (arguments.length === 1 && typeof arguments[0] == "string") return $a5217dbd1b0d33ce$exports("Symbol")["for"](arguments[0]);
        return $3cdb2ef65d8e3cb5$exports($e12f552938f6c28b$exports, null, arguments).get("symbol", $a5217dbd1b0d33ce$exports("Symbol"));
    }
});


"use strict";

var $a39ae7ae5ecd9c38$exports = {};
"use strict";
var $e055c888a6d66079$exports = {};
"use strict";

// eslint-disable-next-line es/no-map -- safe
var $e055c888a6d66079$var$MapPrototype = Map.prototype;
$e055c888a6d66079$exports = {
    // eslint-disable-next-line es/no-map -- safe
    Map: Map,
    set: $43b18aa2f1faac44$exports($e055c888a6d66079$var$MapPrototype.set),
    get: $43b18aa2f1faac44$exports($e055c888a6d66079$var$MapPrototype.get),
    has: $43b18aa2f1faac44$exports($e055c888a6d66079$var$MapPrototype.has),
    remove: $43b18aa2f1faac44$exports($e055c888a6d66079$var$MapPrototype["delete"]),
    proto: $e055c888a6d66079$var$MapPrototype
};


var $a39ae7ae5ecd9c38$require$has = $e055c888a6d66079$exports.has;
// Perform ? RequireInternalSlot(M, [[MapData]])
$a39ae7ae5ecd9c38$exports = function(it) {
    $a39ae7ae5ecd9c38$require$has(it);
    return it;
};



var $d3b2d4177c8bb8cf$require$remove = $e055c888a6d66079$exports.remove;
// `Map.prototype.deleteAll` method
// https://github.com/tc39/proposal-collection-methods
$ca3e1754e676956d$exports({
    target: "Map",
    proto: true,
    real: true,
    forced: true
}, {
    deleteAll: function deleteAll() {
        var collection = $a39ae7ae5ecd9c38$exports(this);
        var allDeleted = true;
        var wasDeleted;
        for(var k = 0, len = arguments.length; k < len; k++){
            wasDeleted = $d3b2d4177c8bb8cf$require$remove(collection, arguments[k]);
            allDeleted = allDeleted && wasDeleted;
        }
        return !!allDeleted;
    }
});


"use strict";



var $4ff0f82b80a31785$exports = {};
"use strict";

var $c3b265c1265de03f$exports = {};
"use strict";

$c3b265c1265de03f$exports = function(record, fn, ITERATOR_INSTEAD_OF_RECORD) {
    var iterator = ITERATOR_INSTEAD_OF_RECORD ? record : record.iterator;
    var next = record.next;
    var step, result;
    while(!(step = $881ad37dbe259e8f$exports(next, iterator)).done){
        result = fn(step.value);
        if (result !== undefined) return result;
    }
};



var $4ff0f82b80a31785$var$Map = $e055c888a6d66079$exports.Map;
var $4ff0f82b80a31785$var$MapPrototype = $e055c888a6d66079$exports.proto;
var $4ff0f82b80a31785$var$forEach = $43b18aa2f1faac44$exports($4ff0f82b80a31785$var$MapPrototype.forEach);
var $4ff0f82b80a31785$var$entries = $43b18aa2f1faac44$exports($4ff0f82b80a31785$var$MapPrototype.entries);
var $4ff0f82b80a31785$var$next = $4ff0f82b80a31785$var$entries(new $4ff0f82b80a31785$var$Map()).next;
$4ff0f82b80a31785$exports = function(map, fn, interruptible) {
    return interruptible ? $c3b265c1265de03f$exports({
        iterator: $4ff0f82b80a31785$var$entries(map),
        next: $4ff0f82b80a31785$var$next
    }, function(entry) {
        return fn(entry[1], entry[0]);
    }) : $4ff0f82b80a31785$var$forEach(map, fn);
};


// `Map.prototype.every` method
// https://github.com/tc39/proposal-collection-methods
$ca3e1754e676956d$exports({
    target: "Map",
    proto: true,
    real: true,
    forced: true
}, {
    every: function every(callbackfn /* , thisArg */ ) {
        var map = $a39ae7ae5ecd9c38$exports(this);
        var boundFunction = $43284f0171045916$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        return $4ff0f82b80a31785$exports(map, function(value, key) {
            if (!boundFunction(value, key, map)) return false;
        }, true) !== false;
    }
});


"use strict";





var $ea55e810e162ec8e$var$Map = $e055c888a6d66079$exports.Map;
var $ea55e810e162ec8e$var$set = $e055c888a6d66079$exports.set;
// `Map.prototype.filter` method
// https://github.com/tc39/proposal-collection-methods
$ca3e1754e676956d$exports({
    target: "Map",
    proto: true,
    real: true,
    forced: true
}, {
    filter: function filter(callbackfn /* , thisArg */ ) {
        var map = $a39ae7ae5ecd9c38$exports(this);
        var boundFunction = $43284f0171045916$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var newMap = new $ea55e810e162ec8e$var$Map();
        $4ff0f82b80a31785$exports(map, function(value, key) {
            if (boundFunction(value, key, map)) $ea55e810e162ec8e$var$set(newMap, key, value);
        });
        return newMap;
    }
});


"use strict";




// `Map.prototype.find` method
// https://github.com/tc39/proposal-collection-methods
$ca3e1754e676956d$exports({
    target: "Map",
    proto: true,
    real: true,
    forced: true
}, {
    find: function find(callbackfn /* , thisArg */ ) {
        var map = $a39ae7ae5ecd9c38$exports(this);
        var boundFunction = $43284f0171045916$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var result = $4ff0f82b80a31785$exports(map, function(value, key) {
            if (boundFunction(value, key, map)) return {
                value: value
            };
        }, true);
        return result && result.value;
    }
});


"use strict";




// `Map.prototype.findKey` method
// https://github.com/tc39/proposal-collection-methods
$ca3e1754e676956d$exports({
    target: "Map",
    proto: true,
    real: true,
    forced: true
}, {
    findKey: function findKey(callbackfn /* , thisArg */ ) {
        var map = $a39ae7ae5ecd9c38$exports(this);
        var boundFunction = $43284f0171045916$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var result = $4ff0f82b80a31785$exports(map, function(value, key) {
            if (boundFunction(value, key, map)) return {
                key: key
            };
        }, true);
        return result && result.key;
    }
});


"use strict";


var $0026225b23b40e5f$exports = {};
"use strict";




$0026225b23b40e5f$exports = function(C, adder, ENTRY) {
    return function from(source /* , mapFn, thisArg */ ) {
        var O = $a2f3ebb5da11db12$exports(source);
        var length = arguments.length;
        var mapFn = length > 1 ? arguments[1] : undefined;
        var mapping = mapFn !== undefined;
        var boundFunction = mapping ? $43284f0171045916$exports(mapFn, length > 2 ? arguments[2] : undefined) : undefined;
        var result = new C();
        var n = 0;
        $a78806ef4ebb6167$exports(O, function(nextItem) {
            var entry = mapping ? boundFunction(nextItem, n++) : nextItem;
            if (ENTRY) adder(result, $c845d421b7b0e630$exports(entry)[0], entry[1]);
            else adder(result, entry);
        });
        return result;
    };
};


// `Map.from` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
$ca3e1754e676956d$exports({
    target: "Map",
    stat: true,
    forced: true
}, {
    from: $0026225b23b40e5f$exports($e055c888a6d66079$exports.Map, $e055c888a6d66079$exports.set, true)
});


"use strict";
"use strict";








var $37e12fa6c9b33441$var$Map = $e055c888a6d66079$exports.Map;
var $37e12fa6c9b33441$var$has = $e055c888a6d66079$exports.has;
var $37e12fa6c9b33441$var$get = $e055c888a6d66079$exports.get;
var $37e12fa6c9b33441$var$set = $e055c888a6d66079$exports.set;
var $37e12fa6c9b33441$var$push = $43b18aa2f1faac44$exports([].push);
var $37e12fa6c9b33441$var$DOES_NOT_WORK_WITH_PRIMITIVES = $e0409817d4e03fc4$exports || $6140c9fa18232846$exports(function() {
    return $37e12fa6c9b33441$var$Map.groupBy("ab", function(it) {
        return it;
    }).get("a").length !== 1;
});
// `Map.groupBy` method
// https://github.com/tc39/proposal-array-grouping
$ca3e1754e676956d$exports({
    target: "Map",
    stat: true,
    forced: $e0409817d4e03fc4$exports || $37e12fa6c9b33441$var$DOES_NOT_WORK_WITH_PRIMITIVES
}, {
    groupBy: function groupBy(items, callbackfn) {
        $c378177673193450$exports(items);
        $ae485921c5498156$exports(callbackfn);
        var map = new $37e12fa6c9b33441$var$Map();
        var k = 0;
        $a78806ef4ebb6167$exports(items, function(value) {
            var key = callbackfn(value, k++);
            if (!$37e12fa6c9b33441$var$has(map, key)) $37e12fa6c9b33441$var$set(map, key, [
                value
            ]);
            else $37e12fa6c9b33441$var$push($37e12fa6c9b33441$var$get(map, key), value);
        });
        return map;
    }
});




"use strict";

var $68a6fb62059d5265$exports = {};
"use strict";
// `SameValueZero` abstract operation
// https://tc39.es/ecma262/#sec-samevaluezero
$68a6fb62059d5265$exports = function(x, y) {
    // eslint-disable-next-line no-self-compare -- NaN check
    return x === y || x !== x && y !== y;
};




// `Map.prototype.includes` method
// https://github.com/tc39/proposal-collection-methods
$ca3e1754e676956d$exports({
    target: "Map",
    proto: true,
    real: true,
    forced: true
}, {
    includes: function includes(searchElement) {
        return $4ff0f82b80a31785$exports($a39ae7ae5ecd9c38$exports(this), function(value) {
            if ($68a6fb62059d5265$exports(value, searchElement)) return true;
        }, true) === true;
    }
});


"use strict";






var $ccd66d5459d00cb6$require$Map = $e055c888a6d66079$exports.Map;
// `Map.keyBy` method
// https://github.com/tc39/proposal-collection-methods
$ca3e1754e676956d$exports({
    target: "Map",
    stat: true,
    forced: true
}, {
    keyBy: function keyBy(iterable, keyDerivative) {
        var C = $70e34a5a2021f756$exports(this) ? this : $ccd66d5459d00cb6$require$Map;
        var newMap = new C();
        $ae485921c5498156$exports(keyDerivative);
        var setter = $ae485921c5498156$exports(newMap.set);
        $a78806ef4ebb6167$exports(iterable, function(element) {
            $881ad37dbe259e8f$exports(setter, newMap, keyDerivative(element), element);
        });
        return newMap;
    }
});


"use strict";



// `Map.prototype.keyOf` method
// https://github.com/tc39/proposal-collection-methods
$ca3e1754e676956d$exports({
    target: "Map",
    proto: true,
    real: true,
    forced: true
}, {
    keyOf: function keyOf(searchElement) {
        var result = $4ff0f82b80a31785$exports($a39ae7ae5ecd9c38$exports(this), function(value, key) {
            if (value === searchElement) return {
                key: key
            };
        }, true);
        return result && result.key;
    }
});


"use strict";





var $2d215c3a160ec6d3$var$Map = $e055c888a6d66079$exports.Map;
var $2d215c3a160ec6d3$var$set = $e055c888a6d66079$exports.set;
// `Map.prototype.mapKeys` method
// https://github.com/tc39/proposal-collection-methods
$ca3e1754e676956d$exports({
    target: "Map",
    proto: true,
    real: true,
    forced: true
}, {
    mapKeys: function mapKeys(callbackfn /* , thisArg */ ) {
        var map = $a39ae7ae5ecd9c38$exports(this);
        var boundFunction = $43284f0171045916$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var newMap = new $2d215c3a160ec6d3$var$Map();
        $4ff0f82b80a31785$exports(map, function(value, key) {
            $2d215c3a160ec6d3$var$set(newMap, boundFunction(value, key, map), value);
        });
        return newMap;
    }
});


"use strict";





var $4f84e6bb9ed6fc72$var$Map = $e055c888a6d66079$exports.Map;
var $4f84e6bb9ed6fc72$var$set = $e055c888a6d66079$exports.set;
// `Map.prototype.mapValues` method
// https://github.com/tc39/proposal-collection-methods
$ca3e1754e676956d$exports({
    target: "Map",
    proto: true,
    real: true,
    forced: true
}, {
    mapValues: function mapValues(callbackfn /* , thisArg */ ) {
        var map = $a39ae7ae5ecd9c38$exports(this);
        var boundFunction = $43284f0171045916$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var newMap = new $4f84e6bb9ed6fc72$var$Map();
        $4ff0f82b80a31785$exports(map, function(value, key) {
            $4f84e6bb9ed6fc72$var$set(newMap, key, boundFunction(value, key, map));
        });
        return newMap;
    }
});


"use strict";




var $f683faf8deb6b58b$require$set = $e055c888a6d66079$exports.set;
// `Map.prototype.merge` method
// https://github.com/tc39/proposal-collection-methods
$ca3e1754e676956d$exports({
    target: "Map",
    proto: true,
    real: true,
    arity: 1,
    forced: true
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    merge: function merge(iterable /* ...iterables */ ) {
        var map = $a39ae7ae5ecd9c38$exports(this);
        var argumentsLength = arguments.length;
        var i = 0;
        while(i < argumentsLength)$a78806ef4ebb6167$exports(arguments[i++], function(key, value) {
            $f683faf8deb6b58b$require$set(map, key, value);
        }, {
            AS_ENTRIES: true
        });
        return map;
    }
});


"use strict";


var $2bf4af15edd92228$exports = {};
"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
$2bf4af15edd92228$exports = function(C, adder, ENTRY) {
    return function of() {
        var result = new C();
        var length = arguments.length;
        for(var index = 0; index < length; index++){
            var entry = arguments[index];
            if (ENTRY) adder(result, $c845d421b7b0e630$exports(entry)[0], entry[1]);
            else adder(result, entry);
        }
        return result;
    };
};


// `Map.of` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
$ca3e1754e676956d$exports({
    target: "Map",
    stat: true,
    forced: true
}, {
    of: $2bf4af15edd92228$exports($e055c888a6d66079$exports.Map, $e055c888a6d66079$exports.set, true)
});


"use strict";




var $f80490e878d93f5c$var$$TypeError = TypeError;
// `Map.prototype.reduce` method
// https://github.com/tc39/proposal-collection-methods
$ca3e1754e676956d$exports({
    target: "Map",
    proto: true,
    real: true,
    forced: true
}, {
    reduce: function reduce(callbackfn /* , initialValue */ ) {
        var map = $a39ae7ae5ecd9c38$exports(this);
        var noInitial = arguments.length < 2;
        var accumulator = noInitial ? undefined : arguments[1];
        $ae485921c5498156$exports(callbackfn);
        $4ff0f82b80a31785$exports(map, function(value, key) {
            if (noInitial) {
                noInitial = false;
                accumulator = value;
            } else accumulator = callbackfn(accumulator, value, key, map);
        });
        if (noInitial) throw new $f80490e878d93f5c$var$$TypeError("Reduce of empty map with no initial value");
        return accumulator;
    }
});


"use strict";




// `Map.prototype.some` method
// https://github.com/tc39/proposal-collection-methods
$ca3e1754e676956d$exports({
    target: "Map",
    proto: true,
    real: true,
    forced: true
}, {
    some: function some(callbackfn /* , thisArg */ ) {
        var map = $a39ae7ae5ecd9c38$exports(this);
        var boundFunction = $43284f0171045916$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        return $4ff0f82b80a31785$exports(map, function(value, key) {
            if (boundFunction(value, key, map)) return true;
        }, true) === true;
    }
});


"use strict";




var $502cb96291d9f44c$var$$TypeError = TypeError;
var $502cb96291d9f44c$var$get = $e055c888a6d66079$exports.get;
var $502cb96291d9f44c$var$has = $e055c888a6d66079$exports.has;
var $502cb96291d9f44c$var$set = $e055c888a6d66079$exports.set;
// `Map.prototype.update` method
// https://github.com/tc39/proposal-collection-methods
$ca3e1754e676956d$exports({
    target: "Map",
    proto: true,
    real: true,
    forced: true
}, {
    update: function update(key, callback /* , thunk */ ) {
        var map = $a39ae7ae5ecd9c38$exports(this);
        var length = arguments.length;
        $ae485921c5498156$exports(callback);
        var isPresentInMap = $502cb96291d9f44c$var$has(map, key);
        if (!isPresentInMap && length < 3) throw new $502cb96291d9f44c$var$$TypeError("Updating absent value");
        var value = isPresentInMap ? $502cb96291d9f44c$var$get(map, key) : $ae485921c5498156$exports(length > 2 ? arguments[2] : undefined)(key, map);
        $502cb96291d9f44c$var$set(map, key, callback(value, key, map));
        return map;
    }
});


"use strict";

var $412a4e903276671c$var$min = Math.min;
var $412a4e903276671c$var$max = Math.max;
// `Math.clamp` method
// https://rwaldron.github.io/proposal-math-extensions/
$ca3e1754e676956d$exports({
    target: "Math",
    stat: true,
    forced: true
}, {
    clamp: function clamp(x, lower, upper) {
        return $412a4e903276671c$var$min(upper, $412a4e903276671c$var$max(lower, x));
    }
});


"use strict";

// `Math.DEG_PER_RAD` constant
// https://rwaldron.github.io/proposal-math-extensions/
$ca3e1754e676956d$exports({
    target: "Math",
    stat: true,
    nonConfigurable: true,
    nonWritable: true
}, {
    DEG_PER_RAD: Math.PI / 180
});


"use strict";

var $2becb7b901651b90$var$RAD_PER_DEG = 180 / Math.PI;
// `Math.degrees` method
// https://rwaldron.github.io/proposal-math-extensions/
$ca3e1754e676956d$exports({
    target: "Math",
    stat: true,
    forced: true
}, {
    degrees: function degrees(radians) {
        return radians * $2becb7b901651b90$var$RAD_PER_DEG;
    }
});


"use strict";

var $8fd01e6e30bfee20$exports = {};
"use strict";
// `Math.scale` method implementation
// https://rwaldron.github.io/proposal-math-extensions/
$8fd01e6e30bfee20$exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
    var nx = +x;
    var nInLow = +inLow;
    var nInHigh = +inHigh;
    var nOutLow = +outLow;
    var nOutHigh = +outHigh;
    // eslint-disable-next-line no-self-compare -- NaN check
    if (nx !== nx || nInLow !== nInLow || nInHigh !== nInHigh || nOutLow !== nOutLow || nOutHigh !== nOutHigh) return NaN;
    if (nx === Infinity || nx === -Infinity) return nx;
    return (nx - nInLow) * (nOutHigh - nOutLow) / (nInHigh - nInLow) + nOutLow;
};


var $dbdc440b8bcf2b92$exports = {};
"use strict";
var $d7b5efbe959018e3$exports = {};
"use strict";
var $ce4b597c505ed4be$exports = {};
"use strict";
// `Math.sign` method implementation
// https://tc39.es/ecma262/#sec-math.sign
// eslint-disable-next-line es/no-math-sign -- safe
$ce4b597c505ed4be$exports = Math.sign || function sign(x) {
    var n = +x;
    // eslint-disable-next-line no-self-compare -- NaN check
    return n === 0 || n !== n ? n : n < 0 ? -1 : 1;
};


var $d7b5efbe959018e3$var$abs = Math.abs;
var $d7b5efbe959018e3$var$EPSILON = 2.220446049250313e-16; // Number.EPSILON
var $d7b5efbe959018e3$var$INVERSE_EPSILON = 1 / $d7b5efbe959018e3$var$EPSILON;
var $d7b5efbe959018e3$var$roundTiesToEven = function(n) {
    return n + $d7b5efbe959018e3$var$INVERSE_EPSILON - $d7b5efbe959018e3$var$INVERSE_EPSILON;
};
$d7b5efbe959018e3$exports = function(x, FLOAT_EPSILON, FLOAT_MAX_VALUE, FLOAT_MIN_VALUE) {
    var n = +x;
    var absolute = $d7b5efbe959018e3$var$abs(n);
    var s = $ce4b597c505ed4be$exports(n);
    if (absolute < FLOAT_MIN_VALUE) return s * $d7b5efbe959018e3$var$roundTiesToEven(absolute / FLOAT_MIN_VALUE / FLOAT_EPSILON) * FLOAT_MIN_VALUE * FLOAT_EPSILON;
    var a = (1 + FLOAT_EPSILON / $d7b5efbe959018e3$var$EPSILON) * absolute;
    var result = a - (a - absolute);
    // eslint-disable-next-line no-self-compare -- NaN check
    if (result > FLOAT_MAX_VALUE || result !== result) return s * Infinity;
    return s * result;
};


var $dbdc440b8bcf2b92$var$FLOAT32_EPSILON = 1.1920928955078125e-7; // 2 ** -23;
var $dbdc440b8bcf2b92$var$FLOAT32_MAX_VALUE = 3.4028234663852886e+38; // 2 ** 128 - 2 ** 104
var $dbdc440b8bcf2b92$var$FLOAT32_MIN_VALUE = 1.1754943508222875e-38; // 2 ** -126;
// `Math.fround` method implementation
// https://tc39.es/ecma262/#sec-math.fround
// eslint-disable-next-line es/no-math-fround -- safe
$dbdc440b8bcf2b92$exports = Math.fround || function fround(x) {
    return $d7b5efbe959018e3$exports(x, $dbdc440b8bcf2b92$var$FLOAT32_EPSILON, $dbdc440b8bcf2b92$var$FLOAT32_MAX_VALUE, $dbdc440b8bcf2b92$var$FLOAT32_MIN_VALUE);
};


// `Math.fscale` method
// https://rwaldron.github.io/proposal-math-extensions/
$ca3e1754e676956d$exports({
    target: "Math",
    stat: true,
    forced: true
}, {
    fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
        return $dbdc440b8bcf2b92$exports($8fd01e6e30bfee20$exports(x, inLow, inHigh, outLow, outHigh));
    }
});


"use strict";

// `Math.iaddh` method
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
// TODO: Remove from `core-js@4`
$ca3e1754e676956d$exports({
    target: "Math",
    stat: true,
    forced: true
}, {
    iaddh: function iaddh(x0, x1, y0, y1) {
        var $x0 = x0 >>> 0;
        var $x1 = x1 >>> 0;
        var $y0 = y0 >>> 0;
        return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
    }
});


"use strict";

// `Math.imulh` method
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
// TODO: Remove from `core-js@4`
$ca3e1754e676956d$exports({
    target: "Math",
    stat: true,
    forced: true
}, {
    imulh: function imulh(u, v) {
        var UINT16 = 0xFFFF;
        var $u = +u;
        var $v = +v;
        var u0 = $u & UINT16;
        var v0 = $v & UINT16;
        var u1 = $u >> 16;
        var v1 = $v >> 16;
        var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
        return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
    }
});


"use strict";

// `Math.isubh` method
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
// TODO: Remove from `core-js@4`
$ca3e1754e676956d$exports({
    target: "Math",
    stat: true,
    forced: true
}, {
    isubh: function isubh(x0, x1, y0, y1) {
        var $x0 = x0 >>> 0;
        var $x1 = x1 >>> 0;
        var $y0 = y0 >>> 0;
        return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
    }
});


"use strict";

// `Math.RAD_PER_DEG` constant
// https://rwaldron.github.io/proposal-math-extensions/
$ca3e1754e676956d$exports({
    target: "Math",
    stat: true,
    nonConfigurable: true,
    nonWritable: true
}, {
    RAD_PER_DEG: 180 / Math.PI
});


"use strict";

var $5bbfbf40a68377f9$var$DEG_PER_RAD = Math.PI / 180;
// `Math.radians` method
// https://rwaldron.github.io/proposal-math-extensions/
$ca3e1754e676956d$exports({
    target: "Math",
    stat: true,
    forced: true
}, {
    radians: function radians(degrees) {
        return degrees * $5bbfbf40a68377f9$var$DEG_PER_RAD;
    }
});


"use strict";


// `Math.scale` method
// https://rwaldron.github.io/proposal-math-extensions/
$ca3e1754e676956d$exports({
    target: "Math",
    stat: true,
    forced: true
}, {
    scale: $8fd01e6e30bfee20$exports
});


"use strict";


var $aa518c863f46227d$exports = {};
"use strict";

var $aa518c863f46227d$var$globalIsFinite = $3fbf1185731afe2b$exports.isFinite;
// `Number.isFinite` method
// https://tc39.es/ecma262/#sec-number.isfinite
// eslint-disable-next-line es/no-number-isfinite -- safe
$aa518c863f46227d$exports = Number.isFinite || function isFinite(it) {
    return typeof it == "number" && $aa518c863f46227d$var$globalIsFinite(it);
};





var $2530f6348992d8a0$var$SEEDED_RANDOM = "Seeded Random";
var $2530f6348992d8a0$var$SEEDED_RANDOM_GENERATOR = $2530f6348992d8a0$var$SEEDED_RANDOM + " Generator";
var $2530f6348992d8a0$var$SEED_TYPE_ERROR = 'Math.seededPRNG() argument should have a "seed" field with a finite value.';
var $2530f6348992d8a0$var$setInternalState = $3a8bcef306e86159$exports.set;
var $2530f6348992d8a0$var$getInternalState = $3a8bcef306e86159$exports.getterFor($2530f6348992d8a0$var$SEEDED_RANDOM_GENERATOR);
var $2530f6348992d8a0$var$$TypeError = TypeError;
var $2530f6348992d8a0$var$$SeededRandomGenerator = $2428e9d9593354c3$exports(function SeededRandomGenerator(seed) {
    $2530f6348992d8a0$var$setInternalState(this, {
        type: $2530f6348992d8a0$var$SEEDED_RANDOM_GENERATOR,
        seed: seed % 2147483647
    });
}, $2530f6348992d8a0$var$SEEDED_RANDOM, function next() {
    var state = $2530f6348992d8a0$var$getInternalState(this);
    var seed = state.seed = (state.seed * 1103515245 + 12345) % 2147483647;
    return $dfab5f5c406cd291$exports((seed & 1073741823) / 1073741823, false);
});
// `Math.seededPRNG` method
// https://github.com/tc39/proposal-seeded-random
// based on https://github.com/tc39/proposal-seeded-random/blob/78b8258835b57fc2100d076151ab506bc3202ae6/demo.html
$ca3e1754e676956d$exports({
    target: "Math",
    stat: true,
    forced: true
}, {
    seededPRNG: function seededPRNG(it) {
        var seed = $c845d421b7b0e630$exports(it).seed;
        if (!$aa518c863f46227d$exports(seed)) throw new $2530f6348992d8a0$var$$TypeError($2530f6348992d8a0$var$SEED_TYPE_ERROR);
        return new $2530f6348992d8a0$var$$SeededRandomGenerator(seed);
    }
});


"use strict";

// `Math.signbit` method
// https://github.com/tc39/proposal-Math.signbit
$ca3e1754e676956d$exports({
    target: "Math",
    stat: true,
    forced: true
}, {
    signbit: function signbit(x) {
        var n = +x;
        // eslint-disable-next-line no-self-compare -- NaN check
        return n === n && n === 0 ? 1 / n === -Infinity : n < 0;
    }
});


"use strict";

// `Math.umulh` method
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
// TODO: Remove from `core-js@4`
$ca3e1754e676956d$exports({
    target: "Math",
    stat: true,
    forced: true
}, {
    umulh: function umulh(u, v) {
        var UINT16 = 0xFFFF;
        var $u = +u;
        var $v = +v;
        var u0 = $u & UINT16;
        var v0 = $v & UINT16;
        var u1 = $u >>> 16;
        var v1 = $v >>> 16;
        var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
        return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
    }
});


"use strict";



var $7b3e4eb8ac0fb40a$var$INVALID_NUMBER_REPRESENTATION = "Invalid number representation";
var $7b3e4eb8ac0fb40a$var$INVALID_RADIX = "Invalid radix";
var $7b3e4eb8ac0fb40a$var$$RangeError = RangeError;
var $7b3e4eb8ac0fb40a$var$$SyntaxError = SyntaxError;
var $7b3e4eb8ac0fb40a$var$$TypeError = TypeError;
var $7b3e4eb8ac0fb40a$var$$parseInt = parseInt;
var $7b3e4eb8ac0fb40a$var$pow = Math.pow;
var $7b3e4eb8ac0fb40a$var$valid = /^[\d.a-z]+$/;
var $7b3e4eb8ac0fb40a$var$charAt = $43b18aa2f1faac44$exports("".charAt);
var $7b3e4eb8ac0fb40a$var$exec = $43b18aa2f1faac44$exports($7b3e4eb8ac0fb40a$var$valid.exec);
var $7b3e4eb8ac0fb40a$var$numberToString = $43b18aa2f1faac44$exports(1.0.toString);
var $7b3e4eb8ac0fb40a$var$stringSlice = $43b18aa2f1faac44$exports("".slice);
var $7b3e4eb8ac0fb40a$var$split = $43b18aa2f1faac44$exports("".split);
// `Number.fromString` method
// https://github.com/tc39/proposal-number-fromstring
$ca3e1754e676956d$exports({
    target: "Number",
    stat: true,
    forced: true
}, {
    fromString: function fromString(string, radix) {
        var sign = 1;
        if (typeof string != "string") throw new $7b3e4eb8ac0fb40a$var$$TypeError($7b3e4eb8ac0fb40a$var$INVALID_NUMBER_REPRESENTATION);
        if (!string.length) throw new $7b3e4eb8ac0fb40a$var$$SyntaxError($7b3e4eb8ac0fb40a$var$INVALID_NUMBER_REPRESENTATION);
        if ($7b3e4eb8ac0fb40a$var$charAt(string, 0) === "-") {
            sign = -1;
            string = $7b3e4eb8ac0fb40a$var$stringSlice(string, 1);
            if (!string.length) throw new $7b3e4eb8ac0fb40a$var$$SyntaxError($7b3e4eb8ac0fb40a$var$INVALID_NUMBER_REPRESENTATION);
        }
        var R = radix === undefined ? 10 : $b5bb21648546ce5b$exports(radix);
        if (R < 2 || R > 36) throw new $7b3e4eb8ac0fb40a$var$$RangeError($7b3e4eb8ac0fb40a$var$INVALID_RADIX);
        if (!$7b3e4eb8ac0fb40a$var$exec($7b3e4eb8ac0fb40a$var$valid, string)) throw new $7b3e4eb8ac0fb40a$var$$SyntaxError($7b3e4eb8ac0fb40a$var$INVALID_NUMBER_REPRESENTATION);
        var parts = $7b3e4eb8ac0fb40a$var$split(string, ".");
        var mathNum = $7b3e4eb8ac0fb40a$var$$parseInt(parts[0], R);
        if (parts.length > 1) mathNum += $7b3e4eb8ac0fb40a$var$$parseInt(parts[1], R) / $7b3e4eb8ac0fb40a$var$pow(R, parts[1].length);
        if (R === 10 && $7b3e4eb8ac0fb40a$var$numberToString(mathNum, R) !== string) throw new $7b3e4eb8ac0fb40a$var$$SyntaxError($7b3e4eb8ac0fb40a$var$INVALID_NUMBER_REPRESENTATION);
        return sign * mathNum;
    }
});


"use strict";
"use strict";














var $46baa546620d2b70$exports = {};
"use strict";
$46baa546620d2b70$exports = function(a, b) {
    try {
        // eslint-disable-next-line no-console -- safe
        arguments.length === 1 ? console.error(a) : console.error(a, b);
    } catch (error) {}
};




var $6e179f71419cf8b4$var$$$OBSERVABLE = $842f8f0a18746212$exports("observable");
var $6e179f71419cf8b4$var$OBSERVABLE = "Observable";
var $6e179f71419cf8b4$var$SUBSCRIPTION = "Subscription";
var $6e179f71419cf8b4$var$SUBSCRIPTION_OBSERVER = "SubscriptionObserver";
var $6e179f71419cf8b4$var$getterFor = $3a8bcef306e86159$exports.getterFor;
var $6e179f71419cf8b4$var$setInternalState = $3a8bcef306e86159$exports.set;
var $6e179f71419cf8b4$var$getObservableInternalState = $6e179f71419cf8b4$var$getterFor($6e179f71419cf8b4$var$OBSERVABLE);
var $6e179f71419cf8b4$var$getSubscriptionInternalState = $6e179f71419cf8b4$var$getterFor($6e179f71419cf8b4$var$SUBSCRIPTION);
var $6e179f71419cf8b4$var$getSubscriptionObserverInternalState = $6e179f71419cf8b4$var$getterFor($6e179f71419cf8b4$var$SUBSCRIPTION_OBSERVER);
var $6e179f71419cf8b4$var$SubscriptionState = function(observer) {
    this.observer = $c845d421b7b0e630$exports(observer);
    this.cleanup = null;
    this.subscriptionObserver = null;
};
$6e179f71419cf8b4$var$SubscriptionState.prototype = {
    type: $6e179f71419cf8b4$var$SUBSCRIPTION,
    clean: function() {
        var cleanup = this.cleanup;
        if (cleanup) {
            this.cleanup = null;
            try {
                cleanup();
            } catch (error) {
                $46baa546620d2b70$exports(error);
            }
        }
    },
    close: function() {
        if (!$ef322a7f89c3ed41$exports) {
            var subscription = this.facade;
            var subscriptionObserver = this.subscriptionObserver;
            subscription.closed = true;
            if (subscriptionObserver) subscriptionObserver.closed = true;
        }
        this.observer = null;
    },
    isClosed: function() {
        return this.observer === null;
    }
};
var $6e179f71419cf8b4$var$Subscription = function(observer, subscriber) {
    var subscriptionState = $6e179f71419cf8b4$var$setInternalState(this, new $6e179f71419cf8b4$var$SubscriptionState(observer));
    var start;
    if (!$ef322a7f89c3ed41$exports) this.closed = false;
    try {
        if (start = $eb80dcd0b8a5698c$exports(observer, "start")) $881ad37dbe259e8f$exports(start, observer, this);
    } catch (error) {
        $46baa546620d2b70$exports(error);
    }
    if (subscriptionState.isClosed()) return;
    var subscriptionObserver = subscriptionState.subscriptionObserver = new $6e179f71419cf8b4$var$SubscriptionObserver(subscriptionState);
    try {
        var cleanup = subscriber(subscriptionObserver);
        var subscription = cleanup;
        if (!$7ce250ddf7b42d4d$exports(cleanup)) subscriptionState.cleanup = $70e34a5a2021f756$exports(cleanup.unsubscribe) ? function() {
            subscription.unsubscribe();
        } : $ae485921c5498156$exports(cleanup);
    } catch (error) {
        subscriptionObserver.error(error);
        return;
    }
    if (subscriptionState.isClosed()) subscriptionState.clean();
};
$6e179f71419cf8b4$var$Subscription.prototype = $a3d227a61e709d75$exports({}, {
    unsubscribe: function unsubscribe() {
        var subscriptionState = $6e179f71419cf8b4$var$getSubscriptionInternalState(this);
        if (!subscriptionState.isClosed()) {
            subscriptionState.close();
            subscriptionState.clean();
        }
    }
});
if ($ef322a7f89c3ed41$exports) $74a6fb831e72713b$exports($6e179f71419cf8b4$var$Subscription.prototype, "closed", {
    configurable: true,
    get: function closed() {
        return $6e179f71419cf8b4$var$getSubscriptionInternalState(this).isClosed();
    }
});
var $6e179f71419cf8b4$var$SubscriptionObserver = function(subscriptionState) {
    $6e179f71419cf8b4$var$setInternalState(this, {
        type: $6e179f71419cf8b4$var$SUBSCRIPTION_OBSERVER,
        subscriptionState: subscriptionState
    });
    if (!$ef322a7f89c3ed41$exports) this.closed = false;
};
$6e179f71419cf8b4$var$SubscriptionObserver.prototype = $a3d227a61e709d75$exports({}, {
    next: function next(value) {
        var subscriptionState = $6e179f71419cf8b4$var$getSubscriptionObserverInternalState(this).subscriptionState;
        if (!subscriptionState.isClosed()) {
            var observer = subscriptionState.observer;
            try {
                var nextMethod = $eb80dcd0b8a5698c$exports(observer, "next");
                if (nextMethod) $881ad37dbe259e8f$exports(nextMethod, observer, value);
            } catch (error) {
                $46baa546620d2b70$exports(error);
            }
        }
    },
    error: function error(value) {
        var subscriptionState = $6e179f71419cf8b4$var$getSubscriptionObserverInternalState(this).subscriptionState;
        if (!subscriptionState.isClosed()) {
            var observer = subscriptionState.observer;
            subscriptionState.close();
            try {
                var errorMethod = $eb80dcd0b8a5698c$exports(observer, "error");
                if (errorMethod) $881ad37dbe259e8f$exports(errorMethod, observer, value);
                else $46baa546620d2b70$exports(value);
            } catch (err) {
                $46baa546620d2b70$exports(err);
            }
            subscriptionState.clean();
        }
    },
    complete: function complete() {
        var subscriptionState = $6e179f71419cf8b4$var$getSubscriptionObserverInternalState(this).subscriptionState;
        if (!subscriptionState.isClosed()) {
            var observer = subscriptionState.observer;
            subscriptionState.close();
            try {
                var completeMethod = $eb80dcd0b8a5698c$exports(observer, "complete");
                if (completeMethod) $881ad37dbe259e8f$exports(completeMethod, observer);
            } catch (error) {
                $46baa546620d2b70$exports(error);
            }
            subscriptionState.clean();
        }
    }
});
if ($ef322a7f89c3ed41$exports) $74a6fb831e72713b$exports($6e179f71419cf8b4$var$SubscriptionObserver.prototype, "closed", {
    configurable: true,
    get: function closed() {
        return $6e179f71419cf8b4$var$getSubscriptionObserverInternalState(this).subscriptionState.isClosed();
    }
});
var $6e179f71419cf8b4$var$$Observable = function Observable(subscriber) {
    $85de2a4f93f1c485$exports(this, $6e179f71419cf8b4$var$ObservablePrototype);
    $6e179f71419cf8b4$var$setInternalState(this, {
        type: $6e179f71419cf8b4$var$OBSERVABLE,
        subscriber: $ae485921c5498156$exports(subscriber)
    });
};
var $6e179f71419cf8b4$var$ObservablePrototype = $6e179f71419cf8b4$var$$Observable.prototype;
$a3d227a61e709d75$exports($6e179f71419cf8b4$var$ObservablePrototype, {
    subscribe: function subscribe(observer) {
        var length = arguments.length;
        return new $6e179f71419cf8b4$var$Subscription($70e34a5a2021f756$exports(observer) ? {
            next: observer,
            error: length > 1 ? arguments[1] : undefined,
            complete: length > 2 ? arguments[2] : undefined
        } : $6a130d390db46c8e$exports(observer) ? observer : {}, $6e179f71419cf8b4$var$getObservableInternalState(this).subscriber);
    }
});
$40e957865125f98f$exports($6e179f71419cf8b4$var$ObservablePrototype, $6e179f71419cf8b4$var$$$OBSERVABLE, function() {
    return this;
});
$ca3e1754e676956d$exports({
    global: true,
    constructor: true,
    forced: true
}, {
    Observable: $6e179f71419cf8b4$var$$Observable
});
$0df731b64ad8eead$exports($6e179f71419cf8b4$var$OBSERVABLE);


"use strict";









var $b692844f8daa9d80$var$$$OBSERVABLE = $842f8f0a18746212$exports("observable");
// `Observable.from` method
// https://github.com/tc39/proposal-observable
$ca3e1754e676956d$exports({
    target: "Observable",
    stat: true,
    forced: true
}, {
    from: function from(x) {
        var C = $1abaf8429012df1f$exports(this) ? this : $a5217dbd1b0d33ce$exports("Observable");
        var observableMethod = $eb80dcd0b8a5698c$exports($c845d421b7b0e630$exports(x), $b692844f8daa9d80$var$$$OBSERVABLE);
        if (observableMethod) {
            var observable = $c845d421b7b0e630$exports($881ad37dbe259e8f$exports(observableMethod, x));
            return observable.constructor === C ? observable : new C(function(observer) {
                return observable.subscribe(observer);
            });
        }
        var iterator = $13a4c31eee540026$exports(x);
        return new C(function(observer) {
            $a78806ef4ebb6167$exports(iterator, function(it, stop) {
                observer.next(it);
                if (observer.closed) return stop();
            }, {
                IS_ITERATOR: true,
                INTERRUPTED: true
            });
            observer.complete();
        });
    }
});


"use strict";



var $a2b413cf33342221$var$Array = $a5217dbd1b0d33ce$exports("Array");
// `Observable.of` method
// https://github.com/tc39/proposal-observable
$ca3e1754e676956d$exports({
    target: "Observable",
    stat: true,
    forced: true
}, {
    of: function of() {
        var C = $1abaf8429012df1f$exports(this) ? this : $a5217dbd1b0d33ce$exports("Observable");
        var length = arguments.length;
        var items = $a2b413cf33342221$var$Array(length);
        var index = 0;
        while(index < length)items[index] = arguments[index++];
        return new C(function(observer) {
            for(var i = 0; i < length; i++){
                observer.next(items[i]);
                if (observer.closed) return;
            }
            observer.complete();
        });
    }
});




"use strict";




// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
var $1fc464e952e6a79f$export$2d1720544b23b823;
"use strict";

var $1fc464e952e6a79f$var$$TypeError = TypeError;
var $1fc464e952e6a79f$var$PromiseCapability = function(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw new $1fc464e952e6a79f$var$$TypeError("Bad Promise constructor");
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = $ae485921c5498156$exports(resolve);
    this.reject = $ae485921c5498156$exports(reject);
};
$1fc464e952e6a79f$export$2d1720544b23b823 = function(C) {
    return new $1fc464e952e6a79f$var$PromiseCapability(C);
};



var $04575dc6f23ce661$exports = {};
"use strict";
$04575dc6f23ce661$exports = function(exec) {
    try {
        return {
            error: false,
            value: exec()
        };
    } catch (error) {
        return {
            error: true,
            value: error
        };
    }
};


var $59b6b52dff62429b$var$Promise = $3fbf1185731afe2b$exports.Promise;
var $59b6b52dff62429b$var$ACCEPT_ARGUMENTS = false;
// Avoiding the use of polyfills of the previous iteration of this proposal
// that does not accept arguments of the callback
var $59b6b52dff62429b$var$FORCED = !$59b6b52dff62429b$var$Promise || !$59b6b52dff62429b$var$Promise["try"] || $04575dc6f23ce661$exports(function() {
    $59b6b52dff62429b$var$Promise["try"](function(argument) {
        $59b6b52dff62429b$var$ACCEPT_ARGUMENTS = argument === 8;
    }, 8);
}).error || !$59b6b52dff62429b$var$ACCEPT_ARGUMENTS;
// `Promise.try` method
// https://github.com/tc39/proposal-promise-try
$ca3e1754e676956d$exports({
    target: "Promise",
    stat: true,
    forced: $59b6b52dff62429b$var$FORCED
}, {
    "try": function(callbackfn /* , ...args */ ) {
        var args = arguments.length > 1 ? $0709cba658bb4ed6$exports(arguments, 1) : [];
        var promiseCapability = $1fc464e952e6a79f$export$2d1720544b23b823(this);
        var result = $04575dc6f23ce661$exports(function() {
            return $3cdb2ef65d8e3cb5$exports($ae485921c5498156$exports(callbackfn), undefined, args);
        });
        (result.error ? promiseCapability.reject : promiseCapability.resolve)(result.value);
        return promiseCapability.promise;
    }
});


"use strict";

var $b97c096df4b0e58b$exports = {};
"use strict";





var $b97c096df4b0e58b$var$Map = $a5217dbd1b0d33ce$exports("Map");
var $b97c096df4b0e58b$var$WeakMap = $a5217dbd1b0d33ce$exports("WeakMap");
var $b97c096df4b0e58b$var$push = $43b18aa2f1faac44$exports([].push);
var $b97c096df4b0e58b$var$metadata = $1946b9b54b48e7fd$exports("metadata");
var $b97c096df4b0e58b$var$store = $b97c096df4b0e58b$var$metadata.store || ($b97c096df4b0e58b$var$metadata.store = new $b97c096df4b0e58b$var$WeakMap());
var $b97c096df4b0e58b$var$getOrCreateMetadataMap = function(target, targetKey, create) {
    var targetMetadata = $b97c096df4b0e58b$var$store.get(target);
    if (!targetMetadata) {
        if (!create) return;
        $b97c096df4b0e58b$var$store.set(target, targetMetadata = new $b97c096df4b0e58b$var$Map());
    }
    var keyMetadata = targetMetadata.get(targetKey);
    if (!keyMetadata) {
        if (!create) return;
        targetMetadata.set(targetKey, keyMetadata = new $b97c096df4b0e58b$var$Map());
    }
    return keyMetadata;
};
var $b97c096df4b0e58b$var$ordinaryHasOwnMetadata = function(MetadataKey, O, P) {
    var metadataMap = $b97c096df4b0e58b$var$getOrCreateMetadataMap(O, P, false);
    return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var $b97c096df4b0e58b$var$ordinaryGetOwnMetadata = function(MetadataKey, O, P) {
    var metadataMap = $b97c096df4b0e58b$var$getOrCreateMetadataMap(O, P, false);
    return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var $b97c096df4b0e58b$var$ordinaryDefineOwnMetadata = function(MetadataKey, MetadataValue, O, P) {
    $b97c096df4b0e58b$var$getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var $b97c096df4b0e58b$var$ordinaryOwnMetadataKeys = function(target, targetKey) {
    var metadataMap = $b97c096df4b0e58b$var$getOrCreateMetadataMap(target, targetKey, false);
    var keys = [];
    if (metadataMap) metadataMap.forEach(function(_, key) {
        $b97c096df4b0e58b$var$push(keys, key);
    });
    return keys;
};
var $b97c096df4b0e58b$var$toMetadataKey = function(it) {
    return it === undefined || typeof it == "symbol" ? it : String(it);
};
$b97c096df4b0e58b$exports = {
    store: $b97c096df4b0e58b$var$store,
    getMap: $b97c096df4b0e58b$var$getOrCreateMetadataMap,
    has: $b97c096df4b0e58b$var$ordinaryHasOwnMetadata,
    get: $b97c096df4b0e58b$var$ordinaryGetOwnMetadata,
    set: $b97c096df4b0e58b$var$ordinaryDefineOwnMetadata,
    keys: $b97c096df4b0e58b$var$ordinaryOwnMetadataKeys,
    toKey: $b97c096df4b0e58b$var$toMetadataKey
};



var $31d54640b5be68a1$var$toMetadataKey = $b97c096df4b0e58b$exports.toKey;
var $31d54640b5be68a1$var$ordinaryDefineOwnMetadata = $b97c096df4b0e58b$exports.set;
// `Reflect.defineMetadata` method
// https://github.com/rbuckton/reflect-metadata
$ca3e1754e676956d$exports({
    target: "Reflect",
    stat: true
}, {
    defineMetadata: function defineMetadata(metadataKey, metadataValue, target /* , targetKey */ ) {
        var targetKey = arguments.length < 4 ? undefined : $31d54640b5be68a1$var$toMetadataKey(arguments[3]);
        $31d54640b5be68a1$var$ordinaryDefineOwnMetadata(metadataKey, metadataValue, $c845d421b7b0e630$exports(target), targetKey);
    }
});


"use strict";



var $c0dea472571e3a69$var$toMetadataKey = $b97c096df4b0e58b$exports.toKey;
var $c0dea472571e3a69$var$getOrCreateMetadataMap = $b97c096df4b0e58b$exports.getMap;
var $c0dea472571e3a69$var$store = $b97c096df4b0e58b$exports.store;
// `Reflect.deleteMetadata` method
// https://github.com/rbuckton/reflect-metadata
$ca3e1754e676956d$exports({
    target: "Reflect",
    stat: true
}, {
    deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */ ) {
        var targetKey = arguments.length < 3 ? undefined : $c0dea472571e3a69$var$toMetadataKey(arguments[2]);
        var metadataMap = $c0dea472571e3a69$var$getOrCreateMetadataMap($c845d421b7b0e630$exports(target), targetKey, false);
        if (metadataMap === undefined || !metadataMap["delete"](metadataKey)) return false;
        if (metadataMap.size) return true;
        var targetMetadata = $c0dea472571e3a69$var$store.get(target);
        targetMetadata["delete"](targetKey);
        return !!targetMetadata.size || $c0dea472571e3a69$var$store["delete"](target);
    }
});


"use strict";




var $f00623edbf0e2abf$var$ordinaryHasOwnMetadata = $b97c096df4b0e58b$exports.has;
var $f00623edbf0e2abf$var$ordinaryGetOwnMetadata = $b97c096df4b0e58b$exports.get;
var $f00623edbf0e2abf$var$toMetadataKey = $b97c096df4b0e58b$exports.toKey;
var $f00623edbf0e2abf$var$ordinaryGetMetadata = function(MetadataKey, O, P) {
    var hasOwn = $f00623edbf0e2abf$var$ordinaryHasOwnMetadata(MetadataKey, O, P);
    if (hasOwn) return $f00623edbf0e2abf$var$ordinaryGetOwnMetadata(MetadataKey, O, P);
    var parent = $a69a130329c6de82$exports(O);
    return parent !== null ? $f00623edbf0e2abf$var$ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};
// `Reflect.getMetadata` method
// https://github.com/rbuckton/reflect-metadata
$ca3e1754e676956d$exports({
    target: "Reflect",
    stat: true
}, {
    getMetadata: function getMetadata(metadataKey, target /* , targetKey */ ) {
        var targetKey = arguments.length < 3 ? undefined : $f00623edbf0e2abf$var$toMetadataKey(arguments[2]);
        return $f00623edbf0e2abf$var$ordinaryGetMetadata(metadataKey, $c845d421b7b0e630$exports(target), targetKey);
    }
});


"use strict";





var $c9061a42f4079c73$exports = {};
"use strict";







var $c9061a42f4079c73$var$Map = $e055c888a6d66079$exports.Map;
var $c9061a42f4079c73$var$mapHas = $e055c888a6d66079$exports.has;
var $c9061a42f4079c73$var$mapSet = $e055c888a6d66079$exports.set;
var $c9061a42f4079c73$var$push = $43b18aa2f1faac44$exports([].push);
// `Array.prototype.uniqueBy` method
// https://github.com/tc39/proposal-array-unique
$c9061a42f4079c73$exports = function uniqueBy(resolver) {
    var that = $a2f3ebb5da11db12$exports(this);
    var length = $04c91bd3815cd64a$exports(that);
    var result = [];
    var map = new $c9061a42f4079c73$var$Map();
    var resolverFunction = !$7ce250ddf7b42d4d$exports(resolver) ? $ae485921c5498156$exports(resolver) : function(value) {
        return value;
    };
    var index, item, key;
    for(index = 0; index < length; index++){
        item = that[index];
        key = resolverFunction(item);
        if (!$c9061a42f4079c73$var$mapHas(map, key)) $c9061a42f4079c73$var$mapSet(map, key, item);
    }
    $4ff0f82b80a31785$exports(map, function(value) {
        $c9061a42f4079c73$var$push(result, value);
    });
    return result;
};


var $c2762de34bdcf4da$var$arrayUniqueBy = $43b18aa2f1faac44$exports($c9061a42f4079c73$exports);
var $c2762de34bdcf4da$var$concat = $43b18aa2f1faac44$exports([].concat);
var $c2762de34bdcf4da$var$ordinaryOwnMetadataKeys = $b97c096df4b0e58b$exports.keys;
var $c2762de34bdcf4da$var$toMetadataKey = $b97c096df4b0e58b$exports.toKey;
var $c2762de34bdcf4da$var$ordinaryMetadataKeys = function(O, P) {
    var oKeys = $c2762de34bdcf4da$var$ordinaryOwnMetadataKeys(O, P);
    var parent = $a69a130329c6de82$exports(O);
    if (parent === null) return oKeys;
    var pKeys = $c2762de34bdcf4da$var$ordinaryMetadataKeys(parent, P);
    return pKeys.length ? oKeys.length ? $c2762de34bdcf4da$var$arrayUniqueBy($c2762de34bdcf4da$var$concat(oKeys, pKeys)) : pKeys : oKeys;
};
// `Reflect.getMetadataKeys` method
// https://github.com/rbuckton/reflect-metadata
$ca3e1754e676956d$exports({
    target: "Reflect",
    stat: true
}, {
    getMetadataKeys: function getMetadataKeys(target /* , targetKey */ ) {
        var targetKey = arguments.length < 2 ? undefined : $c2762de34bdcf4da$var$toMetadataKey(arguments[1]);
        return $c2762de34bdcf4da$var$ordinaryMetadataKeys($c845d421b7b0e630$exports(target), targetKey);
    }
});


"use strict";



var $20787d7b927a9461$var$ordinaryGetOwnMetadata = $b97c096df4b0e58b$exports.get;
var $20787d7b927a9461$var$toMetadataKey = $b97c096df4b0e58b$exports.toKey;
// `Reflect.getOwnMetadata` method
// https://github.com/rbuckton/reflect-metadata
$ca3e1754e676956d$exports({
    target: "Reflect",
    stat: true
}, {
    getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */ ) {
        var targetKey = arguments.length < 3 ? undefined : $20787d7b927a9461$var$toMetadataKey(arguments[2]);
        return $20787d7b927a9461$var$ordinaryGetOwnMetadata(metadataKey, $c845d421b7b0e630$exports(target), targetKey);
    }
});


"use strict";



var $729002be664fa9da$var$ordinaryOwnMetadataKeys = $b97c096df4b0e58b$exports.keys;
var $729002be664fa9da$var$toMetadataKey = $b97c096df4b0e58b$exports.toKey;
// `Reflect.getOwnMetadataKeys` method
// https://github.com/rbuckton/reflect-metadata
$ca3e1754e676956d$exports({
    target: "Reflect",
    stat: true
}, {
    getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */ ) {
        var targetKey = arguments.length < 2 ? undefined : $729002be664fa9da$var$toMetadataKey(arguments[1]);
        return $729002be664fa9da$var$ordinaryOwnMetadataKeys($c845d421b7b0e630$exports(target), targetKey);
    }
});


"use strict";




var $bd7d56d22c6f063c$var$ordinaryHasOwnMetadata = $b97c096df4b0e58b$exports.has;
var $bd7d56d22c6f063c$var$toMetadataKey = $b97c096df4b0e58b$exports.toKey;
var $bd7d56d22c6f063c$var$ordinaryHasMetadata = function(MetadataKey, O, P) {
    var hasOwn = $bd7d56d22c6f063c$var$ordinaryHasOwnMetadata(MetadataKey, O, P);
    if (hasOwn) return true;
    var parent = $a69a130329c6de82$exports(O);
    return parent !== null ? $bd7d56d22c6f063c$var$ordinaryHasMetadata(MetadataKey, parent, P) : false;
};
// `Reflect.hasMetadata` method
// https://github.com/rbuckton/reflect-metadata
$ca3e1754e676956d$exports({
    target: "Reflect",
    stat: true
}, {
    hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */ ) {
        var targetKey = arguments.length < 3 ? undefined : $bd7d56d22c6f063c$var$toMetadataKey(arguments[2]);
        return $bd7d56d22c6f063c$var$ordinaryHasMetadata(metadataKey, $c845d421b7b0e630$exports(target), targetKey);
    }
});


"use strict";



var $3eb05025dc586de2$var$ordinaryHasOwnMetadata = $b97c096df4b0e58b$exports.has;
var $3eb05025dc586de2$var$toMetadataKey = $b97c096df4b0e58b$exports.toKey;
// `Reflect.hasOwnMetadata` method
// https://github.com/rbuckton/reflect-metadata
$ca3e1754e676956d$exports({
    target: "Reflect",
    stat: true
}, {
    hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */ ) {
        var targetKey = arguments.length < 3 ? undefined : $3eb05025dc586de2$var$toMetadataKey(arguments[2]);
        return $3eb05025dc586de2$var$ordinaryHasOwnMetadata(metadataKey, $c845d421b7b0e630$exports(target), targetKey);
    }
});


"use strict";



var $e51ee49c376f0001$var$toMetadataKey = $b97c096df4b0e58b$exports.toKey;
var $e51ee49c376f0001$var$ordinaryDefineOwnMetadata = $b97c096df4b0e58b$exports.set;
// `Reflect.metadata` method
// https://github.com/rbuckton/reflect-metadata
$ca3e1754e676956d$exports({
    target: "Reflect",
    stat: true
}, {
    metadata: function metadata(metadataKey, metadataValue) {
        return function decorator(target, key) {
            $e51ee49c376f0001$var$ordinaryDefineOwnMetadata(metadataKey, metadataValue, $c845d421b7b0e630$exports(target), $e51ee49c376f0001$var$toMetadataKey(key));
        };
    }
});


"use strict";

var $181da54e4761d0e8$exports = {};
"use strict";
var $f5060c84c0f60f7e$exports = {};
"use strict";

// eslint-disable-next-line es/no-set -- safe
var $f5060c84c0f60f7e$var$SetPrototype = Set.prototype;
$f5060c84c0f60f7e$exports = {
    // eslint-disable-next-line es/no-set -- safe
    Set: Set,
    add: $43b18aa2f1faac44$exports($f5060c84c0f60f7e$var$SetPrototype.add),
    has: $43b18aa2f1faac44$exports($f5060c84c0f60f7e$var$SetPrototype.has),
    remove: $43b18aa2f1faac44$exports($f5060c84c0f60f7e$var$SetPrototype["delete"]),
    proto: $f5060c84c0f60f7e$var$SetPrototype
};


var $181da54e4761d0e8$require$has = $f5060c84c0f60f7e$exports.has;
// Perform ? RequireInternalSlot(M, [[SetData]])
$181da54e4761d0e8$exports = function(it) {
    $181da54e4761d0e8$require$has(it);
    return it;
};



var $d07daff3c49c457c$require$add = $f5060c84c0f60f7e$exports.add;
// `Set.prototype.addAll` method
// https://github.com/tc39/proposal-collection-methods
$ca3e1754e676956d$exports({
    target: "Set",
    proto: true,
    real: true,
    forced: true
}, {
    addAll: function addAll() {
        var set = $181da54e4761d0e8$exports(this);
        for(var k = 0, len = arguments.length; k < len; k++)$d07daff3c49c457c$require$add(set, arguments[k]);
        return set;
    }
});


"use strict";



var $84d9e98b9d741732$require$remove = $f5060c84c0f60f7e$exports.remove;
// `Set.prototype.deleteAll` method
// https://github.com/tc39/proposal-collection-methods
$ca3e1754e676956d$exports({
    target: "Set",
    proto: true,
    real: true,
    forced: true
}, {
    deleteAll: function deleteAll() {
        var collection = $181da54e4761d0e8$exports(this);
        var allDeleted = true;
        var wasDeleted;
        for(var k = 0, len = arguments.length; k < len; k++){
            wasDeleted = $84d9e98b9d741732$require$remove(collection, arguments[k]);
            allDeleted = allDeleted && wasDeleted;
        }
        return !!allDeleted;
    }
});


"use strict";


var $b126c600f59850cf$exports = {};
"use strict";


var $965955edb258a3f2$exports = {};
"use strict";





var $965955edb258a3f2$var$ITERATOR = $842f8f0a18746212$exports("iterator");
var $965955edb258a3f2$var$$Object = Object;
$965955edb258a3f2$exports = function(it) {
    if ($7ce250ddf7b42d4d$exports(it)) return false;
    var O = $965955edb258a3f2$var$$Object(it);
    return O[$965955edb258a3f2$var$ITERATOR] !== undefined || "@@iterator" in O || $1f868a26fd901990$exports($0fe0dd04b0eb22af$exports, $b07c9aec2f9c74e4$exports(O));
};



var $b126c600f59850cf$var$Set = $a5217dbd1b0d33ce$exports("Set");
var $b126c600f59850cf$var$isSetLike = function(it) {
    return $6a130d390db46c8e$exports(it) && typeof it.size == "number" && $70e34a5a2021f756$exports(it.has) && $70e34a5a2021f756$exports(it.keys);
};
// fallback old -> new set methods proposal arguments
$b126c600f59850cf$exports = function(it) {
    if ($b126c600f59850cf$var$isSetLike(it)) return it;
    return $965955edb258a3f2$exports(it) ? new $b126c600f59850cf$var$Set(it) : it;
};


var $456984ac7dad2a58$exports = {};
"use strict";


var $d77fd3960bcf099e$exports = {};
"use strict";

var $fa8664a1252d26ee$exports = {};
"use strict";



var $fa8664a1252d26ee$var$Set = $f5060c84c0f60f7e$exports.Set;
var $fa8664a1252d26ee$var$SetPrototype = $f5060c84c0f60f7e$exports.proto;
var $fa8664a1252d26ee$var$forEach = $43b18aa2f1faac44$exports($fa8664a1252d26ee$var$SetPrototype.forEach);
var $fa8664a1252d26ee$var$keys = $43b18aa2f1faac44$exports($fa8664a1252d26ee$var$SetPrototype.keys);
var $fa8664a1252d26ee$var$next = $fa8664a1252d26ee$var$keys(new $fa8664a1252d26ee$var$Set()).next;
$fa8664a1252d26ee$exports = function(set, fn, interruptible) {
    return interruptible ? $c3b265c1265de03f$exports({
        iterator: $fa8664a1252d26ee$var$keys(set),
        next: $fa8664a1252d26ee$var$next
    }, fn) : $fa8664a1252d26ee$var$forEach(set, fn);
};


var $d77fd3960bcf099e$var$Set = $f5060c84c0f60f7e$exports.Set;
var $d77fd3960bcf099e$var$add = $f5060c84c0f60f7e$exports.add;
$d77fd3960bcf099e$exports = function(set) {
    var result = new $d77fd3960bcf099e$var$Set();
    $fa8664a1252d26ee$exports(set, function(it) {
        $d77fd3960bcf099e$var$add(result, it);
    });
    return result;
};


var $425be1cc5645690d$exports = {};
"use strict";


$425be1cc5645690d$exports = $ab274a67893419f3$exports($f5060c84c0f60f7e$exports.proto, "size", "get") || function(set) {
    return set.size;
};


var $a57ec52899092109$exports = {};
"use strict";




var $48a5733549e1760e$exports = {};
"use strict";
// `GetIteratorDirect(obj)` abstract operation
// https://tc39.es/proposal-iterator-helpers/#sec-getiteratordirect
$48a5733549e1760e$exports = function(obj) {
    return {
        iterator: obj,
        next: obj.next,
        done: false
    };
};


var $a57ec52899092109$var$INVALID_SIZE = "Invalid size";
var $a57ec52899092109$var$$RangeError = RangeError;
var $a57ec52899092109$var$$TypeError = TypeError;
var $a57ec52899092109$var$max = Math.max;
var $a57ec52899092109$var$SetRecord = function(set, intSize) {
    this.set = set;
    this.size = $a57ec52899092109$var$max(intSize, 0);
    this.has = $ae485921c5498156$exports(set.has);
    this.keys = $ae485921c5498156$exports(set.keys);
};
$a57ec52899092109$var$SetRecord.prototype = {
    getIterator: function() {
        return $48a5733549e1760e$exports($c845d421b7b0e630$exports($881ad37dbe259e8f$exports(this.keys, this.set)));
    },
    includes: function(it) {
        return $881ad37dbe259e8f$exports(this.has, this.set, it);
    }
};
// `GetSetRecord` abstract operation
// https://tc39.es/proposal-set-methods/#sec-getsetrecord
$a57ec52899092109$exports = function(obj) {
    $c845d421b7b0e630$exports(obj);
    var numSize = +obj.size;
    // NOTE: If size is undefined, then numSize will be NaN
    // eslint-disable-next-line no-self-compare -- NaN check
    if (numSize !== numSize) throw new $a57ec52899092109$var$$TypeError($a57ec52899092109$var$INVALID_SIZE);
    var intSize = $b5bb21648546ce5b$exports(numSize);
    if (intSize < 0) throw new $a57ec52899092109$var$$RangeError($a57ec52899092109$var$INVALID_SIZE);
    return new $a57ec52899092109$var$SetRecord(obj, intSize);
};




var $456984ac7dad2a58$var$has = $f5060c84c0f60f7e$exports.has;
var $456984ac7dad2a58$var$remove = $f5060c84c0f60f7e$exports.remove;
// `Set.prototype.difference` method
// https://github.com/tc39/proposal-set-methods
$456984ac7dad2a58$exports = function difference(other) {
    var O = $181da54e4761d0e8$exports(this);
    var otherRec = $a57ec52899092109$exports(other);
    var result = $d77fd3960bcf099e$exports(O);
    if ($425be1cc5645690d$exports(O) <= otherRec.size) $fa8664a1252d26ee$exports(O, function(e) {
        if (otherRec.includes(e)) $456984ac7dad2a58$var$remove(result, e);
    });
    else $c3b265c1265de03f$exports(otherRec.getIterator(), function(e) {
        if ($456984ac7dad2a58$var$has(O, e)) $456984ac7dad2a58$var$remove(result, e);
    });
    return result;
};


// `Set.prototype.difference` method
// https://github.com/tc39/proposal-set-methods
// TODO: Obsolete version, remove from `core-js@4`
$ca3e1754e676956d$exports({
    target: "Set",
    proto: true,
    real: true,
    forced: true
}, {
    difference: function difference(other) {
        return $881ad37dbe259e8f$exports($456984ac7dad2a58$exports, this, $b126c600f59850cf$exports(other));
    }
});


"use strict";




// `Set.prototype.every` method
// https://github.com/tc39/proposal-collection-methods
$ca3e1754e676956d$exports({
    target: "Set",
    proto: true,
    real: true,
    forced: true
}, {
    every: function every(callbackfn /* , thisArg */ ) {
        var set = $181da54e4761d0e8$exports(this);
        var boundFunction = $43284f0171045916$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        return $fa8664a1252d26ee$exports(set, function(value) {
            if (!boundFunction(value, value, set)) return false;
        }, true) !== false;
    }
});


"use strict";





var $0a8f56ceec8deeee$var$Set = $f5060c84c0f60f7e$exports.Set;
var $0a8f56ceec8deeee$var$add = $f5060c84c0f60f7e$exports.add;
// `Set.prototype.filter` method
// https://github.com/tc39/proposal-collection-methods
$ca3e1754e676956d$exports({
    target: "Set",
    proto: true,
    real: true,
    forced: true
}, {
    filter: function filter(callbackfn /* , thisArg */ ) {
        var set = $181da54e4761d0e8$exports(this);
        var boundFunction = $43284f0171045916$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var newSet = new $0a8f56ceec8deeee$var$Set();
        $fa8664a1252d26ee$exports(set, function(value) {
            if (boundFunction(value, value, set)) $0a8f56ceec8deeee$var$add(newSet, value);
        });
        return newSet;
    }
});


"use strict";




// `Set.prototype.find` method
// https://github.com/tc39/proposal-collection-methods
$ca3e1754e676956d$exports({
    target: "Set",
    proto: true,
    real: true,
    forced: true
}, {
    find: function find(callbackfn /* , thisArg */ ) {
        var set = $181da54e4761d0e8$exports(this);
        var boundFunction = $43284f0171045916$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var result = $fa8664a1252d26ee$exports(set, function(value) {
            if (boundFunction(value, value, set)) return {
                value: value
            };
        }, true);
        return result && result.value;
    }
});


"use strict";



// `Set.from` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
$ca3e1754e676956d$exports({
    target: "Set",
    stat: true,
    forced: true
}, {
    from: $0026225b23b40e5f$exports($f5060c84c0f60f7e$exports.Set, $f5060c84c0f60f7e$exports.add, false)
});


"use strict";



var $7c51fff376b214dd$exports = {};
"use strict";






var $7c51fff376b214dd$var$Set = $f5060c84c0f60f7e$exports.Set;
var $7c51fff376b214dd$var$add = $f5060c84c0f60f7e$exports.add;
var $7c51fff376b214dd$var$has = $f5060c84c0f60f7e$exports.has;
// `Set.prototype.intersection` method
// https://github.com/tc39/proposal-set-methods
$7c51fff376b214dd$exports = function intersection(other) {
    var O = $181da54e4761d0e8$exports(this);
    var otherRec = $a57ec52899092109$exports(other);
    var result = new $7c51fff376b214dd$var$Set();
    if ($425be1cc5645690d$exports(O) > otherRec.size) $c3b265c1265de03f$exports(otherRec.getIterator(), function(e) {
        if ($7c51fff376b214dd$var$has(O, e)) $7c51fff376b214dd$var$add(result, e);
    });
    else $fa8664a1252d26ee$exports(O, function(e) {
        if (otherRec.includes(e)) $7c51fff376b214dd$var$add(result, e);
    });
    return result;
};


// `Set.prototype.intersection` method
// https://github.com/tc39/proposal-set-methods
// TODO: Obsolete version, remove from `core-js@4`
$ca3e1754e676956d$exports({
    target: "Set",
    proto: true,
    real: true,
    forced: true
}, {
    intersection: function intersection(other) {
        return $881ad37dbe259e8f$exports($7c51fff376b214dd$exports, this, $b126c600f59850cf$exports(other));
    }
});


"use strict";



var $d0fa8e310d7bc338$exports = {};
"use strict";


var $d0fa8e310d7bc338$require$has = $f5060c84c0f60f7e$exports.has;





// `Set.prototype.isDisjointFrom` method
// https://tc39.github.io/proposal-set-methods/#Set.prototype.isDisjointFrom
$d0fa8e310d7bc338$exports = function isDisjointFrom(other) {
    var O = $181da54e4761d0e8$exports(this);
    var otherRec = $a57ec52899092109$exports(other);
    if ($425be1cc5645690d$exports(O) <= otherRec.size) return $fa8664a1252d26ee$exports(O, function(e) {
        if (otherRec.includes(e)) return false;
    }, true) !== false;
    var iterator = otherRec.getIterator();
    return $c3b265c1265de03f$exports(iterator, function(e) {
        if ($d0fa8e310d7bc338$require$has(O, e)) return $4105790cb9bf2aaa$exports(iterator, "normal", false);
    }) !== false;
};


// `Set.prototype.isDisjointFrom` method
// https://github.com/tc39/proposal-set-methods
// TODO: Obsolete version, remove from `core-js@4`
$ca3e1754e676956d$exports({
    target: "Set",
    proto: true,
    real: true,
    forced: true
}, {
    isDisjointFrom: function isDisjointFrom(other) {
        return $881ad37dbe259e8f$exports($d0fa8e310d7bc338$exports, this, $b126c600f59850cf$exports(other));
    }
});


"use strict";



var $cc6482b020a78a5f$exports = {};
"use strict";




// `Set.prototype.isSubsetOf` method
// https://tc39.github.io/proposal-set-methods/#Set.prototype.isSubsetOf
$cc6482b020a78a5f$exports = function isSubsetOf(other) {
    var O = $181da54e4761d0e8$exports(this);
    var otherRec = $a57ec52899092109$exports(other);
    if ($425be1cc5645690d$exports(O) > otherRec.size) return false;
    return $fa8664a1252d26ee$exports(O, function(e) {
        if (!otherRec.includes(e)) return false;
    }, true) !== false;
};


// `Set.prototype.isSubsetOf` method
// https://github.com/tc39/proposal-set-methods
// TODO: Obsolete version, remove from `core-js@4`
$ca3e1754e676956d$exports({
    target: "Set",
    proto: true,
    real: true,
    forced: true
}, {
    isSubsetOf: function isSubsetOf(other) {
        return $881ad37dbe259e8f$exports($cc6482b020a78a5f$exports, this, $b126c600f59850cf$exports(other));
    }
});


"use strict";



var $d824487b4bec8d7f$exports = {};
"use strict";


var $d824487b4bec8d7f$require$has = $f5060c84c0f60f7e$exports.has;




// `Set.prototype.isSupersetOf` method
// https://tc39.github.io/proposal-set-methods/#Set.prototype.isSupersetOf
$d824487b4bec8d7f$exports = function isSupersetOf(other) {
    var O = $181da54e4761d0e8$exports(this);
    var otherRec = $a57ec52899092109$exports(other);
    if ($425be1cc5645690d$exports(O) < otherRec.size) return false;
    var iterator = otherRec.getIterator();
    return $c3b265c1265de03f$exports(iterator, function(e) {
        if (!$d824487b4bec8d7f$require$has(O, e)) return $4105790cb9bf2aaa$exports(iterator, "normal", false);
    }) !== false;
};


// `Set.prototype.isSupersetOf` method
// https://github.com/tc39/proposal-set-methods
// TODO: Obsolete version, remove from `core-js@4`
$ca3e1754e676956d$exports({
    target: "Set",
    proto: true,
    real: true,
    forced: true
}, {
    isSupersetOf: function isSupersetOf(other) {
        return $881ad37dbe259e8f$exports($d824487b4bec8d7f$exports, this, $b126c600f59850cf$exports(other));
    }
});


"use strict";




var $e25aed89b5529bcb$exports = {};
"use strict";

var $e25aed89b5529bcb$var$$String = String;
$e25aed89b5529bcb$exports = function(argument) {
    if ($b07c9aec2f9c74e4$exports(argument) === "Symbol") throw new TypeError("Cannot convert a Symbol value to a string");
    return $e25aed89b5529bcb$var$$String(argument);
};


var $cd706fad0a9135e1$var$arrayJoin = $43b18aa2f1faac44$exports([].join);
var $cd706fad0a9135e1$var$push = $43b18aa2f1faac44$exports([].push);
// `Set.prototype.join` method
// https://github.com/tc39/proposal-collection-methods
$ca3e1754e676956d$exports({
    target: "Set",
    proto: true,
    real: true,
    forced: true
}, {
    join: function join(separator) {
        var set = $181da54e4761d0e8$exports(this);
        var sep = separator === undefined ? "," : $e25aed89b5529bcb$exports(separator);
        var array = [];
        $fa8664a1252d26ee$exports(set, function(value) {
            $cd706fad0a9135e1$var$push(array, value);
        });
        return $cd706fad0a9135e1$var$arrayJoin(array, sep);
    }
});


"use strict";





var $a7c147af33eabfc9$var$Set = $f5060c84c0f60f7e$exports.Set;
var $a7c147af33eabfc9$var$add = $f5060c84c0f60f7e$exports.add;
// `Set.prototype.map` method
// https://github.com/tc39/proposal-collection-methods
$ca3e1754e676956d$exports({
    target: "Set",
    proto: true,
    real: true,
    forced: true
}, {
    map: function map(callbackfn /* , thisArg */ ) {
        var set = $181da54e4761d0e8$exports(this);
        var boundFunction = $43284f0171045916$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var newSet = new $a7c147af33eabfc9$var$Set();
        $fa8664a1252d26ee$exports(set, function(value) {
            $a7c147af33eabfc9$var$add(newSet, boundFunction(value, value, set));
        });
        return newSet;
    }
});


"use strict";



// `Set.of` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
$ca3e1754e676956d$exports({
    target: "Set",
    stat: true,
    forced: true
}, {
    of: $2bf4af15edd92228$exports($f5060c84c0f60f7e$exports.Set, $f5060c84c0f60f7e$exports.add, false)
});


"use strict";




var $ac455a9431d64528$var$$TypeError = TypeError;
// `Set.prototype.reduce` method
// https://github.com/tc39/proposal-collection-methods
$ca3e1754e676956d$exports({
    target: "Set",
    proto: true,
    real: true,
    forced: true
}, {
    reduce: function reduce(callbackfn /* , initialValue */ ) {
        var set = $181da54e4761d0e8$exports(this);
        var noInitial = arguments.length < 2;
        var accumulator = noInitial ? undefined : arguments[1];
        $ae485921c5498156$exports(callbackfn);
        $fa8664a1252d26ee$exports(set, function(value) {
            if (noInitial) {
                noInitial = false;
                accumulator = value;
            } else accumulator = callbackfn(accumulator, value, value, set);
        });
        if (noInitial) throw new $ac455a9431d64528$var$$TypeError("Reduce of empty set with no initial value");
        return accumulator;
    }
});


"use strict";




// `Set.prototype.some` method
// https://github.com/tc39/proposal-collection-methods
$ca3e1754e676956d$exports({
    target: "Set",
    proto: true,
    real: true,
    forced: true
}, {
    some: function some(callbackfn /* , thisArg */ ) {
        var set = $181da54e4761d0e8$exports(this);
        var boundFunction = $43284f0171045916$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        return $fa8664a1252d26ee$exports(set, function(value) {
            if (boundFunction(value, value, set)) return true;
        }, true) === true;
    }
});


"use strict";



var $d76d05972236f5c4$exports = {};
"use strict";





var $d76d05972236f5c4$var$add = $f5060c84c0f60f7e$exports.add;
var $d76d05972236f5c4$var$has = $f5060c84c0f60f7e$exports.has;
var $d76d05972236f5c4$var$remove = $f5060c84c0f60f7e$exports.remove;
// `Set.prototype.symmetricDifference` method
// https://github.com/tc39/proposal-set-methods
$d76d05972236f5c4$exports = function symmetricDifference(other) {
    var O = $181da54e4761d0e8$exports(this);
    var keysIter = $a57ec52899092109$exports(other).getIterator();
    var result = $d77fd3960bcf099e$exports(O);
    $c3b265c1265de03f$exports(keysIter, function(e) {
        if ($d76d05972236f5c4$var$has(O, e)) $d76d05972236f5c4$var$remove(result, e);
        else $d76d05972236f5c4$var$add(result, e);
    });
    return result;
};


// `Set.prototype.symmetricDifference` method
// https://github.com/tc39/proposal-set-methods
// TODO: Obsolete version, remove from `core-js@4`
$ca3e1754e676956d$exports({
    target: "Set",
    proto: true,
    real: true,
    forced: true
}, {
    symmetricDifference: function symmetricDifference(other) {
        return $881ad37dbe259e8f$exports($d76d05972236f5c4$exports, this, $b126c600f59850cf$exports(other));
    }
});


"use strict";



var $2a73a1a5fe9468e8$exports = {};
"use strict";


var $2a73a1a5fe9468e8$require$add = $f5060c84c0f60f7e$exports.add;



// `Set.prototype.union` method
// https://github.com/tc39/proposal-set-methods
$2a73a1a5fe9468e8$exports = function union(other) {
    var O = $181da54e4761d0e8$exports(this);
    var keysIter = $a57ec52899092109$exports(other).getIterator();
    var result = $d77fd3960bcf099e$exports(O);
    $c3b265c1265de03f$exports(keysIter, function(it) {
        $2a73a1a5fe9468e8$require$add(result, it);
    });
    return result;
};


// `Set.prototype.union` method
// https://github.com/tc39/proposal-set-methods
// TODO: Obsolete version, remove from `core-js@4`
$ca3e1754e676956d$exports({
    target: "Set",
    proto: true,
    real: true,
    forced: true
}, {
    union: function union(other) {
        return $881ad37dbe259e8f$exports($2a73a1a5fe9468e8$exports, this, $b126c600f59850cf$exports(other));
    }
});


"use strict";

var $d2d4d612d3120d2f$exports = {};
"use strict";




var $d2d4d612d3120d2f$var$charAt = $43b18aa2f1faac44$exports("".charAt);
var $d2d4d612d3120d2f$var$charCodeAt = $43b18aa2f1faac44$exports("".charCodeAt);
var $d2d4d612d3120d2f$var$stringSlice = $43b18aa2f1faac44$exports("".slice);
var $d2d4d612d3120d2f$var$createMethod = function(CONVERT_TO_STRING) {
    return function($this, pos) {
        var S = $e25aed89b5529bcb$exports($c378177673193450$exports($this));
        var position = $b5bb21648546ce5b$exports(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? "" : undefined;
        first = $d2d4d612d3120d2f$var$charCodeAt(S, position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = $d2d4d612d3120d2f$var$charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? $d2d4d612d3120d2f$var$charAt(S, position) : first : CONVERT_TO_STRING ? $d2d4d612d3120d2f$var$stringSlice(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
};
$d2d4d612d3120d2f$exports = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: $d2d4d612d3120d2f$var$createMethod(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: $d2d4d612d3120d2f$var$createMethod(true)
};


var $3af59adea3ff7a02$require$charAt = $d2d4d612d3120d2f$exports.charAt;



// `String.prototype.at` method
// https://github.com/mathiasbynens/String.prototype.at
$ca3e1754e676956d$exports({
    target: "String",
    proto: true,
    forced: true
}, {
    at: function at(index) {
        var S = $e25aed89b5529bcb$exports($c378177673193450$exports(this));
        var len = S.length;
        var relativeIndex = $b5bb21648546ce5b$exports(index);
        var k = relativeIndex >= 0 ? relativeIndex : len + relativeIndex;
        return k < 0 || k >= len ? undefined : $3af59adea3ff7a02$require$charAt(S, k);
    }
});


"use strict";







var $754c0816c814f0fa$var$codeAt = $d2d4d612d3120d2f$exports.codeAt;
var $754c0816c814f0fa$var$charAt = $d2d4d612d3120d2f$exports.charAt;
var $754c0816c814f0fa$var$STRING_ITERATOR = "String Iterator";
var $754c0816c814f0fa$var$setInternalState = $3a8bcef306e86159$exports.set;
var $754c0816c814f0fa$var$getInternalState = $3a8bcef306e86159$exports.getterFor($754c0816c814f0fa$var$STRING_ITERATOR);
// TODO: unify with String#@@iterator
var $754c0816c814f0fa$var$$StringIterator = $2428e9d9593354c3$exports(function StringIterator(string) {
    $754c0816c814f0fa$var$setInternalState(this, {
        type: $754c0816c814f0fa$var$STRING_ITERATOR,
        string: string,
        index: 0
    });
}, "String", function next() {
    var state = $754c0816c814f0fa$var$getInternalState(this);
    var string = state.string;
    var index = state.index;
    var point;
    if (index >= string.length) return $dfab5f5c406cd291$exports(undefined, true);
    point = $754c0816c814f0fa$var$charAt(string, index);
    state.index += point.length;
    return $dfab5f5c406cd291$exports({
        codePoint: $754c0816c814f0fa$var$codeAt(point, 0),
        position: index
    }, false);
});
// `String.prototype.codePoints` method
// https://github.com/tc39/proposal-string-prototype-codepoints
$ca3e1754e676956d$exports({
    target: "String",
    proto: true,
    forced: true
}, {
    codePoints: function codePoints() {
        return new $754c0816c814f0fa$var$$StringIterator($e25aed89b5529bcb$exports($c378177673193450$exports(this)));
    }
});


"use strict";

var $d59cfa12048c6a93$exports = {};
"use strict";
var $d7077b1b2482ede0$exports = {};
"use strict";

$d7077b1b2482ede0$exports = $3fbf1185731afe2b$exports;



var $f95af0e9699ed86b$export$2d1720544b23b823;
"use strict";

$f95af0e9699ed86b$export$2d1720544b23b823 = $842f8f0a18746212$exports;



var $d59cfa12048c6a93$require$defineProperty = $2d0ac3aa5e39584b$export$2d1720544b23b823;
$d59cfa12048c6a93$exports = function(NAME) {
    var Symbol = $d7077b1b2482ede0$exports.Symbol || ($d7077b1b2482ede0$exports.Symbol = {});
    if (!$1f868a26fd901990$exports(Symbol, NAME)) $d59cfa12048c6a93$require$defineProperty(Symbol, NAME, {
        value: $f95af0e9699ed86b$export$2d1720544b23b823(NAME)
    });
};



var $87873509811afceb$require$defineProperty = $2d0ac3aa5e39584b$export$2d1720544b23b823;

var $87873509811afceb$require$getOwnPropertyDescriptor = $6d99163b6684d050$export$2d1720544b23b823;
var $87873509811afceb$var$Symbol = $3fbf1185731afe2b$exports.Symbol;
// `Symbol.dispose` well-known symbol
// https://github.com/tc39/proposal-explicit-resource-management
$d59cfa12048c6a93$exports("dispose");
if ($87873509811afceb$var$Symbol) {
    var $87873509811afceb$var$descriptor = $87873509811afceb$require$getOwnPropertyDescriptor($87873509811afceb$var$Symbol, "dispose");
    // workaround of NodeJS 20.4 bug
    // https://github.com/nodejs/node/issues/48699
    // and incorrect descriptor from some transpilers and userland helpers
    if ($87873509811afceb$var$descriptor.enumerable && $87873509811afceb$var$descriptor.configurable && $87873509811afceb$var$descriptor.writable) $87873509811afceb$require$defineProperty($87873509811afceb$var$Symbol, "dispose", {
        value: $87873509811afceb$var$descriptor.value,
        enumerable: false,
        configurable: false,
        writable: false
    });
}


"use strict";

// `Symbol.observable` well-known symbol
// https://github.com/tc39/proposal-observable
$d59cfa12048c6a93$exports("observable");


"use strict";

// `Symbol.patternMatch` well-known symbol
// https://github.com/tc39/proposal-pattern-matching
$d59cfa12048c6a93$exports("patternMatch");


"use strict";

var $ae43bfa593b0460a$exports = {};
"use strict";
var $9a631153b9a7e6cd$exports = {};
"use strict";

// eslint-disable-next-line es/no-weak-map -- safe
var $9a631153b9a7e6cd$var$WeakMapPrototype = WeakMap.prototype;
$9a631153b9a7e6cd$exports = {
    // eslint-disable-next-line es/no-weak-map -- safe
    WeakMap: WeakMap,
    set: $43b18aa2f1faac44$exports($9a631153b9a7e6cd$var$WeakMapPrototype.set),
    get: $43b18aa2f1faac44$exports($9a631153b9a7e6cd$var$WeakMapPrototype.get),
    has: $43b18aa2f1faac44$exports($9a631153b9a7e6cd$var$WeakMapPrototype.has),
    remove: $43b18aa2f1faac44$exports($9a631153b9a7e6cd$var$WeakMapPrototype["delete"])
};


var $ae43bfa593b0460a$require$has = $9a631153b9a7e6cd$exports.has;
// Perform ? RequireInternalSlot(M, [[WeakMapData]])
$ae43bfa593b0460a$exports = function(it) {
    $ae43bfa593b0460a$require$has(it);
    return it;
};



var $3704a7e2d113d7a5$require$remove = $9a631153b9a7e6cd$exports.remove;
// `WeakMap.prototype.deleteAll` method
// https://github.com/tc39/proposal-collection-methods
$ca3e1754e676956d$exports({
    target: "WeakMap",
    proto: true,
    real: true,
    forced: true
}, {
    deleteAll: function deleteAll() {
        var collection = $ae43bfa593b0460a$exports(this);
        var allDeleted = true;
        var wasDeleted;
        for(var k = 0, len = arguments.length; k < len; k++){
            wasDeleted = $3704a7e2d113d7a5$require$remove(collection, arguments[k]);
            allDeleted = allDeleted && wasDeleted;
        }
        return !!allDeleted;
    }
});


"use strict";



// `WeakMap.from` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
$ca3e1754e676956d$exports({
    target: "WeakMap",
    stat: true,
    forced: true
}, {
    from: $0026225b23b40e5f$exports($9a631153b9a7e6cd$exports.WeakMap, $9a631153b9a7e6cd$exports.set, true)
});


"use strict";



// `WeakMap.of` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
$ca3e1754e676956d$exports({
    target: "WeakMap",
    stat: true,
    forced: true
}, {
    of: $2bf4af15edd92228$exports($9a631153b9a7e6cd$exports.WeakMap, $9a631153b9a7e6cd$exports.set, true)
});


"use strict";

var $5f9b7dcc7d8b56a1$exports = {};
"use strict";
var $2a8a6281836e2ca2$exports = {};
"use strict";

// eslint-disable-next-line es/no-weak-set -- safe
var $2a8a6281836e2ca2$var$WeakSetPrototype = WeakSet.prototype;
$2a8a6281836e2ca2$exports = {
    // eslint-disable-next-line es/no-weak-set -- safe
    WeakSet: WeakSet,
    add: $43b18aa2f1faac44$exports($2a8a6281836e2ca2$var$WeakSetPrototype.add),
    has: $43b18aa2f1faac44$exports($2a8a6281836e2ca2$var$WeakSetPrototype.has),
    remove: $43b18aa2f1faac44$exports($2a8a6281836e2ca2$var$WeakSetPrototype["delete"])
};


var $5f9b7dcc7d8b56a1$require$has = $2a8a6281836e2ca2$exports.has;
// Perform ? RequireInternalSlot(M, [[WeakSetData]])
$5f9b7dcc7d8b56a1$exports = function(it) {
    $5f9b7dcc7d8b56a1$require$has(it);
    return it;
};



var $e1a09ce94db7efdc$require$add = $2a8a6281836e2ca2$exports.add;
// `WeakSet.prototype.addAll` method
// https://github.com/tc39/proposal-collection-methods
$ca3e1754e676956d$exports({
    target: "WeakSet",
    proto: true,
    real: true,
    forced: true
}, {
    addAll: function addAll() {
        var set = $5f9b7dcc7d8b56a1$exports(this);
        for(var k = 0, len = arguments.length; k < len; k++)$e1a09ce94db7efdc$require$add(set, arguments[k]);
        return set;
    }
});


"use strict";



var $9b4fda4227855a37$require$remove = $2a8a6281836e2ca2$exports.remove;
// `WeakSet.prototype.deleteAll` method
// https://github.com/tc39/proposal-collection-methods
$ca3e1754e676956d$exports({
    target: "WeakSet",
    proto: true,
    real: true,
    forced: true
}, {
    deleteAll: function deleteAll() {
        var collection = $5f9b7dcc7d8b56a1$exports(this);
        var allDeleted = true;
        var wasDeleted;
        for(var k = 0, len = arguments.length; k < len; k++){
            wasDeleted = $9b4fda4227855a37$require$remove(collection, arguments[k]);
            allDeleted = allDeleted && wasDeleted;
        }
        return !!allDeleted;
    }
});


"use strict";



// `WeakSet.from` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
$ca3e1754e676956d$exports({
    target: "WeakSet",
    stat: true,
    forced: true
}, {
    from: $0026225b23b40e5f$exports($2a8a6281836e2ca2$exports.WeakSet, $2a8a6281836e2ca2$exports.add, false)
});


"use strict";



// `WeakSet.of` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
$ca3e1754e676956d$exports({
    target: "WeakSet",
    stat: true,
    forced: true
}, {
    of: $2bf4af15edd92228$exports($2a8a6281836e2ca2$exports.WeakSet, $2a8a6281836e2ca2$exports.add, false)
});


"use strict";
"use strict";


var $a393da0e05d61ed1$exports = {};
"use strict";









var $7d824954c5058f7d$exports = {};
"use strict";
var $7d824954c5058f7d$var$$TypeError = TypeError;
$7d824954c5058f7d$exports = function(passed, required) {
    if (passed < required) throw new $7d824954c5058f7d$var$$TypeError("Not enough arguments");
    return passed;
};


var $2d59c67a15180939$exports = {};
"use strict";

// eslint-disable-next-line redos/no-vulnerable -- safe
$2d59c67a15180939$exports = /(?:ipad|iphone|ipod).*applewebkit/i.test($34fa2a1382dc63c1$exports);


var $88d6935be735e2e8$exports = {};
"use strict";
var $87e21695405add0a$exports = {};
"use strict";



var $87e21695405add0a$var$userAgentStartsWith = function(string) {
    return $34fa2a1382dc63c1$exports.slice(0, string.length) === string;
};
$87e21695405add0a$exports = function() {
    if ($87e21695405add0a$var$userAgentStartsWith("Bun/")) return "BUN";
    if ($87e21695405add0a$var$userAgentStartsWith("Cloudflare-Workers")) return "CLOUDFLARE";
    if ($87e21695405add0a$var$userAgentStartsWith("Deno/")) return "DENO";
    if ($87e21695405add0a$var$userAgentStartsWith("Node.js/")) return "NODE";
    if ($3fbf1185731afe2b$exports.Bun && typeof Bun.version == "string") return "BUN";
    if ($3fbf1185731afe2b$exports.Deno && typeof Deno.version == "object") return "DENO";
    if ($b0ba63bfbfb16088$exports($3fbf1185731afe2b$exports.process) === "process") return "NODE";
    if ($3fbf1185731afe2b$exports.window && $3fbf1185731afe2b$exports.document) return "BROWSER";
    return "REST";
}();


$88d6935be735e2e8$exports = $87e21695405add0a$exports === "NODE";


var $a393da0e05d61ed1$var$set = $3fbf1185731afe2b$exports.setImmediate;
var $a393da0e05d61ed1$var$clear = $3fbf1185731afe2b$exports.clearImmediate;
var $a393da0e05d61ed1$var$process = $3fbf1185731afe2b$exports.process;
var $a393da0e05d61ed1$var$Dispatch = $3fbf1185731afe2b$exports.Dispatch;
var $a393da0e05d61ed1$var$Function = $3fbf1185731afe2b$exports.Function;
var $a393da0e05d61ed1$var$MessageChannel = $3fbf1185731afe2b$exports.MessageChannel;
var $a393da0e05d61ed1$var$String = $3fbf1185731afe2b$exports.String;
var $a393da0e05d61ed1$var$counter = 0;
var $a393da0e05d61ed1$var$queue = {};
var $a393da0e05d61ed1$var$ONREADYSTATECHANGE = "onreadystatechange";
var $a393da0e05d61ed1$var$$location, $a393da0e05d61ed1$var$defer, $a393da0e05d61ed1$var$channel, $a393da0e05d61ed1$var$port;
$6140c9fa18232846$exports(function() {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $a393da0e05d61ed1$var$$location = $3fbf1185731afe2b$exports.location;
});
var $a393da0e05d61ed1$var$run = function(id) {
    if ($1f868a26fd901990$exports($a393da0e05d61ed1$var$queue, id)) {
        var fn = $a393da0e05d61ed1$var$queue[id];
        delete $a393da0e05d61ed1$var$queue[id];
        fn();
    }
};
var $a393da0e05d61ed1$var$runner = function(id) {
    return function() {
        $a393da0e05d61ed1$var$run(id);
    };
};
var $a393da0e05d61ed1$var$eventListener = function(event) {
    $a393da0e05d61ed1$var$run(event.data);
};
var $a393da0e05d61ed1$var$globalPostMessageDefer = function(id) {
    // old engines have not location.origin
    $3fbf1185731afe2b$exports.postMessage($a393da0e05d61ed1$var$String(id), $a393da0e05d61ed1$var$$location.protocol + "//" + $a393da0e05d61ed1$var$$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$a393da0e05d61ed1$var$set || !$a393da0e05d61ed1$var$clear) {
    $a393da0e05d61ed1$var$set = function setImmediate(handler) {
        $7d824954c5058f7d$exports(arguments.length, 1);
        var fn = $70e34a5a2021f756$exports(handler) ? handler : $a393da0e05d61ed1$var$Function(handler);
        var args = $0709cba658bb4ed6$exports(arguments, 1);
        $a393da0e05d61ed1$var$queue[++$a393da0e05d61ed1$var$counter] = function() {
            $3cdb2ef65d8e3cb5$exports(fn, undefined, args);
        };
        $a393da0e05d61ed1$var$defer($a393da0e05d61ed1$var$counter);
        return $a393da0e05d61ed1$var$counter;
    };
    $a393da0e05d61ed1$var$clear = function clearImmediate(id) {
        delete $a393da0e05d61ed1$var$queue[id];
    };
    // Node.js 0.8-
    if ($88d6935be735e2e8$exports) $a393da0e05d61ed1$var$defer = function(id) {
        $a393da0e05d61ed1$var$process.nextTick($a393da0e05d61ed1$var$runner(id));
    };
    else if ($a393da0e05d61ed1$var$Dispatch && $a393da0e05d61ed1$var$Dispatch.now) $a393da0e05d61ed1$var$defer = function(id) {
        $a393da0e05d61ed1$var$Dispatch.now($a393da0e05d61ed1$var$runner(id));
    };
    else if ($a393da0e05d61ed1$var$MessageChannel && !$2d59c67a15180939$exports) {
        $a393da0e05d61ed1$var$channel = new $a393da0e05d61ed1$var$MessageChannel();
        $a393da0e05d61ed1$var$port = $a393da0e05d61ed1$var$channel.port2;
        $a393da0e05d61ed1$var$channel.port1.onmessage = $a393da0e05d61ed1$var$eventListener;
        $a393da0e05d61ed1$var$defer = $43284f0171045916$exports($a393da0e05d61ed1$var$port.postMessage, $a393da0e05d61ed1$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($3fbf1185731afe2b$exports.addEventListener && $70e34a5a2021f756$exports($3fbf1185731afe2b$exports.postMessage) && !$3fbf1185731afe2b$exports.importScripts && $a393da0e05d61ed1$var$$location && $a393da0e05d61ed1$var$$location.protocol !== "file:" && !$6140c9fa18232846$exports($a393da0e05d61ed1$var$globalPostMessageDefer)) {
        $a393da0e05d61ed1$var$defer = $a393da0e05d61ed1$var$globalPostMessageDefer;
        $3fbf1185731afe2b$exports.addEventListener("message", $a393da0e05d61ed1$var$eventListener, false);
    // IE8-
    } else if ($a393da0e05d61ed1$var$ONREADYSTATECHANGE in $15c0c414b89100b1$exports("script")) $a393da0e05d61ed1$var$defer = function(id) {
        $b8ce1ad1b6b1e7c1$exports.appendChild($15c0c414b89100b1$exports("script"))[$a393da0e05d61ed1$var$ONREADYSTATECHANGE] = function() {
            $b8ce1ad1b6b1e7c1$exports.removeChild(this);
            $a393da0e05d61ed1$var$run(id);
        };
    };
    else $a393da0e05d61ed1$var$defer = function(id) {
        setTimeout($a393da0e05d61ed1$var$runner(id), 0);
    };
}
$a393da0e05d61ed1$exports = {
    set: $a393da0e05d61ed1$var$set,
    clear: $a393da0e05d61ed1$var$clear
};


var $99b55bbd56d52729$require$clearImmediate = $a393da0e05d61ed1$exports.clear;
// `clearImmediate` method
// http://w3c.github.io/setImmediate/#si-clearImmediate
$ca3e1754e676956d$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $3fbf1185731afe2b$exports.clearImmediate !== $99b55bbd56d52729$require$clearImmediate
}, {
    clearImmediate: $99b55bbd56d52729$require$clearImmediate
});


"use strict";



var $e55ac54d5aaa2e1c$require$setTask = $a393da0e05d61ed1$exports.set;
var $f112a170991e44cc$exports = {};
"use strict";







var $f112a170991e44cc$var$Function = $3fbf1185731afe2b$exports.Function;
// dirty IE9- and Bun 0.3.0- checks
var $f112a170991e44cc$var$WRAP = /MSIE .\./.test($34fa2a1382dc63c1$exports) || $87e21695405add0a$exports === "BUN" && function() {
    var version = $3fbf1185731afe2b$exports.Bun.version.split(".");
    return version.length < 3 || version[0] === "0" && (version[1] < 3 || version[1] === "3" && version[2] === "0");
}();
// IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
// https://github.com/oven-sh/bun/issues/1633
$f112a170991e44cc$exports = function(scheduler, hasTimeArg) {
    var firstParamIndex = hasTimeArg ? 2 : 1;
    return $f112a170991e44cc$var$WRAP ? function(handler, timeout /* , ...arguments */ ) {
        var boundArgs = $7d824954c5058f7d$exports(arguments.length, 1) > firstParamIndex;
        var fn = $70e34a5a2021f756$exports(handler) ? handler : $f112a170991e44cc$var$Function(handler);
        var params = boundArgs ? $0709cba658bb4ed6$exports(arguments, firstParamIndex) : [];
        var callback = boundArgs ? function() {
            $3cdb2ef65d8e3cb5$exports(fn, this, params);
        } : fn;
        return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
    } : scheduler;
};


// https://github.com/oven-sh/bun/issues/1633
var $e55ac54d5aaa2e1c$var$setImmediate = $3fbf1185731afe2b$exports.setImmediate ? $f112a170991e44cc$exports($e55ac54d5aaa2e1c$require$setTask, false) : $e55ac54d5aaa2e1c$require$setTask;
// `setImmediate` method
// http://w3c.github.io/setImmediate/#si-setImmediate
$ca3e1754e676956d$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $3fbf1185731afe2b$exports.setImmediate !== $e55ac54d5aaa2e1c$var$setImmediate
}, {
    setImmediate: $e55ac54d5aaa2e1c$var$setImmediate
});




var $f993037a9863bffd$exports = {};
!function(t, n) {
    $f993037a9863bffd$exports = n();
}("undefined" != typeof self ? self : $f993037a9863bffd$exports, function() {
    return function() {
        "use strict";
        var t = {
            407: function(t, n, e) {
                e.d(n, {
                    default: function() {
                        return N;
                    }
                });
                var o = /([:*])(\w+)/g, r = /\*/g, i = /\/\?/g;
                function a(t) {
                    return void 0 === t && (t = "/"), v() ? location.pathname + location.search + location.hash : t;
                }
                function s(t) {
                    return t.replace(/\/+$/, "").replace(/^\/+/, "");
                }
                function c(t) {
                    return "string" == typeof t;
                }
                function u(t) {
                    return t && t.indexOf("#") >= 0 && t.split("#").pop() || "";
                }
                function h(t) {
                    var n = s(t).split(/\?(.*)?$/);
                    return [
                        s(n[0]),
                        n.slice(1).join("")
                    ];
                }
                function f(t) {
                    for(var n = {}, e = t.split("&"), o = 0; o < e.length; o++){
                        var r = e[o].split("=");
                        if ("" !== r[0]) {
                            var i = decodeURIComponent(r[0]);
                            n[i] ? (Array.isArray(n[i]) || (n[i] = [
                                n[i]
                            ]), n[i].push(decodeURIComponent(r[1] || ""))) : n[i] = decodeURIComponent(r[1] || "");
                        }
                    }
                    return n;
                }
                function l(t, n) {
                    var e, a = h(s(t.currentLocationPath)), l = a[0], p = a[1], d = "" === p ? null : f(p), v = [];
                    if (c(n.path)) {
                        if (e = "(?:/^|^)" + s(n.path).replace(o, function(t, n, e) {
                            return v.push(e), "([^/]+)";
                        }).replace(r, "?(?:.*)").replace(i, "/?([^/]+|)") + "$", "" === s(n.path) && "" === s(l)) return {
                            url: l,
                            queryString: p,
                            hashString: u(t.to),
                            route: n,
                            data: null,
                            params: d
                        };
                    } else e = n.path;
                    var g = new RegExp(e, ""), m = l.match(g);
                    if (m) {
                        var y = c(n.path) ? function(t, n) {
                            return 0 === n.length ? null : t ? t.slice(1, t.length).reduce(function(t, e, o) {
                                return null === t && (t = {}), t[n[o]] = decodeURIComponent(e), t;
                            }, null) : null;
                        }(m, v) : m.groups ? m.groups : m.slice(1);
                        return {
                            url: s(l.replace(new RegExp("^" + t.instance.root), "")),
                            queryString: p,
                            hashString: u(t.to),
                            route: n,
                            data: y,
                            params: d
                        };
                    }
                    return !1;
                }
                function p() {
                    return !("undefined" == typeof window || !window.history || !window.history.pushState);
                }
                function d(t, n) {
                    return void 0 === t[n] || !0 === t[n];
                }
                function v() {
                    return "undefined" != typeof window;
                }
                function g(t, n) {
                    return void 0 === t && (t = []), void 0 === n && (n = {}), t.filter(function(t) {
                        return t;
                    }).forEach(function(t) {
                        [
                            "before",
                            "after",
                            "already",
                            "leave"
                        ].forEach(function(e) {
                            t[e] && (n[e] || (n[e] = []), n[e].push(t[e]));
                        });
                    }), n;
                }
                function m(t, n, e) {
                    var o = n || {}, r = 0;
                    !function n() {
                        t[r] ? Array.isArray(t[r]) ? (t.splice.apply(t, [
                            r,
                            1
                        ].concat(t[r][0](o) ? t[r][1] : t[r][2])), n()) : t[r](o, function(t) {
                            void 0 === t || !0 === t ? (r += 1, n()) : e && e(o);
                        }) : e && e(o);
                    }();
                }
                function y(t, n) {
                    void 0 === t.currentLocationPath && (t.currentLocationPath = t.to = a(t.instance.root)), t.currentLocationPath = t.instance._checkForAHash(t.currentLocationPath), n();
                }
                function _(t, n) {
                    for(var e = 0; e < t.instance.routes.length; e++){
                        var o = l(t, t.instance.routes[e]);
                        if (o && (t.matches || (t.matches = []), t.matches.push(o), "ONE" === t.resolveOptions.strategy)) return void n();
                    }
                    n();
                }
                function k(t, n) {
                    t.navigateOptions && (void 0 !== t.navigateOptions.shouldResolve && console.warn('"shouldResolve" is deprecated. Please check the documentation.'), void 0 !== t.navigateOptions.silent && console.warn('"silent" is deprecated. Please check the documentation.')), n();
                }
                function O(t, n) {
                    !0 === t.navigateOptions.force ? (t.instance._setCurrent([
                        t.instance._pathToMatchObject(t.to)
                    ]), n(!1)) : n();
                }
                m.if = function(t, n, e) {
                    return Array.isArray(n) || (n = [
                        n
                    ]), Array.isArray(e) || (e = [
                        e
                    ]), [
                        t,
                        n,
                        e
                    ];
                };
                var w = v(), L = p();
                function b(t, n) {
                    if (d(t.navigateOptions, "updateBrowserURL")) {
                        var e = ("/" + t.to).replace(/\/\//g, "/"), o = w && t.resolveOptions && !0 === t.resolveOptions.hash;
                        L ? (history[t.navigateOptions.historyAPIMethod || "pushState"](t.navigateOptions.stateObj || {}, t.navigateOptions.title || "", o ? "#" + e : e), location && location.hash && (t.instance.__freezeListening = !0, setTimeout(function() {
                            if (!o) {
                                var n = location.hash;
                                location.hash = "", location.hash = n;
                            }
                            t.instance.__freezeListening = !1;
                        }, 1))) : w && (window.location.href = t.to);
                    }
                    n();
                }
                function A(t, n) {
                    var e = t.instance;
                    e.lastResolved() ? m(e.lastResolved().map(function(n) {
                        return function(e, o) {
                            if (n.route.hooks && n.route.hooks.leave) {
                                var r = !1, i = t.instance.matchLocation(n.route.path, t.currentLocationPath, !1);
                                r = "*" !== n.route.path ? !i : !(t.matches && t.matches.find(function(t) {
                                    return n.route.path === t.route.path;
                                })), d(t.navigateOptions, "callHooks") && r ? m(n.route.hooks.leave.map(function(n) {
                                    return function(e, o) {
                                        return n(function(n) {
                                            !1 === n ? t.instance.__markAsClean(t) : o();
                                        }, t.matches && t.matches.length > 0 ? 1 === t.matches.length ? t.matches[0] : t.matches : void 0);
                                    };
                                }).concat([
                                    function() {
                                        return o();
                                    }
                                ])) : o();
                            } else o();
                        };
                    }), {}, function() {
                        return n();
                    }) : n();
                }
                function P(t, n) {
                    d(t.navigateOptions, "updateState") && t.instance._setCurrent(t.matches), n();
                }
                var R = [
                    function(t, n) {
                        var e = t.instance.lastResolved();
                        if (e && e[0] && e[0].route === t.match.route && e[0].url === t.match.url && e[0].queryString === t.match.queryString) return e.forEach(function(n) {
                            n.route.hooks && n.route.hooks.already && d(t.navigateOptions, "callHooks") && n.route.hooks.already.forEach(function(n) {
                                return n(t.match);
                            });
                        }), void n(!1);
                        n();
                    },
                    function(t, n) {
                        t.match.route.hooks && t.match.route.hooks.before && d(t.navigateOptions, "callHooks") ? m(t.match.route.hooks.before.map(function(n) {
                            return function(e, o) {
                                return n(function(n) {
                                    !1 === n ? t.instance.__markAsClean(t) : o();
                                }, t.match);
                            };
                        }).concat([
                            function() {
                                return n();
                            }
                        ])) : n();
                    },
                    function(t, n) {
                        d(t.navigateOptions, "callHandler") && t.match.route.handler(t.match), t.instance.updatePageLinks(), n();
                    },
                    function(t, n) {
                        t.match.route.hooks && t.match.route.hooks.after && d(t.navigateOptions, "callHooks") && t.match.route.hooks.after.forEach(function(n) {
                            return n(t.match);
                        }), n();
                    }
                ], S = [
                    A,
                    function(t, n) {
                        var e = t.instance._notFoundRoute;
                        if (e) {
                            t.notFoundHandled = !0;
                            var o = h(t.currentLocationPath), r = o[0], i = o[1], a = u(t.to);
                            e.path = s(r);
                            var c = {
                                url: e.path,
                                queryString: i,
                                hashString: a,
                                data: null,
                                route: e,
                                params: "" !== i ? f(i) : null
                            };
                            t.matches = [
                                c
                            ], t.match = c;
                        }
                        n();
                    },
                    m.if(function(t) {
                        return t.notFoundHandled;
                    }, R.concat([
                        P
                    ]), [
                        function(t, n) {
                            t.resolveOptions && !1 !== t.resolveOptions.noMatchWarning && void 0 !== t.resolveOptions.noMatchWarning || console.warn('Navigo: "' + t.currentLocationPath + "\" didn't match any of the registered routes."), n();
                        },
                        function(t, n) {
                            t.instance._setCurrent(null), n();
                        }
                    ])
                ];
                function E() {
                    return (E = Object.assign || function(t) {
                        for(var n = 1; n < arguments.length; n++){
                            var e = arguments[n];
                            for(var o in e)Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                        }
                        return t;
                    }).apply(this, arguments);
                }
                function x(t, n) {
                    var e = 0;
                    A(t, function o() {
                        e !== t.matches.length ? m(R, E({}, t, {
                            match: t.matches[e]
                        }), function() {
                            e += 1, o();
                        }) : P(t, n);
                    });
                }
                function H(t) {
                    t.instance.__markAsClean(t);
                }
                function j() {
                    return (j = Object.assign || function(t) {
                        for(var n = 1; n < arguments.length; n++){
                            var e = arguments[n];
                            for(var o in e)Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                        }
                        return t;
                    }).apply(this, arguments);
                }
                var C = "[data-navigo]";
                function N(t, n) {
                    var e, o = n || {
                        strategy: "ONE",
                        hash: !1,
                        noMatchWarning: !1,
                        linksSelector: C
                    }, r = this, i = "/", d = null, w = [], L = !1, A = p(), P = v();
                    function R(t) {
                        return t.indexOf("#") >= 0 && (t = !0 === o.hash ? t.split("#")[1] || "/" : t.split("#")[0]), t;
                    }
                    function E(t) {
                        return s(i + "/" + s(t));
                    }
                    function N(t, n, e, o) {
                        return t = c(t) ? E(t) : t, {
                            name: o || s(String(t)),
                            path: t,
                            handler: n,
                            hooks: g(e)
                        };
                    }
                    function U(t, n) {
                        if (!r.__dirty) {
                            r.__dirty = !0, t = t ? s(i) + "/" + s(t) : void 0;
                            var e = {
                                instance: r,
                                to: t,
                                currentLocationPath: t,
                                navigateOptions: {},
                                resolveOptions: j({}, o, n)
                            };
                            return m([
                                y,
                                _,
                                m.if(function(t) {
                                    var n = t.matches;
                                    return n && n.length > 0;
                                }, x, S)
                            ], e, H), !!e.matches && e.matches;
                        }
                        r.__waiting.push(function() {
                            return r.resolve(t, n);
                        });
                    }
                    function q(t, n) {
                        if (r.__dirty) r.__waiting.push(function() {
                            return r.navigate(t, n);
                        });
                        else {
                            r.__dirty = !0, t = s(i) + "/" + s(t);
                            var e = {
                                instance: r,
                                to: t,
                                navigateOptions: n || {},
                                resolveOptions: n && n.resolveOptions ? n.resolveOptions : o,
                                currentLocationPath: R(t)
                            };
                            m([
                                k,
                                O,
                                _,
                                m.if(function(t) {
                                    var n = t.matches;
                                    return n && n.length > 0;
                                }, x, S),
                                b,
                                H
                            ], e, H);
                        }
                    }
                    function F() {
                        if (P) return (P ? [].slice.call(document.querySelectorAll(o.linksSelector || C)) : []).forEach(function(t) {
                            "false" !== t.getAttribute("data-navigo") && "_blank" !== t.getAttribute("target") ? t.hasListenerAttached || (t.hasListenerAttached = !0, t.navigoHandler = function(n) {
                                if ((n.ctrlKey || n.metaKey) && "a" === n.target.tagName.toLowerCase()) return !1;
                                var e = t.getAttribute("href");
                                if (null == e) return !1;
                                if (e.match(/^(http|https)/) && "undefined" != typeof URL) try {
                                    var o = new URL(e);
                                    e = o.pathname + o.search;
                                } catch (t) {}
                                var i = function(t) {
                                    if (!t) return {};
                                    var n, e = t.split(","), o = {};
                                    return e.forEach(function(t) {
                                        var e = t.split(":").map(function(t) {
                                            return t.replace(/(^ +| +$)/g, "");
                                        });
                                        switch(e[0]){
                                            case "historyAPIMethod":
                                                o.historyAPIMethod = e[1];
                                                break;
                                            case "resolveOptionsStrategy":
                                                n || (n = {}), n.strategy = e[1];
                                                break;
                                            case "resolveOptionsHash":
                                                n || (n = {}), n.hash = "true" === e[1];
                                                break;
                                            case "updateBrowserURL":
                                            case "callHandler":
                                            case "updateState":
                                            case "force":
                                                o[e[0]] = "true" === e[1];
                                        }
                                    }), n && (o.resolveOptions = n), o;
                                }(t.getAttribute("data-navigo-options"));
                                L || (n.preventDefault(), n.stopPropagation(), r.navigate(s(e), i));
                            }, t.addEventListener("click", t.navigoHandler)) : t.hasListenerAttached && t.removeEventListener("click", t.navigoHandler);
                        }), r;
                    }
                    function I(t, n, e) {
                        var o = w.find(function(n) {
                            return n.name === t;
                        }), r = null;
                        if (o) {
                            if (r = o.path, n) for(var a in n)r = r.replace(":" + a, n[a]);
                            r = r.match(/^\//) ? r : "/" + r;
                        }
                        return r && e && !e.includeRoot && (r = r.replace(new RegExp("^/" + i), "")), r;
                    }
                    function M(t) {
                        var n = h(s(t)), o = n[0], r = n[1], i = "" === r ? null : f(r);
                        return {
                            url: o,
                            queryString: r,
                            hashString: u(t),
                            route: N(o, function() {}, [
                                e
                            ], o),
                            data: null,
                            params: i
                        };
                    }
                    function T(t, n, e) {
                        return "string" == typeof n && (n = z(n)), n ? (n.hooks[t] || (n.hooks[t] = []), n.hooks[t].push(e), function() {
                            n.hooks[t] = n.hooks[t].filter(function(t) {
                                return t !== e;
                            });
                        }) : (console.warn("Route doesn't exists: " + n), function() {});
                    }
                    function z(t) {
                        return "string" == typeof t ? w.find(function(n) {
                            return n.name === E(t);
                        }) : w.find(function(n) {
                            return n.handler === t;
                        });
                    }
                    t ? i = s(t) : console.warn('Navigo requires a root path in its constructor. If not provided will use "/" as default.'), this.root = i, this.routes = w, this.destroyed = L, this.current = d, this.__freezeListening = !1, this.__waiting = [], this.__dirty = !1, this.__markAsClean = function(t) {
                        t.instance.__dirty = !1, t.instance.__waiting.length > 0 && t.instance.__waiting.shift()();
                    }, this.on = function(t, n, o) {
                        var r = this;
                        return "object" != typeof t || t instanceof RegExp ? ("function" == typeof t && (o = n, n = t, t = i), w.push(N(t, n, [
                            e,
                            o
                        ])), this) : (Object.keys(t).forEach(function(n) {
                            if ("function" == typeof t[n]) r.on(n, t[n]);
                            else {
                                var o = t[n], i = o.uses, a = o.as, s = o.hooks;
                                w.push(N(n, i, [
                                    e,
                                    s
                                ], a));
                            }
                        }), this);
                    }, this.off = function(t) {
                        return this.routes = w = w.filter(function(n) {
                            return c(t) ? s(n.path) !== s(t) : "function" == typeof t ? t !== n.handler : String(n.path) !== String(t);
                        }), this;
                    }, this.resolve = U, this.navigate = q, this.navigateByName = function(t, n, e) {
                        var o = I(t, n);
                        return null !== o && (q(o.replace(new RegExp("^/?" + i), ""), e), !0);
                    }, this.destroy = function() {
                        this.routes = w = [], A && window.removeEventListener("popstate", this.__popstateListener), this.destroyed = L = !0;
                    }, this.notFound = function(t, n) {
                        return r._notFoundRoute = N("*", t, [
                            e,
                            n
                        ], "__NOT_FOUND__"), this;
                    }, this.updatePageLinks = F, this.link = function(t) {
                        return "/" + i + "/" + s(t);
                    }, this.hooks = function(t) {
                        return e = t, this;
                    }, this.extractGETParameters = function(t) {
                        return h(R(t));
                    }, this.lastResolved = function() {
                        return d;
                    }, this.generate = I, this.getLinkPath = function(t) {
                        return t.getAttribute("href");
                    }, this.match = function(t) {
                        var n = {
                            instance: r,
                            currentLocationPath: t,
                            to: t,
                            navigateOptions: {},
                            resolveOptions: o
                        };
                        return _(n, function() {}), !!n.matches && n.matches;
                    }, this.matchLocation = function(t, n, e) {
                        void 0 === n || void 0 !== e && !e || (n = E(n));
                        var o = {
                            instance: r,
                            to: n,
                            currentLocationPath: n
                        };
                        return y(o, function() {}), "string" == typeof t && (t = void 0 === e || e ? E(t) : t), l(o, {
                            name: String(t),
                            path: t,
                            handler: function() {},
                            hooks: {}
                        }) || !1;
                    }, this.getCurrentLocation = function() {
                        return M(s(a(i)).replace(new RegExp("^" + i), ""));
                    }, this.addBeforeHook = T.bind(this, "before"), this.addAfterHook = T.bind(this, "after"), this.addAlreadyHook = T.bind(this, "already"), this.addLeaveHook = T.bind(this, "leave"), this.getRoute = z, this._pathToMatchObject = M, this._clean = s, this._checkForAHash = R, this._setCurrent = function(t) {
                        return d = r.current = t;
                    }, (function() {
                        A && (this.__popstateListener = function() {
                            r.__freezeListening || U();
                        }, window.addEventListener("popstate", this.__popstateListener));
                    }).call(this), F.call(this);
                }
            }
        }, n = {};
        function e(o) {
            if (n[o]) return n[o].exports;
            var r = n[o] = {
                exports: {}
            };
            return t[o](r, r.exports, e), r.exports;
        }
        return e.d = function(t, n) {
            for(var o in n)e.o(n, o) && !e.o(t, o) && Object.defineProperty(t, o, {
                enumerable: !0,
                get: n[o]
            });
        }, e.o = function(t, n) {
            return Object.prototype.hasOwnProperty.call(t, n);
        }, e(407);
    }().default;
});



class $3e27a66f4ef69c2e$var$Router {
    constructor(){
        const basePath = this._getBasePath();
        this.router = new (0, (/*@__PURE__*/$parcel$interopDefault($f993037a9863bffd$exports)))(basePath, {
            hash: false,
            strategy: "ONE"
        });
        this._setupRoutes();
    }
    _setupRoutes() {
        this.router.on("/", ()=>$f50bd1f2915ed0f2$export$c08853eef7857581()).on("/signup", ()=>$f50bd1f2915ed0f2$export$39e43f811a0d6c63()).on("/continue", ()=>$f50bd1f2915ed0f2$export$8807bf9af653fcb1()).on("/main", ()=>$f50bd1f2915ed0f2$export$b68f47d2740eda21()).on("/pokedex", ()=>$f50bd1f2915ed0f2$export$c3954f25ab777496()).on("/learn", ()=>$f50bd1f2915ed0f2$export$44c0a083e75ef642()).on("/explore", ()=>$f50bd1f2915ed0f2$export$f7c3b936dbc22433());
    }
    _getBasePath() {
        // Check if we're on GitHub Pages or similar
        const hostname = window.location.hostname;
        const pathname = window.location.pathname;
        // Local development
        if (hostname === "localhost" || hostname === "127.0.0.1") return "/";
        // GitHub Pages pattern: username.github.io/repo-name/
        if (hostname.includes("github.io")) {
            const pathParts = pathname.split("/").filter((part)=>part);
            if (pathParts.length > 0) return `/${pathParts[0]}/`;
        }
        // Custom domain or other hosting
        return "/";
    }
    init() {
        this.router.resolve();
    }
    navigateTo(path) {
        this.router.navigate(path);
    }
}
var $3e27a66f4ef69c2e$export$2e2bcd8739ae039 = new $3e27a66f4ef69c2e$var$Router();


//Import necessary components as needed (logoBar, priceCard, etc..)
const $8536cb1d01d30dc7$export$eee7ace900e487d2 = (config = {})=>{
    let { use: use = "nav", path: path = "", color: color = "yellow", text: text = "\u26A0 No Text", type: type = "" } = config;
    // if (use !== "game" || type !== "submit") {
    //   type = "nav";
    // }
    //Re: nullish below. Not sure I absolutely need to use it when compiling a button.
    if (!path) return `
 <a
    type="${type}"
    class="btn btn-${use} btn-nav--${color}">
    ${text}
</a>
`;
    else return `
   <a
      href="${path ?? "/signup"}"
      type="${type}"
      data-nav="${path ?? "/signup"}"
      class="btn btn-${use} btn-nav--${color}">
      ${text}
  </a>
  `;
};


//##### AVATAR ASSETS ######
//##########################
var $33315a45fb2a4a3a$exports = {};
$33315a45fb2a4a3a$exports = new URL("boy1.a0d18640.webp", import.meta.url).toString();


var $70db0d277a09cbdd$exports = {};
$70db0d277a09cbdd$exports = new URL("boy2.6a5e4d2e.webp", import.meta.url).toString();


var $6c5b6efb9e8b2651$exports = {};
$6c5b6efb9e8b2651$exports = new URL("boy3.c0fbc845.webp", import.meta.url).toString();


var $34b425da376ce2fc$exports = {};
$34b425da376ce2fc$exports = new URL("girl1.5bc2366e.webp", import.meta.url).toString();


var $d87cbddfa493f7cf$exports = {};
$d87cbddfa493f7cf$exports = new URL("girl2.f1d0ea34.webp", import.meta.url).toString();


var $5c73e412f558ab54$exports = {};
$5c73e412f558ab54$exports = new URL("girl3.649422b8.webp", import.meta.url).toString();


var $7626390a2007e86e$exports = {};
$7626390a2007e86e$exports = new URL("girl4.1da0aed8.webp", import.meta.url).toString();


var $92a99b5f3984fbc3$exports = {};
$92a99b5f3984fbc3$exports = new URL("girl5.c5cf8b90.webp", import.meta.url).toString();


var $1500977ce7e2d078$exports = {};
$1500977ce7e2d078$exports = new URL("alien-planet.c55122c8.webp", import.meta.url).toString();


var $732664e895c57858$exports = {};
$732664e895c57858$exports = new URL("bare-beach.e7889e77.webp", import.meta.url).toString();


var $5e614f98c66496e2$exports = {};
$5e614f98c66496e2$exports = new URL("cherry-blossoms.e39a504d.webp", import.meta.url).toString();


var $f8c70115cfc5a665$exports = {};
$f8c70115cfc5a665$exports = new URL("deep-forest.5b6fcd75.webp", import.meta.url).toString();


var $f93b4581aae4b3eb$exports = {};
$f93b4581aae4b3eb$exports = new URL("desert.4bb3b2cf.webp", import.meta.url).toString();


var $efbb73e9cffc0f3a$exports = {};
$efbb73e9cffc0f3a$exports = new URL("dinosaurs.1a5d5ee4.webp", import.meta.url).toString();


var $c750a93f44bf8ce5$exports = {};
$c750a93f44bf8ce5$exports = new URL("field-cliff.46d49504.webp", import.meta.url).toString();


var $35144bbbeeb0b598$exports = {};
$35144bbbeeb0b598$exports = new URL("field-hill.a186fc13.webp", import.meta.url).toString();


var $53b47676dd6c30ef$exports = {};
$53b47676dd6c30ef$exports = new URL("field.ad39b465.webp", import.meta.url).toString();


var $8fee3fb890f71334$exports = {};
$8fee3fb890f71334$exports = new URL("forest-alt.f5c85aed.webp", import.meta.url).toString();


var $bd5c5a1c6ff6f905$exports = {};
$bd5c5a1c6ff6f905$exports = new URL("forest.17b46619.webp", import.meta.url).toString();


var $0f87592535210faa$exports = {};
$0f87592535210faa$exports = new URL("jungle-island.eaab3abd.webp", import.meta.url).toString();


var $abbd1c6b366e6b80$exports = {};
$abbd1c6b366e6b80$exports = new URL("jungle.2aa435ae.webp", import.meta.url).toString();


var $2c2937c3343a2024$exports = {};
$2c2937c3343a2024$exports = new URL("night-field.ac7d0010.webp", import.meta.url).toString();


var $28fe971fe505b13b$exports = {};
$28fe971fe505b13b$exports = new URL("night-forest.0b092cf2.webp", import.meta.url).toString();


var $864581fae9d2f811$exports = {};
$864581fae9d2f811$exports = new URL("night-town.c4371576.webp", import.meta.url).toString();


var $8491cc410388103e$exports = {};
$8491cc410388103e$exports = new URL("open-field.23cad61d.webp", import.meta.url).toString();


var $521e9ad6bc0db385$exports = {};
$521e9ad6bc0db385$exports = new URL("rural-field.d714463b.webp", import.meta.url).toString();


var $d60d7839cda6f804$exports = {};
$d60d7839cda6f804$exports = new URL("stream.cca67c7c.webp", import.meta.url).toString();


var $2067556ff9165c16$exports = {};
$2067556ff9165c16$exports = new URL("sunset-valley.70706031.webp", import.meta.url).toString();


var $8b93b2c9047595b0$exports = {};
$8b93b2c9047595b0$exports = new URL("training.a6a0d1e8.webp", import.meta.url).toString();


var $b6d3ed4ff3296c52$exports = {};
$b6d3ed4ff3296c52$exports = new URL("tropical-beach.45ca6725.webp", import.meta.url).toString();


var $b3c217d4c02517bf$exports = {};
$b3c217d4c02517bf$exports = new URL("valley.7b6c8020.webp", import.meta.url).toString();


var $d09d72cb097d3744$exports = {};
$d09d72cb097d3744$exports = new URL("8bitpokeball.0851237e.webp", import.meta.url).toString();


var $55402e5801851cdd$exports = {};
$55402e5801851cdd$exports = new URL("attack-special.58aa1a94.png", import.meta.url).toString();


var $58ddffb32cde7e3a$exports = {};
$58ddffb32cde7e3a$exports = new URL("attack.a1529314.png", import.meta.url).toString();


var $000901b2e36ea7ac$exports = {};
$000901b2e36ea7ac$exports = new URL("defense-special.4795e3dd.png", import.meta.url).toString();


var $16f3e5f5db0115af$exports = {};
$16f3e5f5db0115af$exports = new URL("defense.83edccb2.png", import.meta.url).toString();


var $a50081d176e794fe$exports = {};
$a50081d176e794fe$exports = new URL("dragon.280bc61c.png", import.meta.url).toString();


var $fee8d448f595bbc1$exports = {};
$fee8d448f595bbc1$exports = new URL("electric.8aa60319.png", import.meta.url).toString();


var $48fa3ada7e686b1a$exports = {};
$48fa3ada7e686b1a$exports = new URL("fire.89ea7ebc.png", import.meta.url).toString();


var $415d18aa5f51d847$exports = {};
$415d18aa5f51d847$exports = new URL("fighting.a8067430.png", import.meta.url).toString();


var $ead8f9cafeaf56cf$exports = {};
$ead8f9cafeaf56cf$exports = new URL("ghost.296a483b.png", import.meta.url).toString();


var $595dbc8433d1bece$exports = {};
$595dbc8433d1bece$exports = new URL("grass.fe2f7ce0.png", import.meta.url).toString();


var $50b5de1068425664$exports = {};
$50b5de1068425664$exports = new URL("heart.d58caa93.png", import.meta.url).toString();


var $f3009342b7c7d604$exports = {};
$f3009342b7c7d604$exports = new URL("ice.cf15ed4e.png", import.meta.url).toString();


var $a97e6e81e3c2cf9d$exports = {};
$a97e6e81e3c2cf9d$exports = new URL("dark.26aa6c52.png", import.meta.url).toString();


var $11595f0963e87a79$exports = {};
$11595f0963e87a79$exports = new URL("poison.9efbfcda.png", import.meta.url).toString();


var $d3ae81e0e92dffdc$exports = {};
$d3ae81e0e92dffdc$exports = new URL("search.6a352167.png", import.meta.url).toString();


var $3345280b24375a6e$exports = {};
$3345280b24375a6e$exports = new URL("speed.d00a8831.png", import.meta.url).toString();


var $32ea101a5a13b663$exports = {};
$32ea101a5a13b663$exports = new URL("thumbsup.cf8720d6.png", import.meta.url).toString();


var $95a2985d9c89a958$exports = {};
$95a2985d9c89a958$exports = new URL("water.666df2a6.png", import.meta.url).toString();


var $8806c3bb473dea10$exports = {};
$8806c3bb473dea10$exports = new URL("normal.f036fc4d.png", import.meta.url).toString();


var $e7bc5d2ad7847004$exports = {};
$e7bc5d2ad7847004$exports = new URL("flying.2c2deca0.png", import.meta.url).toString();


var $8709caa153d0d659$exports = {};
$8709caa153d0d659$exports = new URL("ground.0d6f152f.png", import.meta.url).toString();


var $66970992ebff8da7$exports = {};
$66970992ebff8da7$exports = new URL("rock.6b1082cc.png", import.meta.url).toString();


var $296847204527468d$exports = {};
$296847204527468d$exports = new URL("psychic.78c8ad97.png", import.meta.url).toString();


var $aa4c3de2f6c8f783$exports = {};
$aa4c3de2f6c8f783$exports = new URL("bug.35c08113.png", import.meta.url).toString();


var $3534b0ed9ac14a1b$exports = {};
$3534b0ed9ac14a1b$exports = new URL("fairy.c32e6e3d.png", import.meta.url).toString();


var $915f0945bdf6dad0$exports = {};
$915f0945bdf6dad0$exports = new URL("steel.85333ba1.png", import.meta.url).toString();


var $d624a448cd8cb068$exports = {};
$d624a448cd8cb068$exports = new URL("fullscreen.053f9bfc.png", import.meta.url).toString();


var $3ade91dbef8955b8$exports = {};
$3ade91dbef8955b8$exports = new URL("normalscreen.158c20c4.png", import.meta.url).toString();


var $85f654f63ea31e48$exports = {};
$85f654f63ea31e48$exports = new URL("backpack.8b3d20cd.webp", import.meta.url).toString();


var $8d19ad41683e3ebe$exports = {};
$8d19ad41683e3ebe$exports = new URL("eevee-bottom.2612c1a3.webp", import.meta.url).toString();


var $1ef443e1b60fc743$exports = {};
$1ef443e1b60fc743$exports = new URL("pokeball.10ecc17a.webp", import.meta.url).toString();


var $c0a3634d18af837f$exports = {};
$c0a3634d18af837f$exports = new URL("pokedex.c174bebc.png", import.meta.url).toString();


var $c16ddfdd140d1770$exports = {};
$c16ddfdd140d1770$exports = new URL("loading.1e3d0f75.gif", import.meta.url).toString();


var $4ee4ad63d3c50bba$exports = {};
$4ee4ad63d3c50bba$exports = new URL("opengraph.54ce0215.jpg", import.meta.url).toString();


var $31272a28ac089079$exports = {};
$31272a28ac089079$exports = new URL("logo.3311eccc.webp", import.meta.url).toString();


var $d4528b74e0e19f46$exports = {};
$d4528b74e0e19f46$exports = new URL("bulbasaur.263249d9.webp", import.meta.url).toString();


var $71d397be911269c4$exports = {};
$71d397be911269c4$exports = new URL("eevee.7e992091.webp", import.meta.url).toString();


var $8be62d65e86ac7f4$exports = {};
$8be62d65e86ac7f4$exports = new URL("pikachu.2cad65a1.webp", import.meta.url).toString();


var $f9d0c73545a168ac$exports = {};
$f9d0c73545a168ac$exports = new URL("snorlax.2aa96b14.webp", import.meta.url).toString();


var $0fab333facf6954a$exports = {};
$0fab333facf6954a$exports = new URL("squirtle.db775511.webp", import.meta.url).toString();


const $d5d3a3fb92434e02$export$31d6f2c3562ba09e = {
    boy1: (/*@__PURE__*/$parcel$interopDefault($33315a45fb2a4a3a$exports)),
    boy2: (/*@__PURE__*/$parcel$interopDefault($70db0d277a09cbdd$exports)),
    boy3: (/*@__PURE__*/$parcel$interopDefault($6c5b6efb9e8b2651$exports)),
    girl1: (/*@__PURE__*/$parcel$interopDefault($34b425da376ce2fc$exports)),
    girl2: (/*@__PURE__*/$parcel$interopDefault($d87cbddfa493f7cf$exports)),
    girl3: (/*@__PURE__*/$parcel$interopDefault($5c73e412f558ab54$exports)),
    girl4: (/*@__PURE__*/$parcel$interopDefault($7626390a2007e86e$exports)),
    girl5: (/*@__PURE__*/$parcel$interopDefault($92a99b5f3984fbc3$exports))
};
const $d5d3a3fb92434e02$export$d041fef2b78b7906 = [
    (0, (/*@__PURE__*/$parcel$interopDefault($1500977ce7e2d078$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($732664e895c57858$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($5e614f98c66496e2$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($f8c70115cfc5a665$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($f93b4581aae4b3eb$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($efbb73e9cffc0f3a$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($c750a93f44bf8ce5$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($35144bbbeeb0b598$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($53b47676dd6c30ef$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($8fee3fb890f71334$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($bd5c5a1c6ff6f905$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($0f87592535210faa$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($abbd1c6b366e6b80$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($2c2937c3343a2024$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($28fe971fe505b13b$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($864581fae9d2f811$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($8491cc410388103e$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($521e9ad6bc0db385$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($d60d7839cda6f804$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($2067556ff9165c16$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($8b93b2c9047595b0$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($b6d3ed4ff3296c52$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($b3c217d4c02517bf$exports)))
];
const $d5d3a3fb92434e02$export$df03f54e09e486fa = {
    pixelPokeball: (/*@__PURE__*/$parcel$interopDefault($d09d72cb097d3744$exports)),
    attackSpecial: (/*@__PURE__*/$parcel$interopDefault($55402e5801851cdd$exports)),
    defenseSpecial: (/*@__PURE__*/$parcel$interopDefault($000901b2e36ea7ac$exports)),
    defense: (/*@__PURE__*/$parcel$interopDefault($16f3e5f5db0115af$exports)),
    dragon: (/*@__PURE__*/$parcel$interopDefault($a50081d176e794fe$exports)),
    fire: (/*@__PURE__*/$parcel$interopDefault($48fa3ada7e686b1a$exports)),
    fighting: (/*@__PURE__*/$parcel$interopDefault($415d18aa5f51d847$exports)),
    ghost: (/*@__PURE__*/$parcel$interopDefault($ead8f9cafeaf56cf$exports)),
    grass: (/*@__PURE__*/$parcel$interopDefault($595dbc8433d1bece$exports)),
    heart: (/*@__PURE__*/$parcel$interopDefault($50b5de1068425664$exports)),
    ice: (/*@__PURE__*/$parcel$interopDefault($f3009342b7c7d604$exports)),
    dark: (/*@__PURE__*/$parcel$interopDefault($a97e6e81e3c2cf9d$exports)),
    poison: (/*@__PURE__*/$parcel$interopDefault($11595f0963e87a79$exports)),
    search: (/*@__PURE__*/$parcel$interopDefault($d3ae81e0e92dffdc$exports)),
    speed: (/*@__PURE__*/$parcel$interopDefault($3345280b24375a6e$exports)),
    thumbsup: (/*@__PURE__*/$parcel$interopDefault($32ea101a5a13b663$exports)),
    water: (/*@__PURE__*/$parcel$interopDefault($95a2985d9c89a958$exports)),
    attack: (/*@__PURE__*/$parcel$interopDefault($58ddffb32cde7e3a$exports)),
    electric: (/*@__PURE__*/$parcel$interopDefault($fee8d448f595bbc1$exports)),
    normal: (/*@__PURE__*/$parcel$interopDefault($8806c3bb473dea10$exports)),
    flying: (/*@__PURE__*/$parcel$interopDefault($e7bc5d2ad7847004$exports)),
    ground: (/*@__PURE__*/$parcel$interopDefault($8709caa153d0d659$exports)),
    rock: (/*@__PURE__*/$parcel$interopDefault($66970992ebff8da7$exports)),
    psychic: (/*@__PURE__*/$parcel$interopDefault($296847204527468d$exports)),
    bug: (/*@__PURE__*/$parcel$interopDefault($aa4c3de2f6c8f783$exports)),
    fairy: (/*@__PURE__*/$parcel$interopDefault($3534b0ed9ac14a1b$exports)),
    steel: (/*@__PURE__*/$parcel$interopDefault($915f0945bdf6dad0$exports)),
    normalscreen: (/*@__PURE__*/$parcel$interopDefault($3ade91dbef8955b8$exports)),
    fullscreen: (/*@__PURE__*/$parcel$interopDefault($d624a448cd8cb068$exports))
};
const $d5d3a3fb92434e02$export$9df96ab17a692a78 = {
    backpack: (/*@__PURE__*/$parcel$interopDefault($85f654f63ea31e48$exports)),
    peekvee: (/*@__PURE__*/$parcel$interopDefault($8d19ad41683e3ebe$exports)),
    pokeball: (/*@__PURE__*/$parcel$interopDefault($1ef443e1b60fc743$exports)),
    pokedex: (/*@__PURE__*/$parcel$interopDefault($c0a3634d18af837f$exports)),
    logo: (/*@__PURE__*/$parcel$interopDefault($31272a28ac089079$exports)),
    loading: (/*@__PURE__*/$parcel$interopDefault($c16ddfdd140d1770$exports)),
    opengraph: (/*@__PURE__*/$parcel$interopDefault($4ee4ad63d3c50bba$exports))
};
const $d5d3a3fb92434e02$export$72d98a059df66e6b = {
    pikachu: (/*@__PURE__*/$parcel$interopDefault($8be62d65e86ac7f4$exports)),
    bulbasaur: (/*@__PURE__*/$parcel$interopDefault($d4528b74e0e19f46$exports)),
    squirtle: (/*@__PURE__*/$parcel$interopDefault($0fab333facf6954a$exports)),
    eevee: (/*@__PURE__*/$parcel$interopDefault($71d397be911269c4$exports)),
    snorlax: (/*@__PURE__*/$parcel$interopDefault($f9d0c73545a168ac$exports))
};


const $f924761f4f77a8a5$export$85a79cba423d2c2d = `

      <div class="plain-logo">
        <img src="${(0, $d5d3a3fb92434e02$export$9df96ab17a692a78).logo}" alt="Cartermon Logo" />
      </div>
      <section class="hero">
        <div class="hero__left">
          <div class="hero__title">
            <h1 class="bilboard">
              Catch
              <span
                ><img
                  class="hero__sprite"
                  src="${(0, $d5d3a3fb92434e02$export$72d98a059df66e6b).bulbasaur}"
                  alt="Bulbasaur"
              /></span>
              Pokemon.
            </h1>
            <h2 class="bilboard-sm">Learn stuff.</h2>
          </div>
          <div class="hero__description">
            <p class="general-text">
              Solve math problems to catch Pokemon and build your collection! Practice addition and subtraction while exploring different environments and discovering new Pokemon. Challenge yourself and become a math master trainer.
            </p>
          </div>

          ${(0, $8536cb1d01d30dc7$export$eee7ace900e487d2)({
    type: "nav",
    path: "/signup",
    color: "yellow",
    text: "New Game"
})}

          ${(0, $8536cb1d01d30dc7$export$eee7ace900e487d2)({
    type: "nav",
    path: "/continue",
    color: "blue",
    text: "Continue"
})}
        
        </div>
        <div class="hero__right">
          <img
            src="${(0, $d5d3a3fb92434e02$export$72d98a059df66e6b).pikachu}"
            alt="Pikachu"
            class="hero__right--pikachu"
          />
          <img
            src="${(0, $d5d3a3fb92434e02$export$72d98a059df66e6b).eevee}"
            alt="Eeevee"
            class="hero__right--eevee"
          />
          <img
            src="${(0, $d5d3a3fb92434e02$export$9df96ab17a692a78).pokeball}"
            alt="Pokeball"
            class="hero__right--pokeball"
          />
        </div>
      </section>
    
`;


class $e62c72fc12a85f1f$var$HomeView {
    constructor(){
        this.container = document.querySelector("#game-container");
    }
    render() {
        const template = (0, $f924761f4f77a8a5$export$85a79cba423d2c2d);
        this.container.innerHTML = template;
    // this._updateNavigationLinks();
    }
}
var $e62c72fc12a85f1f$export$2e2bcd8739ae039 = new $e62c72fc12a85f1f$var$HomeView();




const $0c07c2da401182a5$export$82f49880f494ecdd = (data)=>{
    const [id, value] = data;
    return `
  <div class="avatar-card">
        <input
            type="radio"
            id="${id}"
            value="${id}"
            name="avatar"
         />
        <label for="${id}">
            <img
              class="avatar-card__img"
              src="${value}"
              alt="Avatar ${id}"
            />
        </label>
    </div>`;
};



const $9e79c22c339a5461$export$c2116f2e983f35e = (level = "normal")=>{
    if (![
        "easy",
        "normal",
        "hard"
    ].includes(level)) level = "error";
    const config = {
        easy: {
            text: "easy",
            id: "easy",
            pokeballs: 5,
            numbers: "0 - 20 Numbers"
        },
        normal: {
            text: "normal",
            id: "normal",
            pokeballs: 3,
            numbers: "2 Digit Numbers"
        },
        hard: {
            text: "hard",
            id: "hard",
            pokeballs: 1,
            numbers: "3 Digit Numbers"
        },
        error: {
            text: "Component Error!",
            id: "error",
            pokeballs: 0,
            numbers: "Something went wrong."
        }
    };
    return `
    <!-- Difficulty Card-->
    <div class="difficulty-selection">
          <input type="radio" id="${config[level].id}" value="${config[level].id}" name="difficulty" />
          <label for="${config[level].id}">
              <div class="difficulty-selection--${config[level].id}">${config[level].text}</div>
          </label>
          <div class="difficulty-selection__description">
                <p class="play-label">
                 <span
                    ><img
                        src="${(0, $d5d3a3fb92434e02$export$df03f54e09e486fa).pixelPokeball}"
                        alt="Pokeball"
                        class="difficulty-selection__description--pokeball"
                    />
                 </span>
                      X ${config[level].pokeballs}
                </p>
                <p class="play-label">${config[level].numbers}</p>
                <p class="play-label">+/-</p>
          </div>
    </div>
    
    `;
};


const $3712bfde40b5e5cd$export$fa71a3504620f4a2 = `

      <form class="signup-form">
        <div class="signup-form__left">
          <div>
            <legend class="rowdie-title signup-form__label">Name</legend>
            <input
              type="text"
              name="name"
              id="username"
              placeholder="Enter your name"
              class="signup-form--username"
            />
          </div>
          <div>
            <legend class="rowdie-title signup-form__label">Picture</legend>
            <fieldset class="signup-form--avatar">
              ${Object.entries((0, $d5d3a3fb92434e02$export$31d6f2c3562ba09e)).map((id)=>(0, $0c07c2da401182a5$export$82f49880f494ecdd)(id)).join("")}

            </fieldset>
          </div>
        </div>
        <div class="signup-form__right">
          <legend class="rowdie-title signup-form__label">Difficulty</legend>
          <fieldset class="signup-form--difficulty">
            ${(0, $9e79c22c339a5461$export$c2116f2e983f35e)("easy")}
            ${(0, $9e79c22c339a5461$export$c2116f2e983f35e)("normal")}
            ${(0, $9e79c22c339a5461$export$c2116f2e983f35e)("hard")}

          </fieldset>
        </div>

        ${(0, $8536cb1d01d30dc7$export$eee7ace900e487d2)({
    use: "nav",
    color: "yellow",
    text: "Start >>>",
    type: "submit"
})}
        
      </form>
    
`;



const $5ac38a8fa098a147$export$b72337ff35e9c24a = (gameModel = {})=>{
    const data = gameModel.player;
    let avatarLink = "";
    // console.log("navBarComponent compiling.....");
    // console.log(gameModel);
    // console.log(data);
    if (data.avatar) avatarLink = `
    
        <a href="/main" data-nav="/main"
          ><img
            class="navigation__icon"
            src="${(0, $d5d3a3fb92434e02$export$31d6f2c3562ba09e)[data.avatar]}"
            alt="User Avatar"
        /></a>
 `;
    return `
    <nav class="navigation">
      <a href="/" data-nav="/"
        ><img
          class="navigation__logo"
          src="${(0, $d5d3a3fb92434e02$export$9df96ab17a692a78).logo}"
          alt="Cartermon Logo"
      /></a>
      <div class="navigation__icon-container">
      ${avatarLink}

        <a href="/pokedex" data-nav="/pokedex"
          ><img
            class="navigation__icon"
            src="${(0, $d5d3a3fb92434e02$export$9df96ab17a692a78).pokedex}"
            alt="Pokedex Icon"
        /></a>
        <a href="/learn" data-nav="/learn"
          ><img
            class="navigation__icon"
            src="${(0, $d5d3a3fb92434e02$export$9df96ab17a692a78).backpack}"
            alt="Backpack Icon (Learn)"
        /></a>
        <a href="/explore" data-nav="/explore"
          ><img
            class="navigation__icon"
            src="${(0, $d5d3a3fb92434e02$export$9df96ab17a692a78).pokeball}"
            alt="Explore Icon"
        /></a>
      </div>
    </nav>
    
    
    `;
};



class $253d11dd669aa9e8$var$SignUpView {
    _startButton;
    _form;
    _avatarContainer;
    _difficultyContainer;
    _nameInput;
    _inputContainers;
    _allInputFields;
    userDetails = {
        name: "",
        avatar: "",
        difficulty: "",
        id: "",
        caught: [],
        pokeballs: 0,
        answers: 0
    };
    constructor(){
        this.container = document.querySelector("#game-container");
    }
    // Initiates page element variables & Sets eventlistners after DOM updated with render.
    _initSignUpBehavior() {
        this._setPageElements();
        this._applyEventListener();
    }
    // Sets page elements
    _setPageElements() {
        this._startButton = document.querySelector('[type="submit"]');
        this._form = document.querySelector(".signup-form");
        this._avatarContainer = document.querySelector(".signup-form--avatar");
        this._difficultyContainer = document.querySelector(".signup-form--difficulty");
        this._nameInput = document.querySelector(".signup-form--username");
        this._allInputFields = document.querySelectorAll("input");
        this._inputContainers = {
            name: this._nameInput,
            avatar: this._avatarContainer,
            difficulty: this._difficultyContainer
        };
    }
    //Applies event listeners
    _applyEventListener() {
        this._startButton.addEventListener("click", this._getPlayerData.bind(this));
        //Prevent premature submit from name input field.
        this._nameInput.addEventListener("keydown", (e)=>{
            if (e.key === "Enter") e.preventDefault();
        });
    }
    // Gets data from form via eventlistner on submit button & passes to
    // validation method.
    _getPlayerData(e) {
        e.preventDefault();
        const userData = new FormData(this._form);
        const rawData = {
            name: userData.get("name"),
            avatar: userData.get("avatar"),
            difficulty: userData.get("difficulty")
        };
        this._validatePlayerData(rawData);
    }
    // Basic input validation (basically 'not empty' validation) & sends to setPlayerData
    _validatePlayerData(inputData) {
        console.log("Validating Inputs");
        let validData = true;
        for (const [key, value] of Object.entries(inputData))if (!value) {
            console.log(this._inputContainers);
            validData = false;
            this._inputContainers[key].classList.add("error");
        }
        if (validData) {
            //Removes errors on parent container
            Object.values(this._inputContainers).forEach((container)=>{
                container.classList.remove("error");
            });
            //Clears any value attributes on input
            this._allInputFields.forEach((input)=>{
                input.value = "";
                input.checked = false;
            });
            this._setPlayerData(inputData);
        }
    }
    //Sets the player Data in view State (userDetails) & passes to controller for updating model.
    _setPlayerData(playerData) {
        console.log("Setting Player DATA!");
        // console.log(data);
        this.userDetails.id = Math.ceil(Math.random() * 1000000000);
        this.userDetails.pokeballs = playerData.difficulty == "easy" ? 5 : playerData.difficulty == "normal" ? 3 : 1;
        for (const [key, value] of Object.entries(playerData))this.userDetails[key] = value;
        $f50bd1f2915ed0f2$export$678fa6c2b4075189(this.userDetails);
    }
    // Renders the page in DOM
    render(gameData) {
        // console.log(data);
        const nav = (0, $5ac38a8fa098a147$export$b72337ff35e9c24a)(gameData);
        this.container.innerHTML = nav + (0, $3712bfde40b5e5cd$export$fa71a3504620f4a2);
    }
}
var $253d11dd669aa9e8$export$2e2bcd8739ae039 = new $253d11dd669aa9e8$var$SignUpView();



const $1dea3823b3fecdcf$export$bcd45b28a34b8532 = (playerData, config = {
    cardSize: "mini"
})=>{
    const { cardSize: cardSize } = config;
    // console.log("playerCardComponent compiling...");
    // console.log(cardSize);
    // console.log(cardSize === "main");
    // if (cardSize != "main" || cardSize != "mini") cardSize = "mini";
    const miniHTML = `
        <div class="player-card__avatar-box">
              <img
                class="player-card__img"
                src="${(0, $d5d3a3fb92434e02$export$31d6f2c3562ba09e)[playerData.avatar]}"
                alt="${playerData.name} Player"
              />
        </div>
        <p class="user-name">${playerData.name}</p>
        <div class="player-card__info-title">
              
                <span
                  ><img
                    src="${(0, $d5d3a3fb92434e02$export$df03f54e09e486fa).pixelPokeball}"
                    alt="Pokeball"
                    class="player-card__info-title--img"
                  />
                </span>
                <p class="play-information" id="pokeball-count">X ${playerData.pokeballs}</p>
              
        </div>
    
    `;
    const mainHTML = `
    <div class="player-card__info-title">
      <p class="user-title">Pokemon Caught</p>
    </div>
    <p class="rowdie-stat stat-blue" id="caught-count">${playerData.caught.length}</p>

    <div class="player-card__info-title">
        <p class="user-title">Math Questions</p>
    </div>
    <p class="rowdie-stat stat-purple" id="math-answers">${playerData.answers}</p>
    
    `;
    // console.log(cardSize);
    const template = `
    <div class="player-card player-card--${cardSize}" data-id="${playerData.id}">
    ${miniHTML}
    ${cardSize === "main" ? mainHTML : ""}
    </div>
    
    `;
    return template;
};


const $a1a6a59c0d377424$export$d00928c9ba604a03 = (playersArray)=>{
    return `

 
      <section class="continue">
        <div class="continue__title">
          <p class="rowdie-title">Select Your Player</p>
        </div>

        <div class="continue__player-container">
        ${playersArray.map((player)=>(0, $1dea3823b3fecdcf$export$bcd45b28a34b8532)(player)).join("")}
          
        </div>
      </section>
    


`;
};




class $e7ec573de5a691d3$var$ContiueView {
    _playerCards;
    constructor(){
        this.container = document.querySelector("#game-container");
    }
    _initContinueBehavior() {
        this._playerCards = document.querySelectorAll(".player-card");
        // console.log(this._playerCards);
        this._playerCards.forEach((element)=>element.addEventListener("click", this._getAndSendPlayerID));
    }
    _getAndSendPlayerID() {
        const playerId = this.dataset.id;
        // console.log("This is player: " + playerId);
        $f50bd1f2915ed0f2$export$9261e82cb75ec79f(playerId);
    }
    render(gameData) {
        const players = gameData.allPlayers;
        const nav = (0, $5ac38a8fa098a147$export$b72337ff35e9c24a)(gameData);
        this.container.innerHTML = nav + (0, $a1a6a59c0d377424$export$d00928c9ba604a03)(players);
    }
}
var $e7ec573de5a691d3$export$2e2bcd8739ae039 = new $e7ec573de5a691d3$var$ContiueView();





const $c22454d1ec6fd565$export$11e71fb9b9ec7230 = (type)=>{
    const configSettings = {
        pokedex: {
            name: "Pokedex",
            color: "red",
            text: "View all the Pokemon you have caught, and look up others you want to know more about.",
            cta: "view",
            image: (0, $d5d3a3fb92434e02$export$9df96ab17a692a78).pokedex,
            url: "/pokedex"
        },
        learn: {
            name: "Learn",
            color: "purple",
            text: "Earn Pokeballs by practicing your Math skills. Answer questions & get Pokeballs!",
            cta: "earn",
            image: (0, $d5d3a3fb92434e02$export$9df96ab17a692a78).backpack,
            url: "/learn"
        },
        explore: {
            name: "Explore",
            color: "blue",
            text: "Search for Pokemon in the wild. Capture them if you have a Pokeball.",
            cta: "search",
            image: (0, $d5d3a3fb92434e02$export$9df96ab17a692a78).pokeball,
            url: "/explore"
        }
    };
    return `
  <div class="gameplay-card gameplay-card--${configSettings[type].color}">
        <img
              src="${configSettings[type].image}"
              alt="Pokedex"
              class="gameplay-card__img"
              data-nav="${configSettings[type].url}"
        />
        <p class="play-information">${configSettings[type].name}</p>
        <p class="general-text">
              ${configSettings[type].text}
        </p>
        <a
              data-nav="${configSettings[type].url}" 
              class="play-information stat-${configSettings[type].color} gameplay-card__nav"
              >${configSettings[type].cta} >
        </a>
  </div>
  `;
};


const $28a3e99f38f50f69$export$e26c86124a0f221e = (gameModel)=>{
    const { player: player } = gameModel;
    return `
  ${(0, $5ac38a8fa098a147$export$b72337ff35e9c24a)(gameModel)}
 
      <section class="main-screen">
      ${(0, $1dea3823b3fecdcf$export$bcd45b28a34b8532)(player, {
        cardSize: "main"
    })}

        <div class="main-screen__game-paths">
         ${(0, $c22454d1ec6fd565$export$11e71fb9b9ec7230)("pokedex")}
         ${(0, $c22454d1ec6fd565$export$11e71fb9b9ec7230)("learn")}
         ${(0, $c22454d1ec6fd565$export$11e71fb9b9ec7230)("explore")}
          
        </div>
      </section>
    
  `;
};


class $807bda42778eb70b$var$MainView {
    constructor(){
        this.container = document.querySelector("#game-container");
    }
    render(gameModel) {
        this.container.innerHTML = (0, $28a3e99f38f50f69$export$e26c86124a0f221e)(gameModel);
    }
}
var $807bda42778eb70b$export$2e2bcd8739ae039 = new $807bda42778eb70b$var$MainView();


/**
 *
 * @param {*} mathObj - Matth Question Object with 3 questions
 * @returns - A compiled set of Math Question Cards
 */ const $ecb05b2a0952b58b$export$2414765950ed13bf = (mathObj)=>{
    const questionsArray = [];
    for (const key of Object.keys(mathObj)){
        // console.log(`${key}:`);
        // console.log(mathObj[key]);
        const { qnumber: qnumber, operand: operand, top: top, bottom: bottom, choices: choices } = mathObj[key];
        const html = `
    <fieldset class="math-question" id="${key}">
        <p class="play-information">Question #${qnumber}</p>

        <!--Equation-->
        <div class="math-question__equation">
            <p class="math-question--operator math-equation">${operand}</p>
            <div class="math-question__numbers">
                <p class="math-equation math-question__numbers--top">${top}</p>
                <p class="math-equation math-question__numbers--bottom">
                      ${bottom}
                </p>
            </div>
        </div>

                <!-- Answers-->
                <div class="math-question__answers-block">

                ${choices.map((choice, index)=>` <!--input-->
                  <label for="${key}a${index + 1}" class="math-question__answer">
                    <input type="radio" name="${key}" id="${key}a${index + 1}" value="${choice}" />
                    <p class="math-answer">${choice}</p>
                  </label>
                  <!--end input -->`).join("")}
                 
                  
                </div>
     </fieldset>
    
    `;
        questionsArray.push(html);
    }
    const compiledHTML = questionsArray.join("");
    return compiledHTML;
};





/**
 *
 * @param {*} config - name, page (explore || learn), caught(boolean), pokeballCount
 * @returns
 */ const $49f6f33438e09960$export$f780f1a8d3e2b1d = (config)=>{
    const { name: name, page: page, caught: caught = false, pokeballs: pokeballs } = config;
    let message;
    const state = caught ? "caught" : pokeballs ? "" : "no-balls";
    const stateMessage = caught ? "caught" : pokeballs ? "catch" : "No Balls";
    let buttonHTML;
    if (page === "explore") {
        message = `A wild <span class="stat-blue">${name.toUpperCase()}</span> appeared!`;
        buttonHTML = `
    <button class="info-bar__button--catch play-information ${state}" id="catch">
        ${stateMessage}
    </button>
    <button class="info-bar__button--search play-information" id="search-pokemon">
        search
    </button>
    `;
    } else {
        message = `Get all 3 correct to earn a Pokeball.`;
        buttonHTML = `
    <button class="info-bar__button--yellow play-information" id="check-answers">Check Answers</button>`;
    }
    return `
 <!--Info bar-->
    <div class="info-bar">
        <div class="info-bar__title">
            <p class="rowdie-title">${message}</p>
        </div>
        <div class="info-bar__button-group">
       ${buttonHTML}
        </div>
    </div>
<!--END Info bar-->
`;
}; // <!-- INFO BAR -->
 //           <div class="info-bar">
 //             <div class="info-bar__title">
 //               <p class="rowdie-title">
 //                 A wild <span class="stat-blue">${name}</span> appeared!
 //               </p>
 //             </div>
 //             <!-- Add CAUGHT class to change-->
 //             <!--Add no-balls class to change-->
 //             <button class="info-bar__button--catch play-information" id="catch">
 //               catch
 //             </button>
 //             <button
 //               class="info-bar__button--search play-information"
 //               id="catch"
 //             >
 //               search
 //             </button>
 //           </div>
 // <!-- END INFO BAR -->


const $212e503a8f116404$export$4f00bb6728267b1c = (gameModel, mathObj)=>{
    return `
  ${(0, $5ac38a8fa098a147$export$b72337ff35e9c24a)(gameModel)}

      <section class="learn">
      ${(0, $1dea3823b3fecdcf$export$bcd45b28a34b8532)(gameModel.player, {
        cardSize: "main"
    })}

        <div class="learn__math-container">

        ${(0, $49f6f33438e09960$export$f780f1a8d3e2b1d)({
        page: "learn"
    })}

          <div class="learn__math-container--questions">
            <form class="learn__math-quiz">
             ${(0, $ecb05b2a0952b58b$export$2414765950ed13bf)(mathObj)}
            </form>
          </div>
          <div class="learn__success-container hide">
            <img
              src="${(0, $d5d3a3fb92434e02$export$9df96ab17a692a78).pokeball}"
              alt="Pokeball"
              class="learn__success-container--pokeball"
            />
            <button
              class="learn__button play-information" id="play-again"
            >
              Play Again?
            </button>
          </div>
        </div>
      </section>
   

`;
};




class $97823873a87ace75$var$LearnView {
    _mathQuestionObj;
    _userAnswers = {
        correct: 0
    };
    _currentPlayer;
    _questionsContainer;
    _messageBar;
    _submitBtn;
    _playAgainBtn;
    _allQuestionContainers;
    _mathForm;
    _allRadioAnswers;
    _successContainer;
    constructor(){
        this._container = document.querySelector("#game-container");
    }
    _initiateElements() {
        this._questionsContainer = document.querySelector(".learn__math-container--questions");
        this._messageBar = document.querySelector(".info-bar__title p");
        this._submitBtn = document.querySelector("#check-answers");
        this._playAgainBtn = document.querySelector("#play-again");
        this._allQuestionContainers = document.querySelectorAll(".math-question");
        this._mathForm = document.querySelector(".learn__math-quiz");
        this._allRadioAnswers = document.querySelectorAll("input");
        this._successContainer = document.querySelector(".learn__success-container");
        //Handles updating UI to show gameModel Stats without a full model call.
        this._pokeCount = document.querySelector("#pokeball-count");
        this._answerCount = document.querySelector("#math-answers");
        //Apply Event Listeners
        this._submitBtn.addEventListener("click", this._checkAnswers.bind(this));
        this._playAgainBtn.addEventListener("click", this._resetMath.bind(this));
    }
    _checkAnswers() {
        //Takes all input elements, loops through and checks if inpue value = answer.
        this._allRadioAnswers.forEach((input)=>{
            let isCorrect;
            // console.log(input);
            input.classList.remove("wrong");
            if (input.checked) {
                // input.classList.remove("wrong");
                isCorrect = this._mathQuestionObj[input.name].answer === +input.value;
                input.checked = false;
                if (isCorrect) {
                    input.classList.add("correct");
                    //Update correct answers in view answers object.
                    this._userAnswers.correct++;
                    //Updates player answers in view current player state.
                    this._currentPlayer.answers++;
                    //Updates DOM element
                    this._answerCount.innerText = `${this._currentPlayer.answers}`;
                    document.querySelector(`#${input.name}`).disabled = true;
                } else {
                    console.log("WRONG FIRED!");
                    // console.log(input);
                    input.classList.add("wrong");
                }
                console.log(this._userAnswers);
                this._updateMessage();
                this._showSuccess();
            }
        });
        //Sends view player State to controller to update whole gameModel
        $f50bd1f2915ed0f2$export$a955988b42e8709c(this._currentPlayer);
    }
    _updateMessage(message) {
        if (!message) this._messageBar.innerText = `You have ${this._userAnswers.correct} correct. Try Again.`;
        else this._messageBar.innerText = message;
    }
    _showSuccess() {
        if (this._userAnswers.correct === 3) {
            //Updates styling of view elements
            this._submitBtn.classList.add("inactive");
            this._questionsContainer.classList.add("hide");
            this._successContainer.classList.remove("hide");
            //Updates view player State pokeball count.
            this._currentPlayer.pokeballs++;
            this._pokeCount.innerText = `X ${this._currentPlayer.pokeballs}`;
            //Sends view player State to controller to update gameModel
            $f50bd1f2915ed0f2$export$a955988b42e8709c(this._currentPlayer);
            // console.log(this._currentPlayer);
            this._resetAnswerCount();
            this._updateMessage(`You earned a Pokeball!`);
        // #############################
        //Going to need logic fo handling upading user state passed back to controller.
        // #############################
        }
    }
    _resetAnswerCount() {
        this._userAnswers.correct = 0;
    }
    _resetMath() {
        this._mathForm.innerHTML = "";
        // Gets new questions for Math cards from controller
        this._mathQuestionObj = $f50bd1f2915ed0f2$export$104277515a263bd7();
        //Creates html of new math cards.
        const html = (0, $ecb05b2a0952b58b$export$2414765950ed13bf)(this._mathQuestionObj);
        //Updates DOM element with cards.
        this._mathForm.innerHTML = html;
        //Re-iniate elements and event listeners since DOM was cleared.
        // I think this is adding a 2second event listenr to the button, so it fires twice.
        //This would cause the first round to work but then clear right away?
        // this._initiateElements();
        this._allRadioAnswers = document.querySelectorAll("input");
        this._successContainer.classList.add("hide");
        this._questionsContainer.classList.remove("hide");
        this._submitBtn.classList.remove("inactive");
        this._updateMessage("Get all 3 correct to earn a Pokeball.");
    }
    render(gameModel, mathObj) {
        // console.log("Rendering LEARN.. gameModel passed =");
        // console.log(gameModel);
        this._mathQuestionObj = mathObj;
        this._currentPlayer = gameModel.player;
        this._container.innerHTML = (0, $212e503a8f116404$export$4f00bb6728267b1c)(gameModel, mathObj);
        this._resetAnswerCount();
    }
}
var $97823873a87ace75$export$2e2bcd8739ae039 = new $97823873a87ace75$var$LearnView();






const $19238b7c45b8f10c$export$673801332369f18d = (gameModel, pokemonObj, render = "full")=>{
    const bgIndex = Math.floor(Math.random() * (0, $d5d3a3fb92434e02$export$d041fef2b78b7906).length);
    // console.log("Background Index: " + bgIndex);
    const scene = (0, $d5d3a3fb92434e02$export$d041fef2b78b7906)[bgIndex];
    const { name: name, sprites: { front_default: spriteImg }, sprites: { other: { showdown: { front_default: spriteGif } } } } = pokemonObj;
    const formattedName = name[0].toUpperCase() + name.slice(1);
    const caught = gameModel.player.caught.includes(formattedName);
    const pokeballCount = gameModel.player.pokeballs;
    if (render == "full") return `
    
    ${(0, $5ac38a8fa098a147$export$b72337ff35e9c24a)(gameModel)}
    
      <section class="explore">
        ${(0, $1dea3823b3fecdcf$export$bcd45b28a34b8532)(gameModel.player, {
        cardSize: "main"
    })}

        <!-- This stays in template-->
        <div class="explore__game-container">
          
        ${(0, $49f6f33438e09960$export$f780f1a8d3e2b1d)({
        name: name,
        page: "explore",
        caught: caught,
        pokeballs: pokeballCount
    })}

          <div class="explore__game-container--screen">
            <!-- MAIN EXPLORE SCREEN-->
            <div class="explore__game-container--pokemon">
              <img
                src="${scene}"
                class="explore__scene"
                alt="Scene Background"
              />
              <img
                src="${spriteGif}"
                class="explore__character"
                data-pokemon="${formattedName}"
                alt="${name}"
              />
            </div>

            <!-- SUCCESS SCREEN-->
            <div class="explore__game-container--success hide">
              <img src="${(0, $d5d3a3fb92434e02$export$9df96ab17a692a78).pokeball}" alt="Pokeball" />
              <p class="play-information">You caught a ${name}!</p>
              <div class="explore__game-container--success-button-group">
                <button
                  class="info-bar__button--search play-information"
                  id="search-pokemon"    
                >
                  search
                </button>

                <button
                  data-nav="/main"
                  class="info-bar__button--home play-information"
                  id="go-home"
                >
                  Go Home
                </button>
              </div>
            </div>
            <!--END SUCCESS SCREEN-->
          </div>
        </div>
      </section>
   
    
    
    
    `;
    if (render == "scene") return `

      ${(0, $49f6f33438e09960$export$f780f1a8d3e2b1d)({
        name: name,
        page: "explore",
        caught: caught,
        pokeballs: pokeballCount
    })}

          <div class="explore__game-container--screen">
            <!-- MAIN EXPLORE SCREEN-->
    <div class="explore__game-container--pokemon">
              <img
                src="${scene}"
                class="explore__scene"
                alt="Scene Background"
              />
              <img
                src="${spriteGif}"
                class="explore__character"
                data-pokemon="${formattedName}"
                alt="${name}"
              />
            </div>

            <!-- SUCCESS SCREEN-->
            <div class="explore__game-container--success hide">
              <img src="${(0, $d5d3a3fb92434e02$export$9df96ab17a692a78).pokeball}" alt="Pokeball" />
              <p class="play-information">You caught a ${name}!</p>
              <div class="explore__game-container--success-button-group">
                <button
                  class="info-bar__button--search play-information"
                  id="search-pokemon"    
                >
                  search
                </button>

                <button
                  data-nav="/main"
                  class="info-bar__button--home play-information"
                  id="go-home"
                >
                  Go Home
                </button>
              </div>
            </div>
            <!--END SUCCESS SCREEN-->
    
    `;
};




class $413df4bdc62cd07f$export$9017194c305e0f65 {
    _currentPlayer;
    //   _catchButton;
    //   _sceneContainer;
    constructor(){
        this._container = document.querySelector("#game-container");
    }
    _initiateElements() {
        this._messageBar = document.querySelector(".info-bar__title p");
        //Handles updating UI to show gameModel Stats without a full model call.
        this._pokeCount = document.querySelector("#pokeball-count");
        this._caughtCount = document.querySelector("#caught-count");
        this._catchButton = document.querySelector("#catch");
        this._searchButtons = document.querySelectorAll("#search-pokemon");
        this._homeButton = document.querySelector("#go-home");
        this._successScreen = document.querySelector(".explore__game-container--success");
        this._pokemonSceneContainer = document.querySelector(".explore__game-container--pokemon");
        this._screenContainer = document.querySelector(".explore__game-container--screen");
        this._gameContainer = document.querySelector(".explore__game-container");
        this._pokemon = document.querySelector(".explore__character");
        this._scene = document.querySelector(".explore__scene");
        this._successText = document.querySelector(".explore__game-container--success p");
        // #### ASSIGN EVENT LISTNERS ###########
        this._catchButton.addEventListener("click", this._catchPokemon.bind(this));
        this._searchButtons.forEach((btn)=>btn.addEventListener("click", this._resetExplore.bind(this)));
    }
    _catchPokemon(e) {
        const target = e.target;
        const catchDisabled = target.classList.contains("caught") || target.classList.contains("no-balls");
        //Catch state flag
        if (catchDisabled) return;
        // console.log(this._pokemon);
        // console.log(this._currentPlayer);
        this._showCaughtUI();
        this._currentPlayer.caught.push(this._pokemon.dataset.pokemon);
        this._currentPlayer.pokeballs--;
        this._updatePlayerCard();
        $f50bd1f2915ed0f2$export$a955988b42e8709c(this._currentPlayer);
    }
    _updatePlayerCard() {
        this._caughtCount.innerText = this._currentPlayer.caught.length;
        this._pokeCount.innerText = `X ${this._currentPlayer.pokeballs}`;
    }
    _showCaughtUI() {
        this._pokemonSceneContainer.classList.add("hide");
        this._successScreen.classList.remove("hide");
        this._messageBar.innerText = "Good job!";
        this._catchButton.classList.add("caught");
        this._catchButton.innerText = "caught";
    }
    async _resetExplore() {
        const newPokemon = await $f50bd1f2915ed0f2$export$9af4bf1b8bed8250();
        const html = (0, $19238b7c45b8f10c$export$673801332369f18d)({
            player: this._currentPlayer
        }, newPokemon, "scene");
        this._gameContainer.innerHTML = html;
        this._initiateElements();
    }
    render(gameModel, pokemon) {
        this._currentPlayer = gameModel.player;
        const html = (0, $19238b7c45b8f10c$export$673801332369f18d)(gameModel, pokemon);
        this._container.innerHTML = html;
    }
}
var $413df4bdc62cd07f$export$2e2bcd8739ae039 = new $413df4bdc62cd07f$export$9017194c305e0f65();




function $20739f136d532ade$export$a5d5457d98639921(id) {
    let formattedID;
    if (id < 10) formattedID = `00${id}`;
    else if (id >= 10 && id <= 99) formattedID = `0${id}`;
    else formattedID = id;
    return formattedID;
}


const $89cadda6d12330eb$export$c4222a73fc779a19 = (pokeObj)=>{
    const { id: id, name: name, sprite: sprite, caught: caught } = pokeObj;
    const formattedID = (0, $20739f136d532ade$export$a5d5457d98639921)(id);
    return `
    <div class="pokemon-card" data-id="${id}">
        <img src="${sprite}" alt="${name}" class="pokemon-card__sprite">
        <p class="rowdie-label">${name}</p>
        <p class="pokedex-value pokemon-card__id">#${formattedID}</p>
        <img src="${(0, $d5d3a3fb92434e02$export$df03f54e09e486fa).pixelPokeball}" alt="Caught" class="pokemon-card__caught ${caught ? "" : "hide"}">
    </div>
    `;
};



const $f997397d1d081d02$export$d636f69f7916997b = (pokemon = {})=>{
    /*
sprite ✅
id (formatted) -- meed logic
caught status -- need logic ✅
name ✅
types [array] -- need logic for class & element creation ✅
abilities [array] -- need logic for element creation ✅
height ✅
weight ✅
hp ✅
speed ✅
attack ✅
attack-special ✅
defense ✅
defense-special ✅
evolution (name, sprite) [array of {}] - logic for creation
*/ const { name: name = null, id: id = null, caught: caught = null, sprite: sprite = null, types: types = [], abilities: abilities = [], height: height = null, weight: weight = null, hp: hp = null, speed: speed = null, attack: attack = null, defense: defense = null, attack_special: attack_special = null, defense_special: defense_special = null } = pokemon;
    return `

<!--Pokemon Img-->
            <img
              src="${sprite}"
              alt="${name}"
              class="pokemon-details__sprite"
            />
            <!--Pokemon #003-->
            <p class="pokedex-value pokemon-details__id">#${id}</p>
            <!-- Pokemon caught icon | hidden by default-->
            <img
              src="${(0, $d5d3a3fb92434e02$export$df03f54e09e486fa).pixelPokeball}"
              alt="Caught"
              class="pokemon-details__caught ${caught ? "" : "hide"}"
            />
            <!--Pokemon Name-->
            <p class="rowdie-title">${name}</p>
            <!--Pokemon Type Container-->
            <div class="pokemon-details__type">
                ${types.map((type)=>`<p class="pokemon-details__type--${type}">${type}</p>`).join("")}

            </div>
            <!--Pokemon Abilities Container-->
            <div class="pokemon-details__abilities">
              <p class="rowdie-label">Abilities</p>
              ${abilities.map((ability)=>`<p class="pokedex-value pokemon-details__abilities--text">
                ${ability}
              </p>`).join("")}
            </div>
            <!--Pokemon Height & Weight-->
            <div class="pokemon-details__attributes">
              <div class="pokemon-details__attributes--height">
                <p class="rowdie-label">Height</p>
                <p
                  class="pokedex-value pokemon-details__attributes--text"
                  id="height"
                >
                  ${height}
                </p>
              </div>
              <div class="pokemon-details__attributes--weight">
                <p class="rowdie-label">Weight</p>
                <p
                  class="pokedex-value pokemon-details__attributes--text"
                  id="weight"
                >
                  ${weight} lbs
                </p>
              </div>
            </div>
            <!--Pokemon SWkills Container-->
            <div class="pokemon-details__skills">
              <p class="rowdie-label">Skills</p>
              <!-- skill -->
              <div class="pokemon-details__skills--skill">
                <img
                  src="${(0, $d5d3a3fb92434e02$export$df03f54e09e486fa).heart}"
                  alt="HP"
                  class="pokemon-details__skills--icon"
                />
                <p class="pokedex-value" id="hp">${hp}</p>
              </div>
              <!-- end skill -->
              <!-- skill -->
              <div class="pokemon-details__skills--skill">
                <img
                  src="${(0, $d5d3a3fb92434e02$export$df03f54e09e486fa).speed}"
                  alt="Speed"
                  class="pokemon-details__skills--icon"
                />
                <p class="pokedex-value" id="speed">${speed}</p>
              </div>
              <!-- end skill -->
              <!-- skill -->
              <div class="pokemon-details__skills--skill">
                <img
                  src="${(0, $d5d3a3fb92434e02$export$df03f54e09e486fa).attack}"
                  alt="Attack"
                  class="pokemon-details__skills--icon"
                />
                <p class="pokedex-value" id="attack">${attack}</p>
              </div>
              <!-- end skill -->
              <!-- skill -->
              <div class="pokemon-details__skills--skill">
                <img
                  src="${(0, $d5d3a3fb92434e02$export$df03f54e09e486fa).attackSpecial}"
                  alt="Special Attack"
                  class="pokemon-details__skills--icon"
                />
                <p class="pokedex-value" id="attack-special">${attack_special}</p>
              </div>
              <!-- end skill -->
              <!-- skill -->
              <div class="pokemon-details__skills--skill">
                <img
                  src="${(0, $d5d3a3fb92434e02$export$df03f54e09e486fa).defense}"
                  alt="Defense"
                  class="pokemon-details__skills--icon"
                />
                <p class="pokedex-value" id="defense">${defense}</p>
              </div>
              <!-- end skill -->
              <!-- skill -->
              <div class="pokemon-details__skills--skill">
                <img
                  src="${(0, $d5d3a3fb92434e02$export$df03f54e09e486fa).defenseSpecial}"
                  alt="Defense Special"
                  class="pokemon-details__skills--icon"
                />
                <p class="pokedex-value" id="defense-special">${defense_special}</p>
              </div>
              <!-- end skill -->
            </div>

            <!--Pokemon Evolution-->
            <div class="pokemon-details__evolution">
              <p class="rowdie-label">Evolution</p>
                <p class="pokedex-value">Coming Soon.</p>

              <! -- 
              <img
                src="${(0, $d5d3a3fb92434e02$export$72d98a059df66e6b).squirtle}"
                alt="Squritle"
                class="pokemon-details__evolution--stage"
              /> 
              <! -- 
              <img
                src="${(0, $d5d3a3fb92434e02$export$72d98a059df66e6b).bulbasaur}"
                alt="Squritle"
                class="pokemon-details__evolution--stage"
              /> 
              <! -- 
              <img
                src="${(0, $d5d3a3fb92434e02$export$72d98a059df66e6b).pikachu}"
                alt="Squritle"
                class="pokemon-details__evolution--stage"
              /> 
              
            </div>

`;
};



const $dcdd4dc47fb91da1$export$8301f40aa4138471 = (gameModel)=>{
    return `
    ${(0, $5ac38a8fa098a147$export$b72337ff35e9c24a)(gameModel)}
        
      <section class="pokedex">

<!-- #########################-->
<!-- Side Pokemon Details Card-->

        <div class="pokemon-details">
 <!-- Empty State-->
          <div class="pokemon-details__empty">
            <p class="play-information" id="details-error">Select or <br />Search for <br />a Pokemon</p>
          </div>
<!-- End Empty State-->

 <!-- Loading State-->
          <div class="pokemon-details__loading hide">
            <img src="${(0, $d5d3a3fb92434e02$export$9df96ab17a692a78).loading}" alt="Loading">
            <p class="play-information">loading..</p>
          </div>
<!-- End Loading State-->

 <!-- DATA -->
          <div class="pokemon-details__data hide">
            ${(0, $f997397d1d081d02$export$d636f69f7916997b)()};
          </div>
        </div>

<!-- End Pokemon Details Card -->
<!-- #########################-->


        <div class="pokedex__container">

 <!-- Search Field -->
          <form>
              <input class="pokedex__search" name="pokemon-search" placeholder="Search Pokemon">
            </input>
            <button alt="Search Button" class="pokedex__search--btn"></button>
        </form>
          <!-- End Search Field -->
          <div class="pokedex__display">

 <!-- Filter Component-->
            <div class="pokedex__filter">
              <p class="play-label">Filter</p>

              <!--Type filter checkbox-->
              <div class="pokedex__filter--type pokedex__filter--caught">
                <input type="checkbox" name="type" id="caught" value="caught">
                <label for="caught" title="Caught Pokemon">
                  <img src="${(0, $d5d3a3fb92434e02$export$df03f54e09e486fa).pixelPokeball}" alt="Caught" class="pokedex__filter--icon">
                </label>
              </div>

                <!--Type filter checkbox-->
              <div class="pokedex__filter--type">
                <input type="checkbox" name="type" id="fighting" value="fighting">
                <label for="fighting" title="Fighting type">
                  <img src="${(0, $d5d3a3fb92434e02$export$df03f54e09e486fa).fighting}" alt="fighting" class="pokedex__filter--icon">
                </label>
              </div>

                 <!--Type filter checkbox-->
              <div class="pokedex__filter--type">
                <input type="checkbox" name="type" id="normal" value="normal">
                <label for="normal" title="Normal type">
                  <img src="${(0, $d5d3a3fb92434e02$export$df03f54e09e486fa).normal}" alt="normal" class="pokedex__filter--icon">
                </label>
              </div>

                <!--Type filter checkbox-->
              <div class="pokedex__filter--type">
                <input type="checkbox" name="type" id="fire" value="fire">
                <label for="fire" title="Fire type">
                  <img src="${(0, $d5d3a3fb92434e02$export$df03f54e09e486fa).fire}" alt="fire" class="pokedex__filter--icon">
                </label>
              </div>

                <!--Type filter checkbox-->
              <div class="pokedex__filter--type">
                <input type="checkbox" name="type" id="water" value="water">
                <label for="water" title="Water type">
                  <img src="${(0, $d5d3a3fb92434e02$export$df03f54e09e486fa).water}" alt="water" class="pokedex__filter--icon">
                </label>
              </div>

                <!--Type filter checkbox-->
              <div class="pokedex__filter--type">
                <input type="checkbox" name="type" id="electric" value="electric">
                <label for="electric" title="Electric type">
                  <img src="${(0, $d5d3a3fb92434e02$export$df03f54e09e486fa).electric}" alt="electric" class="pokedex__filter--icon">
                </label>
              </div>

                <!--Type filter checkbox-->
              <div class="pokedex__filter--type">
                <input type="checkbox" name="type" id="grass" value="grass">
                <label for="grass" title="Grass type">
                  <img src="${(0, $d5d3a3fb92434e02$export$df03f54e09e486fa).grass}" alt="grass" class="pokedex__filter--icon">
                </label>
              </div>

                <!--Type filter checkbox-->
              <div class="pokedex__filter--type">
                <input type="checkbox" name="type" id="ice" value="ice">
                <label for="ice" title="Ice type">
                  <img src="${(0, $d5d3a3fb92434e02$export$df03f54e09e486fa).ice}" alt="ice" class="pokedex__filter--icon">
                </label>
              </div>

                <!--Type filter checkbox-->
              <div class="pokedex__filter--type">
                <input type="checkbox" name="type" id="poison" value="poison">
                <label for="poison" title="Poison type">
                  <img src="${(0, $d5d3a3fb92434e02$export$df03f54e09e486fa).poison}" alt="poison" class="pokedex__filter--icon">
                </label>
              </div>

                <!--Type filter checkbox-->
              <div class="pokedex__filter--type">
                <input type="checkbox" name="type" id="ground" value="ground">
                <label for="ground" title="Ground type">
                  <img src="${(0, $d5d3a3fb92434e02$export$df03f54e09e486fa).ground}" alt="ground" class="pokedex__filter--icon">
                </label>
              </div>

                <!--Type filter checkbox-->
              <div class="pokedex__filter--type">
                <input type="checkbox" name="type" id="flying" value="flying">
                <label for="flying" title="Flying type">
                  <img src="${(0, $d5d3a3fb92434e02$export$df03f54e09e486fa).flying}" alt="flying" class="pokedex__filter--icon">
                </label>
              </div>

                <!--Type filter checkbox-->
              <div class="pokedex__filter--type">
                <input type="checkbox" name="type" id="psychic" value="psychic">
                <label for="psychic" title="Psychic type">
                  <img src="${(0, $d5d3a3fb92434e02$export$df03f54e09e486fa).psychic}" alt="psychic" class="pokedex__filter--icon">
                </label>
              </div>

                <!--Type filter checkbox-->
              <div class="pokedex__filter--type">
                <input type="checkbox" name="type" id="bug" value="bug">
                <label for="bug" title="Bug type">
                  <img src="${(0, $d5d3a3fb92434e02$export$df03f54e09e486fa).bug}" alt="bug" class="pokedex__filter--icon">
                </label>
              </div>

                <!--Type filter checkbox-->
              <div class="pokedex__filter--type">
                <input type="checkbox" name="type" id="rock" value="rock">
                <label for="rock" title="Rock type">
                  <img src="${(0, $d5d3a3fb92434e02$export$df03f54e09e486fa).rock}" alt="rock" class="pokedex__filter--icon">
                </label>
              </div>

                <!--Type filter checkbox-->
              <div class="pokedex__filter--type">
                <input type="checkbox" name="type" id="ghost" value="ghost">
                <label for="ghost" title="Ghosttype">
                  <img src="${(0, $d5d3a3fb92434e02$export$df03f54e09e486fa).ghost}" alt="ghost" class="pokedex__filter--icon">
                </label>
              </div>

                <!--Type filter checkbox-->
              <div class="pokedex__filter--type">
                <input type="checkbox" name="type" id="dragon" value="dragon">
                <label for="dragon" title="Dragon type">
                  <img src="${(0, $d5d3a3fb92434e02$export$df03f54e09e486fa).dragon}" alt="dragon" class="pokedex__filter--icon">
                </label>
              </div>

                <!--Type filter checkbox-->
              <div class="pokedex__filter--type">
                <input type="checkbox" name="type" id="dark" value="dark">
                <label for="dark" title="Dark type">
                  <img src="${(0, $d5d3a3fb92434e02$export$df03f54e09e486fa).dark}" alt="dark" class="pokedex__filter--icon">
                </label>
              </div>

                <!--Type filter checkbox-->
              <div class="pokedex__filter--type">
                <input type="checkbox" name="type" id="steel" value="steel">
                <label for="steel" title="Steel type">
                  <img src="${(0, $d5d3a3fb92434e02$export$df03f54e09e486fa).steel}" alt="steel" class="pokedex__filter--icon">
                </label>
              </div>

                <!--Type filter checkbox-->
              <div class="pokedex__filter--type">
                <input type="checkbox" name="type" id="fairy" value="fairy">
                <label for="fairy" title="Fairy type">
                  <img src="${(0, $d5d3a3fb92434e02$export$df03f54e09e486fa).fairy}" alt="fairy" class="pokedex__filter--icon">
                </label>
              </div>

<!-- END TYPES-->
              <button class="pokedex__filter--clear" id="clear-button">Clear</button>
            </div>



<!-- End Filter Component-->

<!-- Pokemon Grid Layout-->
            <div class="pokedex__grid">

            
<!--Pokemon Card-->
              ${gameModel.pokemon.map((pokemon)=>(0, $89cadda6d12330eb$export$c4222a73fc779a19)(pokemon)).join("")}
<!--END Pokemon Card-->
             

            </div>

            <!-- No Pokemon Message-->
            <div class="pokedex__empty hide">
              <img src="${(0, $d5d3a3fb92434e02$export$72d98a059df66e6b).snorlax}" alt="Snorlax Empty">
              <p class="play-information">No Pokemon Found. <br> Try Again.</p>
            </div>
          </div>
        </div>
      </section>
    
    
    `;
};





class $ff2f1f7904740e58$export$80150055db1935f7 {
    // _rawList;
    // _filteredList;
    // _filterParams;
    _filterCaught = false;
    _notFoundShowing = false;
    constructor(){
        this._filteredList = [];
        this._filterParams = [];
        this._rawList = [];
        this.container = document.querySelector("#game-container");
    }
    _initiateElements() {
        // Event trigger elements
        this._search = document.querySelector("form");
        this._searchField = document.querySelector(".pokedex__search");
        this._filterButtons = document.querySelectorAll('input[type="checkbox"]');
        this._clearFilter = document.querySelector("#clear-button");
        this._iniatePokedexCards();
        // Element Containers
        this._emptyDetails = document.querySelector(".pokemon-details__empty");
        this._pokemonDataContainer = document.querySelector(".pokemon-details__data");
        this._loading = document.querySelector(".pokemon-details__loading");
        this._gridContainer = document.querySelector(".pokedex__grid");
        this._notFoundContainer = document.querySelector(".pokedex__empty");
        this._detailsErrorMessage = document.querySelector("#details-error");
        //Event listeners
        this._search.addEventListener("submit", this._searchPokemon.bind(this));
        // this._searchField.addEventListener("keyup", this._searchPokemon.bind(this));
        this._filterButtons.forEach((filter)=>filter.addEventListener("change", this._triggerFilterPokemon.bind(this)));
        this._clearFilter.addEventListener("click", this._clearFilters.bind(this));
    }
    // After pokedex grid if filtered/cleared need to re-declare the cards & add the
    // event listener for showing the details card.
    _iniatePokedexCards() {
        this._pokemonCards = document.querySelectorAll(".pokemon-card");
        this._pokemonCards.forEach((card)=>card.addEventListener("click", this._showPokemonDetails.bind(this)));
    }
    async _searchPokemon(e) {
        e.preventDefault();
        const inputValue = this._searchField.value;
        if (!inputValue) return;
        console.log(`View search input: ${inputValue}`);
        try {
            const pokemon = await $f50bd1f2915ed0f2$export$5c29d29f679921b0(inputValue);
            this._searchField.value = "";
            //Should be refactored into own function (also used in showPokemonDetails)
            const html = (0, $f997397d1d081d02$export$d636f69f7916997b)(pokemon);
            //Hid/Show empty / details elements
            this._emptyDetails.classList.add("hide");
            this._pokemonDataContainer.classList.remove("hide");
            this._pokemonDataContainer.innerHTML = "";
            this._pokemonDataContainer.innerHTML = html;
        } catch (error) {
            const message = `${inputValue}... <br> not found. <br> Search Again!`;
            this._searchField.value = "";
            this._detailsErrorMessage.innerText = "";
            this._detailsErrorMessage.innerHTML = message;
            this._emptyDetails.classList.remove("hide");
            this._pokemonDataContainer.classList.add("hide");
        }
    /*
    For live filtered searches as user types:
    - Loop through list (raw, filter). Use string.substring() on each item. 
    - Check if input.value is same as list item.substrtinc(value.length)
    - Push to list variable.
    - Build pokemonCard elements from list. 
    - Render elements to DOM

    - Will live filtering of pokemoncards be too resource intensive. Need lodash (debounce or throttle)?

    */ }
    // Calls controller to get details from model (API) via target data-id
    // Renders data in details cards
    async _showPokemonDetails(e) {
        // Get Pokemon Details
        const pokeId = e.target.dataset?.id ?? e.target.parentElement.dataset.id;
        const details = await $f50bd1f2915ed0f2$export$5c29d29f679921b0(pokeId);
        //Hid/Show empty / details elements
        this._emptyDetails.classList.add("hide");
        this._pokemonDataContainer.classList.remove("hide");
        // Render the details via component in details container.
        const html = (0, $f997397d1d081d02$export$d636f69f7916997b)(details);
        this._pokemonDataContainer.innerHTML = "";
        this._pokemonDataContainer.innerHTML = html;
    }
    // Action for filtering pokemon (used on filterButtons)
    // Gets filter criteria and adds to filterList array.
    _triggerFilterPokemon(e) {
        const filterButton = e.target;
        filterButton.disabled = true; // in place so user HAS to use clear button.
        if (filterButton.value == "caught") this._filterCaught = true;
        else this._filterParams.push(filterButton.value);
        // Calls to compile all pokemon that match the filter
        this._compileFilteredList();
    }
    // Compiles pokemon from rawList that match filter criteria
    _compileFilteredList() {
        //Copies rawList to be maniupated wihout effecting rawList
        let results = [
            ...this._rawList
        ];
        //Condition whne there are no filter parameters
        if (this._filterParams.length > 0) results = this._rawList.filter((pokemon)=>{
            return pokemon.types.some((type)=>this._filterParams.includes(type));
        });
        //Condiiton when caught is true
        if (this._filterCaught) results = results.filter((pokemon)=>pokemon.caught);
        // Assings manipulated list to filteredList to use when rendering to DOM
        this._filteredList = results;
        this._renderFiltered();
    }
    //Renders filteredList to the DOM
    _renderFiltered() {
        console.log("RENDERING FILETERED!");
        // console.log(this._filteredList);
        // console.log(`_filteredList length: ${this._filteredList.length}`);
        // Control for if there is no filterable pokemon
        if (this._filteredList.length == 0) {
            this._toggleNotFound();
            return;
        }
        // Creates HTML to be instered via pokemonCard component.
        const html = this._filteredList.map((pokemon)=>(0, $89cadda6d12330eb$export$c4222a73fc779a19)(pokemon)).join("");
        // DOM updates
        this._gridContainer.innerHTML = "";
        this._gridContainer.innerHTML = html;
        // Reinitiates event listeners for pokemonCards
        this._iniatePokedexCards();
        // Acts as a catch if previous filter meets any of the controls in the function.
        this._toggleNotFound();
    }
    //Resets pokedex back to initiate DOM state.
    _reset() {
        //Rebuild pokemonCards from rawList in gameModel
        const html = this._rawList.map((pokemon)=>(0, $89cadda6d12330eb$export$c4222a73fc779a19)(pokemon)).join("");
        this._gridContainer.innerHTML = "";
        this._gridContainer.innerHTML = html;
        this._iniatePokedexCards();
        // Updates grid if notFound is showing.
        console.log("ToggleNotFound fired from _reset");
        this._toggleNotFound();
    }
    // Used as clearButton event.
    _clearFilters() {
        //Control state based off filterPArams and if filterCaught is true
        if (this._filterParams.length == 0 && !this._filterCaught) return;
        //Clears the properties of the filterButtons
        for (const input of this._filterButtons){
            input.disabled = false;
            input.checked = false;
        }
        //Triggers the reset.
        this._reset();
        //Clears any filter lists, params, or caught
        this._filteredList = [];
        this._filterParams = [];
        this._filterCaught = false;
    }
    // Controls showing and hiding not-found(Snorlaxx) element
    _toggleNotFound() {
        // Checks to see if snorlaxx is showing if it does not contain 'hide' then it is showing
        this._notFoundShowing = !this._notFoundContainer.classList.contains("hide");
        //Condition if showing (simple).
        if (this._notFoundShowing) {
            this._gridContainer.classList.remove("hide");
            this._notFoundContainer.classList.add("hide");
            return;
        }
        // Condition based on list length, showing, and filter params.
        if (this._filteredList.length == 0 && !this._notFoundShowing && this._filterParams.length >= 0) {
            this._gridContainer.classList.add("hide");
            this._notFoundContainer.classList.remove("hide");
        }
    }
    // Renders the initial DOM
    render(gameModel) {
        const html = (0, $dcdd4dc47fb91da1$export$8301f40aa4138471)(gameModel);
        this._rawList = [
            ...gameModel.pokemon
        ];
        this.container.innerHTML = html;
    // console.log("RAW LIST:");
    // console.log(this._rawList);
    }
}
var $ff2f1f7904740e58$export$2e2bcd8739ae039 /*

Psuedo Code:
Declare/Initiate Elements
Calling individual pokemon and rendering in data column


Create Component for:
filter Icons
Search bar

Notes: 
When grabbing pokemonList in model, does it make sense to determine caught status in
cardComponent instead. This way can push to local storage and not need to call and compare on /main.

Will need to determine best approach for re-initializing cards after filer/search.


10/13
IN PROGRESS:
- Basic filter working for capturing filter params & setting caught filter flag 
(_triggerFilterPokemon & _filterCaught = false).
- _compileFilterList function. uses .filer, .some, .include on rawList &
_fiterParams to compile type based filtering. 
- _compileFilterList has bug with filteringt for caught. 
- _renderFiltered() calling console.log for now. 

✅ BUG: 
- Need to create a function (model) that when user catches a pokemon
it updates the gameModel.pokemon to included updated caught pokemon.

TODO:
✅- Finish _renderFiltered with just type filter.
✅- Fix bug for caught and retest. 
✅- Build clearFilter function & reset function. 
- Search functionality
- Click and render pokemon details functionallity (evolution trickiest part)
- Show hide empty search (snorlax) function (toggle hide class)
- Loading feature

*/  = new $ff2f1f7904740e58$export$80150055db1935f7();



class $0290c99c0e335be3$export$3c43eca7ae3a5135 {
    constructor(){
        this.container = document.querySelector("#game-container");
    }
    render() {
        const html = `
        <div class="loading">
            <img src="${(0, $d5d3a3fb92434e02$export$9df96ab17a692a78).loading}" alt="Loading Image">
            <p class="play-information">Loading...</p>
        </div>
        `;
        this.container.innerHTML = "";
        this.container.innerHTML = html;
    }
}
var $0290c99c0e335be3$export$2e2bcd8739ae039 = new $0290c99c0e335be3$export$3c43eca7ae3a5135();



var $8EJWz = parcelRequire("8EJWz");

var $7238a34a955809b2$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7238a34a955809b2$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per GeneratorResume behavior specified since ES2015:
                // ES2015 spec, step 3: https://262.ecma-international.org/6.0/#sec-generatorresume
                // Latest spec, step 2: https://tc39.es/ecma262/#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next method, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable != null) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        throw new TypeError(typeof iterable + " is not iterable");
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, $7238a34a955809b2$exports));
try {
    regeneratorRuntime = $7238a34a955809b2$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $7238a34a955809b2$var$runtime;
    else Function("r", "regeneratorRuntime = r")($7238a34a955809b2$var$runtime);
}



const $0f1d4402dffacf5b$export$1153eb200e99c065 = {
    player: {
        name: null,
        avatar: "",
        difficulty: "",
        id: "",
        pokeballs: 3,
        answers: 0,
        caught: []
    },
    pokemon: [],
    allPlayers: [],
    limit: 252
};
function $0f1d4402dffacf5b$export$f4787878ccfd53f5(userObj) {
    // const { name, avatar, difficulty, id, caught, pokeballs, answers } = data;
    console.log("_updateActivePlayer, userObj passed");
    // console.log(userObj);
    $0f1d4402dffacf5b$export$1153eb200e99c065.player = userObj;
    console.log("UPDATE! \uD83D\uDDC3 Current Game Model");
}
function $0f1d4402dffacf5b$export$fd70bf79e65a3e2c(id) {
    const playerID = +id;
    console.log("setActivePlayer => to Current Game Model");
    //Finds index of player in allPlayers
    const playerIndex = $0f1d4402dffacf5b$export$1153eb200e99c065.allPlayers.findIndex((player)=>player.id === playerID);
    //Assigns selected player to variable
    const selectedPlayer = $0f1d4402dffacf5b$export$1153eb200e99c065.allPlayers[playerIndex];
    console.log("setActivePlayer, to selectedPlayer in gameModel");
    // Passes selected player to update gameModel
    $0f1d4402dffacf5b$export$f4787878ccfd53f5(selectedPlayer);
}
function $0f1d4402dffacf5b$export$d822e56153148f63(playerData) {
    const userID = playerData.id;
    const playerExistsInDB = $0f1d4402dffacf5b$export$1153eb200e99c065.allPlayers.find((player)=>player.id == userID);
    if (!playerExistsInDB) $0f1d4402dffacf5b$export$1153eb200e99c065.allPlayers.push(playerData);
    else {
        const playerIndex = $0f1d4402dffacf5b$export$1153eb200e99c065.allPlayers.findIndex((player)=>player.id == userID);
        console.log("Found Index: " + playerIndex);
        $0f1d4402dffacf5b$export$1153eb200e99c065.allPlayers[playerIndex] = playerData;
    }
    console.log("Updated gameModel. ");
    console.log("Updating Local Storage....");
    $0f1d4402dffacf5b$export$1fef91fbbef6ad9b();
}
function $0f1d4402dffacf5b$export$fce8332843b46c61() {
    //Check --> if first time, creates local storage.
    if (!localStorage.getItem("gameModel")) localStorage.setItem("gameModel", JSON.stringify($0f1d4402dffacf5b$export$1153eb200e99c065));
    const rawLocalStorageData = localStorage.getItem("gameModel");
    const localStorageData = JSON.parse(rawLocalStorageData);
    const pokemon = localStorageData.pokemon || [];
    const allPlayersData = localStorageData.allPlayers || [];
    $0f1d4402dffacf5b$export$1153eb200e99c065.pokemon = pokemon;
    $0f1d4402dffacf5b$export$1153eb200e99c065.allPlayers = allPlayersData;
}
function $0f1d4402dffacf5b$export$1fef91fbbef6ad9b() {
    const gameModelJSON = JSON.stringify($0f1d4402dffacf5b$export$1153eb200e99c065);
    localStorage.setItem("gameModel", gameModelJSON);
}
async function $0f1d4402dffacf5b$export$4744f9c5e82a404a() {
    const pokemonId = Math.floor(Math.random() * $0f1d4402dffacf5b$export$1153eb200e99c065.limit) + 1;
    try {
        const pokeRequest = await fetch(`https://pokeapi.co/api/v2/pokemon/${pokemonId}`);
        if (!pokeRequest.ok) throw new Error(`HTTP ${pokeRequest.status}: ${pokeRequest.statusText}`);
        const pokemon = await pokeRequest.json();
        return pokemon;
    } catch (error) {
        console.log(error);
        console.error(error);
    }
}
async function $0f1d4402dffacf5b$export$91a28542f71ead27() {
    if ($0f1d4402dffacf5b$export$1153eb200e99c065.pokemon.length == $0f1d4402dffacf5b$export$1153eb200e99c065.limit) // console.log("Pokemon already in gameModel");
    return;
    try {
        const request = await fetch(`https://pokeapi.co/api/v2/pokemon?limit=${$0f1d4402dffacf5b$export$1153eb200e99c065.limit}`);
        if (!request.ok) throw new Error(`Failed to fetch Pokemon List ${request.status}: ${request.statusText}`);
        const { results: list } = await request.json();
        // Individual Pokemon Promise/Fetch Loop
        const compilePokemonBasicDetails = list.map(async (pokemon)=>{
            try {
                const pokemonRaw = await fetch(pokemon.url);
                if (!pokemonRaw.ok) throw new Error(`HTTP ${pokemonRaw.status}`);
                const pokemonDetails = await pokemonRaw.json();
                return {
                    name: pokemonDetails.name[0].toUpperCase() + pokemonDetails.name.slice(1),
                    id: pokemonDetails.id,
                    sprite: pokemonDetails.sprites.front_default,
                    caught: $0f1d4402dffacf5b$export$1153eb200e99c065.player.caught.includes(pokemonDetails.name),
                    types: pokemonDetails.types.map((type)=>type.type.name)
                };
            } catch (error) {
                console.warn(`Failed to load ${pokemon.name}: ${error}`);
                return null;
            }
        });
        //End Individual Pokemon Promise/fetch loop
        const results = await Promise.all(compilePokemonBasicDetails);
        const pokemonList = results.filter((pokemon)=>pokemon !== null);
        $0f1d4402dffacf5b$export$1153eb200e99c065.pokemon = [
            ...pokemonList
        ];
        console.log("Get Basic Pokedex List Called");
        $0f1d4402dffacf5b$export$1fef91fbbef6ad9b();
    } catch (error) {
        console.log(error);
        console.error(`Uh-oh Something Happened: ${error} `);
    }
}
async function $0f1d4402dffacf5b$export$64973ac049d1814e() {
    for (const pokemon of $0f1d4402dffacf5b$export$1153eb200e99c065.pokemon)// console.log(`Updating: ${pokemon.name}`);
    pokemon.caught = $0f1d4402dffacf5b$export$1153eb200e99c065.player.caught.includes(pokemon.name);
    $0f1d4402dffacf5b$export$1fef91fbbef6ad9b();
}
async function $0f1d4402dffacf5b$export$bb2902664a21b78f(id) {
    try {
        const request = await fetch(`https://pokeapi.co/api/v2/pokemon/${id}`);
        if (!request.ok) throw new Error(`HTTP ${request.status}`);
        const rawDetails = await request.json();
        const formatName = rawDetails.name[0].toUpperCase() + rawDetails.name.slice(1);
        const pokemon = {
            name: formatName,
            id: (0, $20739f136d532ade$export$a5d5457d98639921)(rawDetails.id),
            // sprite: rawDetails.sprites.front_default,
            sprite: rawDetails.sprites.other.showdown.front_default,
            caught: $0f1d4402dffacf5b$export$1153eb200e99c065.player.caught.includes(formatName),
            types: rawDetails.types.map((type)=>type.type.name),
            abilities: rawDetails.abilities.map((ability)=>ability.ability.name).slice(0, 2),
            height: rawDetails.height,
            weight: rawDetails.weight,
            hp: rawDetails.stats[0].base_stat,
            speed: rawDetails.stats[5].base_stat,
            attack: rawDetails.stats[1].base_stat,
            attack_special: rawDetails.stats[3].base_stat,
            defense: rawDetails.stats[2].base_stat,
            defense_special: rawDetails.stats[4].base_stat
        };
        return pokemon;
    } catch (error) {
        console.error(error);
        throw error;
    }
} // PSUEDO CODE 9-3-25
 /*
-- ANY Page Load (not / or /continue or /singup)
  + Check player -> if name: null direct to /Continue page

-- New Signup:
  + Add player details to player
  + Add player to allPlayers. 
  + Update LocalStorage

-- Continue Page:
  + Pull allPlayers from LocalStorage
  + Loop over & create cards for UX
  + Selected Player pushed to Player property
  + Redirect to /Main. 
*/ 


async function $f50bd1f2915ed0f2$export$c08853eef7857581() {
    // console.log(model.gameModel);
    try {
        document.body.className = "home-page";
        await (0, $e62c72fc12a85f1f$export$2e2bcd8739ae039).render();
    } catch (error) {
        console.error(`Failed to load page: ${error}`);
    }
}
async function $f50bd1f2915ed0f2$export$39e43f811a0d6c63() {
    // console.log("showSignup -> Current gameModel:");
    // console.log(model.gameModel);
    try {
        document.body.className = "signup";
        //Renders Signuyp View
        await (0, $253d11dd669aa9e8$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$1153eb200e99c065);
        //After DOM Loaded, assigns elements and event listeners
        (0, $253d11dd669aa9e8$export$2e2bcd8739ae039)._initSignUpBehavior();
    } catch (error) {
        console.error(`Failed to load page: ${error}`);
    }
}
async function $f50bd1f2915ed0f2$export$8807bf9af653fcb1() {
    $0f1d4402dffacf5b$export$fce8332843b46c61();
    //Check if any saved players, if not direct to /signup.
    const hasPlayers = $0f1d4402dffacf5b$export$1153eb200e99c065.allPlayers.length > 0;
    if (!hasPlayers) (0, $3e27a66f4ef69c2e$export$2e2bcd8739ae039).navigateTo("/signup");
    // Render continue
    try {
        (0, $0290c99c0e335be3$export$2e2bcd8739ae039).render();
        document.body.className = "continue";
        await (0, $e7ec573de5a691d3$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$1153eb200e99c065);
        //After DOM Loaded initiate elements & event listeners
        (0, $e7ec573de5a691d3$export$2e2bcd8739ae039)._initContinueBehavior();
    } catch (error) {
        console.log(error);
        console.error(`Failed to load page: ${error}`);
    }
}
async function $f50bd1f2915ed0f2$export$b68f47d2740eda21() {
    // If no player route to /continue path.
    if (!$0f1d4402dffacf5b$export$1153eb200e99c065.player.name) (0, $3e27a66f4ef69c2e$export$2e2bcd8739ae039).navigateTo("/continue");
    try {
        (0, $0290c99c0e335be3$export$2e2bcd8739ae039).render();
        document.body.className = "main";
        await $0f1d4402dffacf5b$export$91a28542f71ead27();
        setTimeout(await (0, $807bda42778eb70b$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$1153eb200e99c065), 5000);
    } catch (error) {
        console.error(`Failed to load page: ${error}`);
    }
}
async function $f50bd1f2915ed0f2$export$44c0a083e75ef642() {
    // If no player route to /continue path.
    if (!$0f1d4402dffacf5b$export$1153eb200e99c065.player.name) {
        (0, $3e27a66f4ef69c2e$export$2e2bcd8739ae039).navigateTo("/continue");
        return;
    }
    try {
        (0, $0290c99c0e335be3$export$2e2bcd8739ae039).render();
        document.body.className = "math-game";
        //Generates initial questions for the learn Page
        const mathQuestions = (0, $8EJWz.generateMathQuestion)($0f1d4402dffacf5b$export$1153eb200e99c065.player);
        await (0, $97823873a87ace75$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$1153eb200e99c065, mathQuestions);
        //After DOM Load iniate elements & event listeners
        (0, $97823873a87ace75$export$2e2bcd8739ae039)._initiateElements();
    } catch (error) {
        console.log(error);
        console.error(`Failed to load page: ${error}`);
    }
}
async function $f50bd1f2915ed0f2$export$f7c3b936dbc22433() {
    // If no player route to /continue path.
    if (!$0f1d4402dffacf5b$export$1153eb200e99c065.player.name) {
        (0, $3e27a66f4ef69c2e$export$2e2bcd8739ae039).navigateTo("/continue");
        return;
    }
    try {
        (0, $0290c99c0e335be3$export$2e2bcd8739ae039).render();
        document.body.className = "explore-game";
        const pokemon = await $0f1d4402dffacf5b$export$4744f9c5e82a404a();
        // console.log(pokemon);
        await (0, $413df4bdc62cd07f$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$1153eb200e99c065, pokemon);
        (0, $413df4bdc62cd07f$export$2e2bcd8739ae039)._initiateElements();
    } catch (error) {
        console.log(error);
        console.error(`Failed to load page: ${error}`);
    }
}
async function $f50bd1f2915ed0f2$export$c3954f25ab777496() {
    // If no player route to /continue path.
    if (!$0f1d4402dffacf5b$export$1153eb200e99c065.player.name) {
        (0, $3e27a66f4ef69c2e$export$2e2bcd8739ae039).navigateTo("/continue");
        return;
    }
    try {
        (0, $0290c99c0e335be3$export$2e2bcd8739ae039).render();
        document.body.className = "pokedex-view";
        await $0f1d4402dffacf5b$export$64973ac049d1814e();
        await (0, $ff2f1f7904740e58$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$1153eb200e99c065);
        (0, $ff2f1f7904740e58$export$2e2bcd8739ae039)._initiateElements();
    } catch (error) {
        console.log(error);
        console.error(`Failed to load page: ${error}`);
    }
}
function $f50bd1f2915ed0f2$export$678fa6c2b4075189(playerData) {
    console.log("New Signup Passed to Controller");
    $0f1d4402dffacf5b$export$f4787878ccfd53f5(playerData);
    $0f1d4402dffacf5b$export$d822e56153148f63(playerData);
    // console.log("Current Game Model:");
    // console.log(model.gameModel);
    localStorage.setItem("gameModel", JSON.stringify($0f1d4402dffacf5b$export$1153eb200e99c065));
    (0, $3e27a66f4ef69c2e$export$2e2bcd8739ae039).navigateTo("/main");
}
function $f50bd1f2915ed0f2$export$9261e82cb75ec79f(id) {
    $0f1d4402dffacf5b$export$fd70bf79e65a3e2c(id);
    (0, $3e27a66f4ef69c2e$export$2e2bcd8739ae039).navigateTo("/main");
}
function $f50bd1f2915ed0f2$export$96047dc32e37089e() {
    return $0f1d4402dffacf5b$export$1153eb200e99c065;
}
function $f50bd1f2915ed0f2$export$a955988b42e8709c(playerObj) {
    $0f1d4402dffacf5b$export$f4787878ccfd53f5(playerObj);
    $0f1d4402dffacf5b$export$d822e56153148f63(playerObj);
}
function $f50bd1f2915ed0f2$export$104277515a263bd7() {
    // This probably could be handled in the learView, but since it requires passing in the gameModel I want to keep it in the controller & avoid storing/mutating the gameModel in the view.
    const newQuestions = (0, $8EJWz.generateMathQuestion)($0f1d4402dffacf5b$export$1153eb200e99c065.player);
    return newQuestions;
}
async function $f50bd1f2915ed0f2$export$9af4bf1b8bed8250() {
    const pokemon = await $0f1d4402dffacf5b$export$4744f9c5e82a404a();
    return pokemon;
}
async function $f50bd1f2915ed0f2$export$5c29d29f679921b0(id) {
    const details = await $0f1d4402dffacf5b$export$bb2902664a21b78f(id);
    return details;
}
// Strictly for navigation from controller. Should not be used anywhere else.
function $f50bd1f2915ed0f2$var$setupGlobalNavigation() {
    document.addEventListener("click", (e)=>{
        if (e.target.matches("[data-nav]") || e.target.parentElement.matches("[data-nav]")) {
            e.preventDefault();
            const path = e.target.getAttribute("data-nav") ?? e.target.parentElement.getAttribute("data-nav");
            (0, $3e27a66f4ef69c2e$export$2e2bcd8739ae039).navigateTo(path);
        }
    });
}
function $f50bd1f2915ed0f2$var$checkScreenSize() {
    const min_width = 1180;
    let resizeTimer;
    const warningDialog = document.querySelector(".width-warning");
    const viewWidth = document.querySelector(".width-warning__width");
    function showWarning() {
        const screen_size = window.innerWidth;
        if (screen_size < min_width) {
            viewWidth.textContent = `${screen_size}px`;
            warningDialog.showModal();
            //Force reflow for iOS
            if (warningDialog.open) warningDialog.offsetHeight; //hacky for trigger reflow.
        } else warningDialog.close();
    }
    //Initial trigger for showing widthWarning.
    document.addEventListener("DOMContentLoaded", showWarning);
    window.addEventListener("resize", ()=>{
        //Basic Debounce method
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(showWarning, 250);
    });
    //Specific listner for iOs (coverage for "resize")
    window.addEventListener("orientationchange", ()=>{
        //Basic Debounce method
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(()=>{
            showWarning();
            //Extra reflow trigger for iOS.
            if (warningDialog.open) {
                warningDialog.style.display = "none";
                warningDialog.offsetHeight;
                warningDialog.style.display = "";
            }
        }, 300);
    });
}
function $f50bd1f2915ed0f2$var$toggleFullScreen(e) {
    const gameScreen = document.querySelector("body");
    const isInFullScreen = document.fullscreenElement !== null;
    const toggleIcon = document.querySelector(".fullscreen-mode__icon");
    const toggleAction = e.target.dataset.action == "toggle-fullscreen";
    if (toggleAction) {
        gameScreen.requestFullscreen();
        toggleIcon.src = `${(0, $d5d3a3fb92434e02$export$df03f54e09e486fa).normalscreen}`;
    }
    if (toggleAction && isInFullScreen) {
        document.exitFullscreen();
        toggleIcon.src = `${(0, $d5d3a3fb92434e02$export$df03f54e09e486fa).fullscreen}`;
    }
}
document.addEventListener("click", $f50bd1f2915ed0f2$var$toggleFullScreen);
function $f50bd1f2915ed0f2$var$init() {
    (0, $3e27a66f4ef69c2e$export$2e2bcd8739ae039).init();
    $f50bd1f2915ed0f2$var$setupGlobalNavigation();
    $f50bd1f2915ed0f2$var$checkScreenSize();
}
$f50bd1f2915ed0f2$var$init();


//# sourceMappingURL=index.fe50e24f.js.map
